//ScreensHomeForm

//IMPORTS
// #region IMPORTS
import React, { Component } from "react";
import { ComponentsPedidoFiltroForm } from "../components/Filtro/PedidoFiltro";
import { DataView } from "primereact/dataview";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Panel } from "primereact/panel";
import { PedidoPortalService } from "../service/PedidoPortal";
import { Paginator } from "primereact/paginator";
import axios from "axios";
import { ServiceLogin } from "../service/Login";
import moment from "moment/min/moment-with-locales";
import print from 'print-js';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { ServiceApi } from "../service/Api";
import { MedicoService } from '../service/Medico'
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputMask } from 'primereact/inputmask';
import { GaleriaImagens } from "../screens/Imagens/GaleriaImagens";
import { GaleriaExternos } from "../screens/Imagens/GaleriaExternos";
import { HistoricoAceiteLGPD } from "../service/HistoricoAceiteLGPD";
import { listarJob, BuscarImagensLista } from "../service/ServiceJob";
import './DataTableDemo.css';
import { GaleriaServices } from "../service/GaleriaServices";
import { ComponentsAppSplash } from "../components/App/Splash";
import { Menu } from 'primereact/menu';
import 'primereact/resources/themes/saga-blue/theme.css';
import { Calendar } from 'primereact/calendar';
import { SplitButton } from 'primereact/splitbutton';
import ModalMensagem from '../components/Avisos/ModalMensagem';
import imgErro from '../images/Icons/error-svgrepo-com.svg'; // ou qualquer outra imagem de erro
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import JSZip from 'jszip';
import { AutoComplete } from 'primereact/autocomplete';
import md5 from 'md5';
import { InputSwitch } from 'primereact/inputswitch';
import { CameraCapture } from '../components/CameraCapture/CameraCapture';

//images
import calendar from '../images/Icons/calendar.svg';
import calendarWhite from '../images/Icons/calendar-white.svg';
import hospital from '../images/Icons/lucide_hospital.svg';
import doctor from '../images/Icons/hugeicons_doctor.svg';
import downloadImg from '../images/Icons/Download-image.svg';
import downloadDicomZip from '../images/Icons/Icone-DicomZip.svg';
import keyImg from '../images/Icons/key.svg';



import share from '../images/Icons/Share-icon.svg';
import printIcon from '../images/Icons/Print-icon.svg';
import imagedashboard from '../images/Icons/mage_dashboard.svg';
import iconeExamesExternos from '../images/Icons/icone-exames-externos.svg';
import iconeExamesExternosBranco from '../images/Icons/icone-exames-externos-branco.svg';
import icoDowndloadBranco from '../images/Icons/icone-download-image-branco.svg';
import icoPdfBranco from '../images/Icons/icone-pdf-branco.svg';
import icoCompartilharBranco from '../images/Icons/icone-compartilhar-branco.svg';
import icoImpressoraBranco from '../images/Icons/icone-impressora-branco.svg';
import icoBaixarZip from '../images/Icons/Icone-baixar-zip.svg';
import iconeProntuario from '../images/Icons/iconeProntuario.svg';
import iconeAmpulheta from '../images/Icons/icone-ampulheta.svg';
import iconeCorreto from '../images/Icons/icone-correto.svg';
import { ServiceConfig } from './../service/Config';

import viewerIcon_principal from "../images/Icons/icone-viewer-branco.svg";
import galeryIcon_principal from "../images/Icons/image_dashboard_white.svg";

import viewerIcon_secundario from "../images/Icons/icone-viewer-azul.svg";
import galeryIcon_secundario from "../images/Icons/mage_dashboard.svg";

var createReactClass = require("create-react-class");



// #endregion

// CONSTS
// #region CONSTS
let cntPgr = 0;
let pgrBarCont = null;

const pedidoFiltro = {
    Prontuario: null,
    PacienteId: 0,
    PacienteNome: '',
    AcNumber: '',
    Prontuario: '',
    DataInicial: '',
    DataFinal: '',
    Modalidades: [],
    //Unidades:[{Id : 1,Nome : '',}, {Id : 2,Nome : '',},{Id : 3,Nome : '',}],
    Unidades: [],
    PageIndex: 0,
    PageCount: 5,
    Revisado: null,
    Sort: null,
    MedicoSolicitanteFiltro: null,
    MedicoExecutanteFiltro: null,
    ConvenioId: 0
};

const listPrazo = [
    { label: '8h', value: '8' },
    { label: '12h', value: '12' },
    { label: '24h', value: '24' },
    { label: '48h', value: '48' }
];

// fora da classe, no topo do arquivo (recomendado)
const periodoOptions = [
    { label: 'Personalizado', value: 'personalizado' },
    { label: 'Últimos 30 dias', value: 'ultimos30' },
    { label: 'Últimos 90 dias', value: 'ultimos90' }
];

// Auto Heigth
const autoHeigth =
{
    height: (window.innerHeight - 100) + 'px'
};

const autoHeigthLista =
{
    textAlign: "left",
};

const dataAtual = new Date();

const viewerAccessKey = sessionStorage.getItem('viewerAccessKey') + "=";
axios.interceptors.request.use((config) => {
    if (config.url.includes("studies")) {
        if (viewerAccessKey)
            config.headers.Authorization = `Basic ${viewerAccessKey}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// #endregion

// UTILS
// #region UTILS
const getAttrs = (object, tagName) => {
    var doc = document.createElement("div");
    doc.innerHTML = object;

    const item = doc.getElementsByTagName(tagName)[0];
    return [].slice.call(item.attributes).reduce((attrs, element) => {
        attrs[element.name] = element.value;
        return attrs;
    }, {});
};


// #endregion

//COMPONENTS AUXILIARES
//#region COMPONENTS AUXILIARES
const ComponentIframe = createReactClass({
    render: function () {
        return (
            <div style={{ height: "75vh" }}>
                <iframe {...getAttrs(this.props.iframe, "iframe")} />
            </div>
        );
    }
});

const ComponentEmbed = createReactClass({
    render: function () {
        return (
            <div style={autoHeigth}>
                <embed key={this.props.id} {...getAttrs(this.props.embed, "embed")} />
            </div>
        );
    }
});


// #endregion

//METHODS
//#region METHODS

//Barra de progresso de Download
function updateProgress(oEvent) {
    clearInterval(pgrBarCont);
    if (oEvent.lengthComputable) {
        var percentComplete = oEvent.loaded / oEvent.total;
        percentComplete = (percentComplete * 100) + '%';
        let elProgresBar = document.getElementById("pgrBar");
        elProgresBar.setAttribute("style", "display:block; width:" + percentComplete);
    }
}
function transferComplete(evt) {
    clearInterval(pgrBarCont);
    viewPgr("none");
}
function transferFailed(evt) {
    clearInterval(pgrBarCont);
    viewPgr("none");
    alert("Um erro ocorreu durante o download do arquivo.");
}
function viewPgr(value) {
    let elProgresBar = document.getElementById("pgrBar");
    elProgresBar.setAttribute("style", "display:" + value + ";");
}
function viewPgrContinuous() {
    cntPgr++;
    if (cntPgr == 101) { cntPgr = 0; }
    let percentComplete = cntPgr + '';
    let elProgresBar = document.getElementById("pgrBar");
    elProgresBar.setAttribute("style", "display:block; width:" + percentComplete);
}
//Fim barra de progresso de Download


//#endregion


class ScreensHomeForm extends Component {

    //CONSTRUCTOR
    //#region CONSTRUCTOR
    constructor() {
        super();

        const auth = JSON.parse(sessionStorage.getItem("auth") || "{}");
        const isAcessoCompartilhado = !!auth.TokenPortal;

        this.tipoCompartilhamento = [{ name: ' WhatsApp', key: 0 }, { name: ' Email', key: 1 }];

        this.state = {
            paciente: "",
            totalPedidos: 0,
            pedidos: [],
            pedidosExternos: [],
            pedidosCombinados: [],
            layout: "list",
            selectedPedido: null,
            visible: false,
            sortKey: null,
            sortOrder: null,
            sort: null,
            rows: 5,
            first: 0,
            Total: 0,
            TotalPedidosExternos: 0,
            panelImageVisible: false,
            panelImageJpegVisible: false,
            panelVisible: false,
            panelLaudoVisible: false,
            panelAnexoVisible: false,
            imagensVinculadas: [],
            caminhoServico: "",
            servicoImagemPortal: "",
            popupImagem: null,
            isMedico: false,
            isExecutante: false,
            emailCompartilhar: "",
            celCompartilhar: "",
            prazoValue: '8',
            pacienteId: 0,
            visibleDialog: false,
            componentImagens: "",
            visibleDialogComentario: false,
            isMobile: false,
            isFullScreen: false,
            modalConfirmaImpressao: false,
            modalImagemOutroPedido: false,
            modalAnexo: false,
            listaAnexos: null,
            Viewer: "",
            viewerSrc: null,
            onPositionScroll: false,
            possuiJob: false,
            filtroSelecionado: { label: 'Mais recentes', value: 'recentes' },
            mostrarFiltro: false,
            periodoSelecionado: 'ultimos30',
            dataFinal: dataAtual,
            dataInicial: (() => {
                const date = new Date();
                date.setDate(date.getDate() - 30);
                return date;
            })(),
            modalidadeSelecionada: [],
            nomeExame: '',
            girando: false,
            dataInicialInvalida: false,
            dataFinalInvalida: false,
            modalErroVisivel: false,
            mensagemErro: '', // mensagem que vai aparecer na modal
            imagemPreviewUrl: null,
            imagemCarregada: false,
            baixandoDicomZip: false,
            dialogDicomZip: false,
            progressoDicomZip: 0,
            isMobile: window.innerWidth < 850,
            procedimentoSelecionadoId: null,

            //USUARIO
            usuariologado: 0,

            // itens do pedido selecionado antes de abrir a modal de imagem em outro pedido
            pedidoComImagemVinculadaMedicoExecutante: {},
            pedidoComImagemVinculadaMedicoRevisor: {},
            pedidoComImagemVinculadaId: null,

            //Parecer médico
            listaParecer: [],
            parecerId: 0,
            parecerTexto: "",
            parecerDataCadastro: null,
            parecerPrioridade: 0,
            UsuarioId: 0,
            parecerCarregado: false,

            //Exames externos:
            pesquisarExamesExternos: isAcessoCompartilhado ? false : true,
            modalExamesExternosVisivel: false,
            descricaoExame: '',
            localExameExterno: '',
            dataExameExterno: '',
            medicoSolicitanteExameExterno: '',
            crmMedicoSolicitanteExameExterno: '',
            arquivosSelecionados: [],
            pacienteId: '',
            erroCamposObrigatorios: false,
            erroArquivos: false,
            arquivosEnviadosViaUpload: false,
            zipDicom: null,
            caminhopastaDicomExameExterno: '',
            zipandoDicom: false,
            resultadoInclusaoVisivel: false,
            resultadoInclusaoMensagem: '',
            resultadoInclusaoTipo: 'sucesso', // ou 'erro'
            arquivosSelecionados: [],
            procedimentosSugeridos: [],
            arquivosDialogOpen: false,
            pedidoSelecionadoArquivos: null,
            anexosDoPedido: [],
            exibirbotoesmodal: true,


            //Modal
            modalOpcoesVisivel: false,
            pedidoModalOpcoes: null,
            modalOpcaoSelecionada: null,
            laudoCarregando: false,
            formaEnvio: 'whatsapp',
            validadeSelecionada: '8h',
            existeAnexo: false,
            validades: [
                { name: '8 horas', value: '8h' },
                { name: '24 horas', value: '24h' },
                { name: '72 horas', value: '72h' },
            ],

            mostrarModalAcoesMobile: false,

            selectedCompartilhamento: this.tipoCompartilhamento[0],

            isAcessoCompartilhado,

            isLoading: true,

            //Configuracoes
                // Labels
            labelBotaoViewer: "",
            labelBotaoGaleria: "",
            labelBotaoBaixarDicom: "",
            labelBotaoLaudo: "",
            labelBotaoImprimirLaudo: "",
            labelBotaoBaixarLaudoPdf: "",
            labelBotaoAnexos: "",
            labelBotaoParecer: "",
            labelInfoAcNumber: "",
            labelInfoUnidade: "",
            labelInfoData: "",
            labelInfoMedSolicitante: "",
            labelInfoMedExecutante: "",
            labelInfoMedRevisor: "",
            labelBotaoCompartilhar: "",
            lblbtnDownloadVisualizador: '',
            lblbtnDownloadDicomZip: '',

            // Status Labels
            labelStatusProcessamentoPaciente: "",
            labelStatusAguardandoPaciente: "",
            labelStatusLiberadoPaciente: "",

            labelStatusProcessamentoMedico: "",
            labelStatusAguardandoMedico: "",
            labelStatusLiberadoMedico: "",

            // Paciente - Botoes
            botaoViewerAtivoPaciente: false,
            botaoGaleriaAtivoPaciente: false,
            botaoBaixarImagensAtivoPaciente: false,
            botaoLaudoAtivoPaciente: false,
            botaoImprimirLaudoAtivoPaciente: false,
            botaoCompartilharAtivoPaciente: false,
            botaoAnexosAtivoPaciente: false,
            acaoBaixarImagens_visualizador_Paciente: false,
            acaoBaixarImagens_dicomZip_Paciente: false,

            // Paciente - Infos
            infoAcNumberAtivoPaciente: false,
            infoProntuarioAtivoPaciente: false,
            infoDataAtivoPaciente: false,
            infoUnidadeAtivoPaciente: false,
            infoMedSolicitanteAtivoPaciente: false,
            infoMedExecutanteAtivoPaciente: false,
            infoMedRevisorAtivoPaciente: false,

            // Paciente - Acoes
            acaoPrincipalBotaoImagensPaciente: "",
            acaoPrincipalThumbnailImagensPaciente: "",
            statusAtivoPaciente: false,

            //PacienteExamesExternos
            botaoIncluirExamesAtivoPaciente: false,
            habilitarEnvioDicomExamesExternos: false,

            // Médico - Botoes
            botaoViewerAtivoMedico: false,
            botaoGaleriaAtivoMedico: false,
            botaoBaixarImagensAtivoMedico: false,
            botaoLaudoAtivoMedico: false,
            botaoImprimirLaudoAtivoMedico: false,
            botaoCompartilharAtivoMedico: false,
            botaoAnexosAtivoMedico: false,
            botaoParecerAtivoMedico: false,
            botaoIncluirExamesAtivoMedico: false,

            acaoBaixarImagens_visualizador_Medico: false,
            acaoBaixarImagens_dicomZip_Medico: false,

            // Médico - Infos
            infoAcNumberAtivoMedico: false,
            infoProntuarioAtivoMedico: false,
            infoDataAtivoMedico: false,
            infoUnidadeAtivoMedico: false,
            infoMedSolicitanteAtivoMedico: false,
            infoMedExecutanteAtivoMedico: false,
            infoMedRevisorAtivoMedico: false,

            // Médico - Acoes
            acaoPrincipalBotaoImagensMedico: "",
            acaoPrincipalThumbnailImagensMedico: "",
            statusAtivoMedico: false,

            // Geral
            tempoInatividade: "30m",
            pesquisa_Inicial_Exames_Paciente: "Fixo",
            exibir_apenas_pedidos_revisados_portal: false,
            //

            pedidoSelecionadoAtual: '',

            configDB: '',

        };

        this.galeriaServices = new GaleriaServices();
        this.pedidoservice = new PedidoPortalService();
        this.itemTemplate = this.itemTemplate.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.pedidoSelecionado = 0;

        this.inputPastaRef = React.createRef();
        this.handleSelecionarPastaDicom = this.handleSelecionarPastaDicom.bind(this);
        this.handleClickSelecionarPastaDicom = this.handleClickSelecionarPastaDicom.bind(this);

        this.menuRef = React.createRef();

        this.itensMenu = [
            {
                label: 'Mais recentes',
                command: () => this.setFiltro({ label: 'Mais recentes', value: 'recentes' })
            },
            {
                label: 'Mais antigos',
                command: () => this.setFiltro({ label: 'Mais antigos', value: 'antigos' })
            },
            {
                label: 'Procedimento',
                command: () => this.setFiltro({ label: 'Procedimento', value: 'procedimento' })
            }
        ];

        this.menuFiltroRef = React.createRef();

        this.setFiltro = (filtro) => {
            this.setState({ 
                filtroSelecionado: filtro,
                sort: filtro.value,
            });
            this.handleBuscarClick();
        };

        this.FiltroDropdown = () => {
            return (
                <div className="relative inline-block">
                    <Button
                        className="btn-sorter"
                        label={this.state.filtroSelecionado.label}
                        icon="pi pi-chevron-down"
                        iconPos="right"
                        onClick={(e) => this.menuFiltroRef.current.toggle(e)}
                    />
                    <Menu className="results-header__sort-menu" model={this.itensMenu} popup ref={this.menuFiltroRef} />
                </div>
            );
        };
    }


    //#endregion

    //COMPONENT_DID_MOUNT
    //#region COMPONENT_DID_MOUNT
    componentDidMount() {

        const historicoAceiteLGPD = new HistoricoAceiteLGPD();
        historicoAceiteLGPD.ChecarAceiteLGPD();
        const auth = JSON.parse(sessionStorage.getItem("auth"));
        const isAcessoCompartilhado = !!auth.TokenPortal;
        this.setState({
            isMedico: ServiceLogin.isMedico(),
            isExecutante: ServiceLogin.isExecutante(),
            isConvenio: ServiceLogin.isConvenio(),
            UsuarioId: ServiceLogin.getUserId(),
            UsuarioNome: ServiceLogin.getUserName(),
            isAcessoCompartilhado,
            pesquisarExamesExternos: isAcessoCompartilhado ? false : this.state.pesquisarExamesExternos,
            mostrarFiltro: isAcessoCompartilhado ? false : this.state.mostrarFiltro,
            panelImageMaximizeOn: false
        });

        this.setState({
            isExecutante: ServiceLogin.isExecutante(),
        });

        this._getUrl().then(url => this.setState({ caminhoServico: url }));

        this.atualizarZoomPDF();
        window.addEventListener('resize', this.atualizarZoomPDF);

        window.addEventListener("resize", this.handleResize);

        this.getConfig();

        //Filtrar pela Data Atual        
        let ano = new Date().getFullYear();
        let mes = new Date().getMonth() + 1;
        let dia = new Date().getDate();

        const dataAtual = moment(`${ano.toString()}-${mes.toString()}-${dia.toString()}`, "YYYY/MM/DD").format();
        let dataInicial = dataAtual;

        if (!ServiceLogin.isMedico()) {
            dataInicial = moment(`${"0"}-${mes.toString()}-${dia.toString()}`, "YYYY/MM/DD").format();

            ServiceLogin.isConvenio() ? pedidoFiltro.ConvenioId = ServiceLogin.getConvenioId() : pedidoFiltro.PacienteId = ServiceLogin.getUserId();
        }

        pedidoFiltro.DataInicial = dataInicial;
        pedidoFiltro.DataFinal = dataAtual;

        //if (window.globalVars.acessoMedicoSolicitante === true) {
        if (sessionStorage.getItem("perfil") === "Solicitante") {
            pedidoFiltro.MedicoSolicitanteFiltro = { Id: ServiceLogin.getMedicoSolicitanteId() };
        }

        if (sessionStorage.getItem("perfil") === "Executante") {
            pedidoFiltro.Unidades = ServiceLogin.getUnidadesMedicoExecutante()
        }

        if (auth.MedicoExecutanteFixo) {
            pedidoFiltro.Unidades = ServiceLogin.getUnidadesMedicoExecutante()
        }

        // setTimeout(() => {
        //     this.DesabilitarBtnImagem(this.state.pedidos[0], false)
        //         .then((result) => {
        //             this.setState({ btnImageDisable: result, isLoading: false });
        //         })
        //         .catch((error) => {
        //             console.error("Erro ao desabilitar botão:", error);
        //             this.setState({ btnImageDisable: true, isLoading: false }); // Default caso ocorra erro
        //         });
        // }, 1000);

        if (!sessionStorage.getItem("refreshOnce")) {
            try {
                sessionStorage.setItem("refreshOnce", "true");
            } catch { }
            setTimeout(() => window.location.reload(), 200);
        } else {
            sessionStorage.removeItem("refreshOnce");
        }

        setTimeout(() => {
            this.alterarLayout();
        }, 500);
    }
    //#endregion

    getConfig() {
        try {
            this.serviceConfig = new ServiceConfig();

            this.serviceConfig.GetConfig()
                .then(res => {
                    console.log("Resposta bruta:", res);

                    let arr = [];

                    if (Array.isArray(res.data)) {
                        arr = res.data;
                    } else if (Array.isArray(res)) {
                        arr = res;
                    } else if (typeof res.data === "string") {
                        arr = JSON.parse(res.data);
                    } else if (typeof res === "string") {
                        arr = JSON.parse(res);
                    } else {
                        console.error("Formato inesperado de resposta:", res);
                        return;
                    }

                    const config = {};
                    arr.forEach(item => {
                        config[item.Key] = {
                            id: item.Id,
                            value: item.Value
                        };
                    });

                    console.log("Config mapeada:", config);

                    this.setState({
                        configDB: config,

                        // Labels
                        labelBotaoViewer: config['LABEL_BOTAO_VIEWER_PORTAL']?.value || '',
                        labelBotaoGaleria: config['LABEL_BOTAO_GALERIA_PORTAL']?.value || '',
                        labelBotaoBaixarDicom: config['LABEL_BOTAO_BAIXAR_DICOM_PORTAL']?.value || '',
                        labelBotaoLaudo: config["LABEL_BOTAO_LAUDO_PORTAL"]?.value || '',
                        labelBotaoImprimirLaudo: config["LABEL_BOTAO_IMPRIMIR_LAUDO_PORTAL"]?.value || '',
                        labelBotaoBaixarLaudoPdf: config["LABEL_BOTAO_BAIXAR_LAUDO_PDF_PORTAL"]?.value || '',
                        labelBotaoAnexos: config["LABEL_BOTAO_VISUALIZAR_ANEXOS_PORTAL"]?.value || '',
                        labelBotaoParecer: config["LABEL_BOTAO_VISUALIZAR_PARECER_PORTAL"]?.value || '',
                        labelInfoAcNumber: config["LABEL_INFO_ACENUMBER_PORTAL"]?.value || '',
                        labelInfoUnidade: config["LABEL_INFO_UNIDADE_PORTAL"]?.value || '',
                        labelInfoData: config["LABEL_INFO_DATA_PORTAL"]?.value || '',
                        labelInfoMedSolicitante: config["LABEL_INFO_MEDICO_SOLICITANTE_PORTAL"]?.value || '',
                        labelInfoMedExecutante: config["LABEL_INFO_MEDICO_EXECUTANTE_PORTAL"]?.value || '',
                        labelInfoMedRevisor: config["LABEL_INFO_MEDICO_REVISOR_PORTAL"]?.value || '',
                        labelBotaoCompartilhar: config['LABEL_BOTAO_COMPARTILHAR_PORTAL']?.value || '',
                        lblbtnDownloadVisualizador: config['LABEL_BOTAO_BAIXAR_VISUALIZADOR']?.value || '',
                        lblbtnDownloadDicomZip: config['LABEL_BOTAO_BAIXAR_ZIP']?.value || '',    

                        // Status labels
                        labelStatusProcessamentoPaciente: config["LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL"]?.value || '',
                        labelStatusAguardandoPaciente: config["LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL"]?.value || '',
                        labelStatusLiberadoPaciente: config["LABEL_STATUS_LIBERADO_PACIENTE_PORTAL"]?.value || '',
                        labelStatusProcessamentoMedico: config["LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL"]?.value || '',
                        labelStatusAguardandoMedico: config["LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL"]?.value || '',
                        labelStatusLiberadoMedico: config["LABEL_STATUS_LIBERADO_MEDICO_PORTAL"]?.value || '',

                        // Paciente - botoes
                        botaoViewerAtivoPaciente: config["BOTAO_VIEWER_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoGaleriaAtivoPaciente: config["BOTAO_GALERIA_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoBaixarImagensAtivoPaciente: config["BOTAO_BAIXAR_IMAGENS_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoLaudoAtivoPaciente: config["BOTAO_LAUDO_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoImprimirLaudoAtivoPaciente: config["BOTAO_IMPRIMIR_LAUDO_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoCompartilharAtivoPaciente: config["BOTAO_COMPARTILHAR_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoAnexosAtivoPaciente: config["BOTAO_ANEXOS_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        botaoIncluirExamesAtivoPaciente: config["BOTAO_INCLUIR_EXAMES_ATIVO_PACIENTE_PORTAL"]?.value === 'true',

                        acaoBaixarImagens_visualizador_Paciente: config['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_PACIENTE']?.value === 'true',
                        acaoBaixarImagens_dicomZip_Paciente: config['ACAO_BAIXAR_IMAGENS_ZIP_PACIENTE']?.value === 'true',

                        // Paciente - infos
                        infoAcNumberAtivoPaciente: config["INFO_ACNUMBER_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        infoProntuarioAtivoPaciente: config["INFO_PRONTUARIO_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        infoDataAtivoPaciente: config["INFO_DATA_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        infoUnidadeAtivoPaciente: config["INFO_UNIDADE_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        infoMedSolicitanteAtivoPaciente: config["INFO_MED_SOLICITANTE_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        infoMedExecutanteAtivoPaciente: config["INFO_MED_EXECUTANTE_ATIVO_PACIENTE_PORTAL"]?.value === 'true',
                        infoMedRevisorAtivoPaciente: config["INFO_MED_REVISOR_ATIVO_PACIENTE_PORTAL"]?.value === 'true',

                        // Paciente - acoes
                        acaoPrincipalBotaoImagensPaciente: config["ACAO_PRINCIPAL_BOTAO_IMAGENS_PACIENTE_PORTAL"]?.value || '',
                        acaoPrincipalThumbnailImagensPaciente: config["ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_PACIENTE_PORTAL"]?.value || '',
                        statusAtivoPaciente: config["STATUS_ATIVO_PACIENTE_PORTAL"]?.value === 'true',

                        // Medico - botoes
                        botaoViewerAtivoMedico: config["BOTAO_VIEWER_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoGaleriaAtivoMedico: config["BOTAO_GALERIA_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoBaixarImagensAtivoMedico: config["BOTAO_BAIXAR_IMAGENS_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoLaudoAtivoMedico: config["BOTAO_LAUDO_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoImprimirLaudoAtivoMedico: config["BOTAO_IMPRIMIR_LAUDO_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoCompartilharAtivoMedico: config["BOTAO_COMPARTILHAR_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoAnexosAtivoMedico: config["BOTAO_ANEXOS_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoParecerAtivoMedico: config["BOTAO_PARECER_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        botaoIncluirExamesAtivoMedico: config["BOTAO_INCLUIR_EXAMES_ATIVO_MEDICO_PORTAL"]?.value === 'true',

                        acaoBaixarImagens_visualizador_Medico: config['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_MEDICO']?.value === 'true',
                        acaoBaixarImagens_dicomZip_Medico: config['ACAO_BAIXAR_IMAGENS_ZIP_MEDICO']?.value === 'true',

                        // Medico - infos
                        infoAcNumberAtivoMedico: config["INFO_ACNUMBER_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        infoProntuarioAtivoMedico: config["INFO_PRONTUARIO_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        infoDataAtivoMedico: config["INFO_DATA_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        infoUnidadeAtivoMedico: config["INFO_UNIDADE_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        infoMedSolicitanteAtivoMedico: config["INFO_MED_SOLICITANTE_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        infoMedExecutanteAtivoMedico: config["INFO_MED_EXECUTANTE_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        infoMedRevisorAtivoMedico: config["INFO_MED_REVISOR_ATIVO_MEDICO_PORTAL"]?.value === 'true',

                        // Medico - acoes
                        acaoPrincipalBotaoImagensMedico: config["ACAO_PRINCIPAL_BOTAO_IMAGENS_MEDICO_PORTAL"]?.value || '',
                        acaoPrincipalThumbnailImagensMedico: config["ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_MEDICO_PORTAL"]?.value || '',
                        statusAtivoMedico: config["STATUS_ATIVO_MEDICO_PORTAL"]?.value === 'true',
                        habilitarEnvioDicomExamesExternos: config["HABILITAR_ENVIO_DICOM_EXAMES_EXTERNOS"]?.value === 'true',

                        // Geral
                        tempoInatividade: config["TEMPO_INATIVIDADE_PORTAL"]?.value || '',
                        servicoImagemPortal: config["SERVICO_IMAGEM"]?.value || '',
                        pesquisa_Inicial_Exames_Paciente: config['PESQUISA_INICIAL_EXAMES_PACIENTE']?.value || 'Padrao',

                        exibir_apenas_pedidos_revisados_portal: config['EXIBIR_APENAS_PEDIDOS_REVISADOS_PORTAL']?.value === 'true',
                    }, () => {
                        this.aplicarFiltroInicial();
                    });
                })
                .catch(err => console.error("Erro no GetConfig:", err));
        } catch (err) {
            console.error("Erro catch getConfig:", err);
        }
    }

    aplicarFiltroInicial = () => {
        const {
            pesquisa_Inicial_Exames_Paciente,
            dataInicial,
            dataFinal,
            isMedico
        } = this.state;

        const filtroBase = {
            modalidades: [],
            paciente: '',
            acNumber: '',
            prontuario: '',
            dataInicial: '',
            dataFinal: ''
        };

        if (pesquisa_Inicial_Exames_Paciente === 'Filtro' || isMedico) {
            filtroBase.dataInicial = dataInicial;
            filtroBase.dataFinal = dataFinal;
        }

        this.onExecuteFiltro(filtroBase);
    };




    //CONSTS/VARIÁVEIS DE CLASSE
    //#region CONSTS/VARIÁVEIS DE CLASSE
    cameraInputRef = null;
    //#endregion

    //METHODS
    //#region METHODS

    mobilecheck() {
        var check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    _getUrl() {
        return axios
            .get("config.json")
            .then(res => res.data.servico)
            .then(url => {
                if (url[url.length - 1] === "/") return url;
                return url + "/";
            });
    }

    atualizarZoomPDF = () => {
        const { urlLaudoPdf } = this.state;

        // Protege contra undefined
        if (!urlLaudoPdf || typeof urlLaudoPdf !== 'string') return;

        const larguraTela = window.innerWidth;

        let zoom = 100;
        if (larguraTela <= 480) zoom = 50;
        else if (larguraTela <= 768) zoom = 60;
        else if (larguraTela <= 1024) zoom = 100;
        else zoom = 100;

        const baseUrl = urlLaudoPdf.split('#')[0];
        const novaUrl = `${baseUrl}#zoom=${zoom}`;

        this.setState({ urlLaudoPdf: novaUrl });
    };

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth < 768 });
    };

    retDataFormatada(value) {
        return value
    }

    retLegendaPrioridade(prioridade) {
        if (prioridade === 0)
            return "Sem prioridade";
        if (prioridade === 1)
            return "Baixa";
        if (prioridade === 2)
            return "Média";
        if (prioridade === 3)
            return "Alta";
    }

    sucessoSalvarParecer(response) {
        alert("Parecer salvo com sucesso!");
        this.limparFormParecer();
    }

    limparFormParecer() {
        this.setState({
            parecerId: 0,
            parecerTexto: "",
            parecerPrioridade: 0,
            visibleDialogComentario: false
        });
    }

    RetPerfil() {
        if (ServiceLogin.isConvenio()) {
            sessionStorage.setItem("perfil", "Convenio");
            return 'Convênio';
        }
        if (this.state.isExecutante) {
            sessionStorage.setItem("perfil", "Executante");
            return "Médico Executante";
        }
        if (this.state.isMedico) {
            sessionStorage.setItem("perfil", "Solicitante");
            return "Médico Solicitante";
        } else {
            return "Paciente";
        }
    }

    alterarLayout = () => {
        let perfil = document.getElementById("perfil").innerText;
        if (perfil !== "Médico Executante") {
            var head = document.getElementsByTagName('HEAD')[0];
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            let layout = "layout/temaPaciente.css";
            if (perfil == "Médico Solicitante") {
                layout = "layout/temaMedico.css";
            }
            link.href = layout;
            head.appendChild(link);
        }
    }

    AdicionarHistoricoAcoes(operacao, pedidoId, tipo) {
        if (tipo === 'interno'){
            let usuarioId = !this.state.isMedico && !this.state.isExecutante ? null : this.state.UsuarioId;
            let url = `Api/Pedido/PostAdicionarHistorico/?operacao=${operacao}&usuarioId=${usuarioId}&pedidoId=${pedidoId}&acaoConvenio=${this.state.isConvenio}`;
            return ServiceApi.post(url);
        }
    }

    IsNullOrEmpty(value) {
        return value === null || value === "";
    }

    DesabilitarBtnLaudo(pedido) {

        if (pedido.Tipo === "externo") {
            return false;
        }

        if (this.state.isMedico & ServiceLogin.getNaoPodeVisualizarPedidoSemServico())
            return !pedido.PossuiServico;

        if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataImpresso === null)
            return true;

        if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataEntregue === null)
            return true;

        if (pedido.ContemAnexoDiagnostico && pedido.DataRevisado)
            return false;

        if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataLaudado && pedido.DataRevisado)
            return pedido.DataEntregue === null || pedido.DataEntregue === "";

        if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataLaudado && pedido.DataRevisado)
            return pedido.DataImpresso === null || pedido.DataImpresso === "";

        return pedido.DataRevisado === null || pedido.DataRevisado === "";
    }

    DesabilitarBtnLaudoSemServico(pedido) {
        return ServiceLogin.getNaoPodeVisualizarPedidoSemServico() ? !pedido.PossuiServico : false;
    }

    DesabilitarBtnImagemSemServico(pedido) {
        return ServiceLogin.getNaoPodeVisualizarImagemPedidoSemServico() ? !pedido.PossuiServico : false;
    }

    DesabilitarBtnAnexo(pedido) {
        try {
            return pedido.Anexos.Count === 0;
        } catch (ex) { }
        return true;
    }

    DesabilitarBtnImagem(pedido, btnImagemDisabledSemServico) {
        return new Promise((resolve) => {

            if (pedido.Tipo === "externo") {
                return false;
            }

            if (this.state.isMedico && btnImagemDisabledSemServico) {
                resolve(btnImagemDisabledSemServico);
            } else {

                const possuiJob = listarJob()
                    .then(res => {
                        return res.length > 0;
                    })
                    .catch(() => false)

                if (!possuiJob) {
                    if (pedido.StatusImagem === 2) {
                        resolve(false);
                        return;
                    }

                    if (this.IsNullOrEmpty(pedido.StudyUid)) {
                        resolve(true);
                        return;
                    }
                }

                this.galeriaServices.getValuesServiceSerie(pedido.Unidade.ServicoImagemPortal, pedido.StudyUid)
                    .then((response) => {
                        if (response.length === 0) {
                            return this.delay(500).then(() => resolve(true));
                        }
                        resolve(false);
                    })
                    .catch(() => resolve(true));
            }
        });
    }

    msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImageDisabledSemServico) {
        if (this.state.isMedico) {
            if (btnLaudoDisabledSemServico || btnImageDisabledSemServico)
                return <div style={{ fontWeight: "bold", textAlign: "right", marginTop: "10px", marginRight: "10px", color: "red" }}>Pedido não possui serviço vinculado</div>;
        }
        const msgAlert = <div style={{ fontWeight: "bold", textAlign: "right", marginTop: "10px", marginRight: "10px", color: "red" }}>Laudo não liberado!</div>;
        if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataEntregue === null)
            return msgAlert;
        if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataImpresso === null)
            return msgAlert;
        if (pedido.DataRevisado === null)
            return msgAlert;
        return "";
    }

    positionScroll() {
        window.scroll(0, 0);
        if (this.state.onPositionScroll) {
            try {
                const topPos = document.getElementById('gridListaPedidos').offsetTop - 50;
                window.scroll(0, topPos)
            } catch (error) { }
        }
    }

    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    fetchImage = async (url) => {
        let imageUrl = null;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Basic ${viewerAccessKey}`
            }
        });
        const blob = await response.blob();
        if (blob.size > 0) {
            this.setState({ imagemCarregada: true });
            imageUrl = URL.createObjectURL(blob);
        }

        return imageUrl;
    }

    buscarImagensPreviewParaPedidos = async (pedidos) => {
        const novosPedidos = await Promise.all(
            pedidos.map(async (pedido) => {
                try {
                    const headers = ServiceApi._getHeaders().headers;

                    // 1. Verifica se existe job para o pedido
                    const jobs = await listarJob(pedido.AcNumber, pedido.Unidade.Id);
                    if (Array.isArray(jobs) && jobs.length > 0) {
                        // 2. Busca as imagens do primeiro job
                        const imagensJob = await BuscarImagensLista(jobs[0].Id, pedido.Unidade.Id);
                        if (Array.isArray(imagensJob) && imagensJob.length > 0) {
                            // 3. Usa a primeira imagem do job como preview
                            return {
                                ...pedido,
                                imagemPreviewUrl: `data:image/jpeg;base64,${imagensJob[0].ImageBase64}`,
                                possuiJob: true
                            };
                        }
                    }

                    // Se não tem job, segue fluxo normal
                    if (headers.user !== null) {
                        const base = pedido.Unidade?.ServicoImagemPortal ?? this.state.servicoImagemPortal;
                        const studyUid = pedido.StudyUid;
                        const cleanedBase = base.endsWith('/studies') ? base : `${base}/studies`;
                        const infoUrl = `${cleanedBase}/${studyUid}/getstudyimagens`;

                        const response = await axios.get(infoUrl, { headers });
                        const imagens = response.data?.instanceImage;

                        if (Array.isArray(imagens) && imagens.length > 0) {
                            const primeiraSerie = imagens[0];
                            const instancias = primeiraSerie.instances;

                            if (
                                !primeiraSerie.serie ||
                                !Array.isArray(instancias) ||
                                instancias.length === 0
                            ) {
                                return { ...pedido, imagemPreviewUrl: null, possuiJob: false };
                            }

                            const meio = Math.floor(instancias.length / 2);
                            const instanceUID = instancias[meio];

                            const urlPreview = `${cleanedBase}/${studyUid}/series/${primeiraSerie.serie}/instances/${instanceUID}/frames/0/rendered/512/512`;
                            const imageUrl = await this.fetchImage(urlPreview);
                            return { ...pedido, imagemPreviewUrl: imageUrl, possuiJob: false };
                        } else {
                            return { ...pedido, imagemPreviewUrl: null, possuiJob: false };
                        }
                    }
                } catch (e) {
                    return { ...pedido, imagemPreviewUrl: null, possuiJob: false };
                }
            })
        );

        return novosPedidos;
    };

    getClasseVisualizador() {
        const opcao = this.state.modalOpcaoSelecionada;

        switch (opcao) {
            case 'Laudo':
            case 'Galeria':
                return 'full';
            case 'Compartilhar':
                return 'compartilhar';
            case 'Exames externos':
                return 'examesExternos';
            case 'Anexos':
                return 'anexos';
            case 'Arquivos':
                return 'arquivos';
            case 'Parecer':
                return 'parecer';
            default:
                return 'full';
        }
    }


    buscarProcedimentos = async (e) => {
        const termo = e.query?.trim();
        const modalidadeId = 0;

        const url = `${this.state.caminhoServico}/Api/Portal/PostListarProcedimentos?procedimento=${encodeURIComponent(termo)}&modalidadeId=${encodeURIComponent(modalidadeId)}&medicoId=0`;

        try {
            const authHeaders = ServiceApi._getHeaders().headers;

            const headers = new Headers();
            headers.append('user', authHeaders.user);
            headers.append('Cnonce', authHeaders.Cnonce);
            headers.append('Token', authHeaders.Token);
            headers.append('TokenPortal', authHeaders.TokenPortal);
            headers.append('isPacientePortal', authHeaders.isPacientePortal);
            headers.append('isConvenioPortal', authHeaders.isConvenioPortal);

            const response = await fetch(url, {
                method: 'POST',
                headers: headers
            });

            if (!response.ok) {
                const text = await response.text();
                throw new Error(`Erro ${response.status}: ${text}`);
            }

            const procedimentos = await response.json();
            this.setState({ procedimentosSugeridos: procedimentos });

        } catch (error) {
            console.error('Erro ao buscar procedimentos:', error.message);
            this.setState({ procedimentosSugeridos: [] });
        }
    };

    adicionarArquivos = (novosArquivos) => {
        const arquivosAtuais = this.state.arquivosSelecionados;

        const todos = [...arquivosAtuais, ...novosArquivos].filter(
            (file, index, self) =>
                index === self.findIndex(f => f.name === file.name && f.size === file.size)
        );

        this.setState({ arquivosSelecionados: todos });
    };

    //#endregion

    //HANDLES
    //#region HANDLES


    onExecuteFiltro(filtro) {

        // Verificação: data inicial > data final
        if (new Date(filtro.dataInicial) > new Date(filtro.dataFinal)) {
            this.setState({
                dataInicialInvalida: true,
                dataFinalInvalida: true,
                modalErroVisivel: true,
                mensagemErro: "A data inicial não pode ser maior que a data final.",
                isLoading: false
            });
            return;
        }

        if (new Date(filtro.dataFinal) < new Date(filtro.dataInicial)) {
            this.setState({
                dataFinalInvalida: true,
                modalErroVisivel: true,
                mensagemErro: "A data final não pode ser menor que a data inicial.",
                isLoading: false
            });
            return;
        }

        // Se passou nas validações, limpa os erros
        this.setState({
            dataInicialInvalida: false,
            dataFinalInvalida: false,
            isLoading: true
        });

        pedidoFiltro.Modalidades = filtro.modalidades;
        pedidoFiltro.PacienteNome = filtro.paciente;
        pedidoFiltro.AcNumber = filtro.acNumber;
        pedidoFiltro.Prontuario = filtro.prontuario;
        pedidoFiltro.DataInicial = filtro.dataInicial;
        pedidoFiltro.DataFinal = filtro.dataFinal;
        pedidoFiltro.PageIndex = 0;
        pedidoFiltro.PageCount = this.state.rows;
        pedidoFiltro.Procedimento = filtro.procedimento;
        pedidoFiltro.ProcedimentoId = filtro.selectedProcedimentoId;
        pedidoFiltro.PesquisarPedidosExternos = this.state.isAcessoCompartilhado ? false : this.state.pesquisarExamesExternos;
        pedidoFiltro.ProcedimentoNome = this.state.nomeExame;
        pedidoFiltro.Sort = this.state.sort;

        if(this.state.exibir_apenas_pedidos_revisados_portal){
            pedidoFiltro.Revisado = true;
        }       

        const dados =
            this.RetPerfil() === "Médico Executante" ||
                this.RetPerfil() === "Médico Solicitante"
                ? this.pedidoservice.listarPortalExamesPaged(pedidoFiltro)
                : this.pedidoservice.listarPortalExamesPagedAdvanced(pedidoFiltro);

        dados
            .then(async data => {
                let pedidos = data.PedidosPortal || [];

                try {
                    const pedidosComImagens = await this.buscarImagensPreviewParaPedidos(pedidos);
                    if (pedidosComImagens && Array.isArray(pedidosComImagens)) {
                        pedidos = pedidosComImagens;
                    }
                } catch (err) {
                    console.warn("Erro ao buscar imagens preview:", err);
                }

                // marca STL e anexos
                pedidos.forEach(p => {
                    const anexos = p.Anexos?.Anexos || [];
                    p.temStl = anexos.some(anexo => anexo?.Nome?.toLowerCase().endsWith('.stl'));
                });

                const internosMarcados = pedidos.filter(p => p.Tipo === "interno");
                const externosMarcados = pedidos.filter(p => p.Tipo === "externo");

                const totalInternos = Number(data.CountTotal || 0);
                const totalExternos = Number(data.CountExternos || 0);

                const totalCombinado = totalInternos + totalExternos;

                const pedidosCombinados = pedidos;

                this.setState({
                    pedidos: internosMarcados,
                    pedidosExternos: externosMarcados,
                    pedidosCombinados,
                    totalPedidos: totalCombinado,
                    Total: totalCombinado,
                    TotalPedidosInternos: totalInternos,
                    TotalPedidosExternos: totalExternos,
                    first: 0,
                    rows: this.state.rows,
                    panelImageVisible: false,
                    panelLaudoVisible: false,
                    onPositionScroll: false
                });

                if (totalCombinado > 0) {
                    this.positionScroll();
                }

                if (totalCombinado === 0 && !this.state.mostrarFiltro) {
                    setTimeout(() => this.setState({ mostrarFiltro: true }), 3000);
                }
            })

            .catch((error) => {
                console.error("Erro ao executar filtro:", error);
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    onPageChange = (event) => {
        const pageIndex = event.first / event.rows;

        pedidoFiltro.PageIndex = pageIndex;
        pedidoFiltro.PageCount = event.rows;

        this.pedidoservice
            .listarPortalExamesPaged(pedidoFiltro)
            .then(async data => {
                let pedidos = data.PedidosPortal || [];

                try {
                    const pedidosComImagens = await this.buscarImagensPreviewParaPedidos(pedidos);
                    if (pedidosComImagens && Array.isArray(pedidosComImagens)) {
                        pedidos = pedidosComImagens;
                    }
                } catch (err) {
                    console.warn("Erro ao buscar imagens preview:", err);
                }

                pedidos.forEach(p => {
                    const anexos = p.Anexos?.Anexos || [];
                    p.temStl = anexos.some(anexo => anexo?.Nome?.toLowerCase().endsWith('.stl'));
                });

                const pedidosCombinados = pedidos;

                this.setState({
                    pedidos: pedidosCombinados.filter(p => p.Tipo === "interno"),
                    pedidosExternos: pedidosCombinados.filter(p => p.Tipo === "externo"),
                    pedidosCombinados,
                    totalPedidos: data.CountTotal,
                    TotalPedidosInternos: data.Count,
                    TotalPedidosExternos: data.CountExternos,
                    first: event.first,
                    rows: event.rows,
                    panelImageVisible: false,
                    panelImageJpegVisible: false,
                    panelLaudoVisible: false,
                    panelVisible: false
                });
            });
    };

    viewFullScreen(panel) {
        let el = document.getElementById(panel);
        let elContent = el.getElementsByClassName("p-panel-content")[0];
        this.state.isFullScreen = !this.state.isFullScreen;
        if (this.state.isFullScreen === true) {
            el.setAttribute("style", "visibility: visible;position: fixed;width: 100%;top: 0;left: 0;bottom: 0;background: white;z-index: 99999;padding:0");
            //elContent.setAttribute("style", "padding:0");
            elContent.firstElementChild.setAttribute("style", "height:" + (window.innerHeight - 50) + "px");
        } else {
            el.setAttribute("style", "visibility: visible;");
            elContent.removeAttribute("style");
            elContent.firstElementChild.setAttribute("style", "height:75vh");
        }
    }

    closeModalFullScreen(panel) {
        let el = document.getElementById(panel);
        el.removeAttribute("style");
        this.setState({ panelVisible: false, isFullScreen: false });
    }

    onSortChange(event) {
        event == "clear" ? this.setState({ sortKey: "Ordenar por" }) :
            pedidoFiltro.Sort = event.value;
        pedidoFiltro.PageIndex = 0;
        this.pedidoservice
            .listarPortalExamesPaged(pedidoFiltro)
            .then(data =>
                this.setState({
                    pedidos: data.PedidosPortal,
                    Total: data.CountTotal,
                    panelImageVisible: false,
                    panelImageJpegVisible: false,
                    panelLaudoVisible: false,
                    panelVisible: false,
                    sortKey: event.value,
                    first: 0
                })
            );
    }

    onHideGaleria() {
        this.setState({ panelImageJpegVisible: false });
    }

    onChangeDataViewLayoutOptions(value) {
        this.setState({ layout: value });
    }

    panelImageJpegMaximize() {
        this.setState({ isFull: !this.state.isFull });
    }

    openDialogParecer(pedido) {
        this.limparFormParecer();
        let _pedidoId = pedido.Id;
        this.setState({ visibleDialogComentario: true, selectedPedido: pedido });
        let medicoService = new MedicoService();
        medicoService.GetParecerMedico(_pedidoId)
            .then(data => {
                console.log(data);
                let _listaParecer = [];

                data.Comentarios.forEach(el => {
                    let dados = {
                        DataCadastro: moment(el.DataCadastro).format("DD/MM/YYYY"),
                        Prioridade: this.retLegendaPrioridade(el.Prioridade),
                        Texto: el.Texto
                    }
                    _listaParecer.push(dados);
                });

                this.setState({
                    listaParecer: _listaParecer
                });
            })
            .catch(error => {
                console.log(error)
            }
            );
    }

    handleClickSelecionarPastaDicom() {
        if (this.inputPastaRef.current) {
            this.inputPastaRef.current.click();
        }
    }

    handleSalvarParecer() {
        let parecerDTO = {
            Id: 0,
            PedidoId: this.state.selectedPedido.Id,
            UsuarioId: this.state.UsuarioId,
            UsuarioNome: this.state.UsuarioNome,
            Texto: this.state.parecerTexto,
            Prioridade: this.state.parecerPrioridade,
            ParecerMedico: true
        }
        let medicoService = new MedicoService();
        medicoService.PostAdicionarParecer(parecerDTO)
            .then(response => {
                this.sucessoSalvarParecer(response);
                this.AdicionarHistoricoAcoes(33, this.state.selectedPedido.Id, this.state.selectedPedido.Tipo);
            })
            .catch(error => {
                console.log(error)
            }
            );
    }

    openDialogArquivos = async (pedido) => {
        this.setState({
            arquivosDialogOpen: true,
            pedidoSelecionadoArquivos: pedido
        });
    };

    closeDialogArquivos = () => {
        this.setState({
            arquivosDialogOpen: false,
            pedidoSelecionadoArquivos: null,
            anexosDoPedido: []
        });
    };

    visualizarListaAnexos(pedido) {
        this.state.listaAnexos = null;

        let _listaAnexos = [];

        const isExecutante = this.state.isExecutante;

        // Se for médico executante, mostra todos os anexos
        if (isExecutante) {
            _listaAnexos = pedido.Anexos.Anexos;
        } else {
            // Senão, mostra só os arquivos STL
            _listaAnexos = pedido.Anexos.Anexos.filter(anexo =>
                anexo.TipoAnexo?.toLowerCase() === "stl" ||
                anexo.Nome?.toLowerCase().endsWith(".stl")
            );
        }

        this.setState({
            listaAnexos: _listaAnexos,
            modalAnexo: true,
            selectedPedido: pedido
        });
    }


    openModalCompartilhar(pedido) {



        this.setState({
            visibleDialog: true,
            Prontuario: pedido.Prontuario,
            pacienteId: pedido.Paciente.Id,
            selectedPedido: pedido,
            prazoValue: '8',
            emailCompartilhar: "",
            celCompartilhar: ""
        })

    }

    handleBaixarImagem(pedido) {

        if (pedido === undefined) {

            this.setState({
                pedido: this.state.pedidoSelecionado
            })
        }

        this.setState({
            selectedPedido: pedido,
            panelImageVisible: false,
            panelImageJpegVisible: false,
            panelLaudoVisible: false,
            panelVisible: false,
            dialogDicomZip: true,
            progressoDicomZip: 0
        });

        let urlImagens = "";
        if (pedido.Unidade.ServicoImagemPortal.search("studies") > 0) {
            urlImagens = pedido.Unidade.ServicoImagemPortal + "/" + pedido.StudyUid + ".zip";
        } else {
            urlImagens = pedido.Unidade.ServicoImagemPortal + "/studies/" + pedido.StudyId + "/archive";
        }

        let so = "";
        switch (navigator.platform) {
            case "MacIntel":
                so = "mac";
                break;
            case "Linux x86_64":
                so = "linux";
                break;
            default:
                so = "windows";
                break;
        }
        const tk = (Math.random(new Date().getUTCMilliseconds())).toString().replace('.', '');
        let caminho = `${this.state.caminhoServico}api/Portal/PostDownloadComVisualizador?so=${so}&urlImagens=${urlImagens}&tk=${tk}`;

        const retDominio = () => {
            try {
                const servico = this.state.caminhoServico.split('/Servico');
                return servico[0];
            } catch (ex) {
                return this.state.caminhoServico;
            }
        }
        //let dominioCliente = `${this.state.caminhoServico}`.replace("Servico", "");
        let dominioCliente = retDominio();
        dominioCliente = dominioCliente.replace("https:", "");
        dominioCliente = dominioCliente.replace("http:", "");
        dominioCliente = dominioCliente.replace(/[//"]/g, '');
        var xhr = new XMLHttpRequest();
        cntPgr = 0;
        xhr.addEventListener("progress", updateProgress, false);
        xhr.addEventListener("load", transferComplete, false);
        // progresso
        xhr.addEventListener("progress", (event) => {
            if (event.lengthComputable) {
                const percent = Math.round((event.loaded / event.total) * 100);
                this.setState({ progressoDicomZip: percent });
            }
        });

        // sucesso
        xhr.onload = (e) => {
            if (xhr.status === 200) {
                const file = new File([xhr.response], "MyResultApp_Download.zip", { type: "application/zip" });
                const exportUrl = URL.createObjectURL(file);
                const fileLink = document.createElement('a');
                fileLink.href = exportUrl;
                fileLink.download = "MyResultApp_" + tk + ".zip";
                fileLink.click();
            }

            this.setState({ dialogDicomZip: false });
        };

        // erro
        xhr.onerror = () => {
            console.error("Erro no download");
            this.setState({ dialogDicomZip: false });
        };


        xhr.addEventListener("error", transferFailed, false)
        xhr.open('POST', caminho, true);
        xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
        xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
        xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
        xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
        xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
        xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);
        xhr.responseType = 'arraybuffer';
        xhr.send();

        this.AdicionarHistoricoAcoes(31, pedido.Id, pedido.Tipo);

        return null;
    }

    handleBaixarDicomZip(pedido) {
        if (!pedido || !pedido.Unidade || !pedido.StudyUid) {
            console.error("Pedido inválido");
            return;
        }

        const urlDicomZip = `${pedido.Unidade.ServicoImagemPortal}/${pedido.StudyUid}.zipAsync`;

        this.setState({
            baixandoDicomZip: true,
            dialogDicomZip: true,
            progressoDicomZip: 0
        });



        const xhr = new XMLHttpRequest();
        xhr.open("GET", urlDicomZip, true);
        xhr.setRequestHeader("Authorization", `Basic ${viewerAccessKey}`);
        xhr.responseType = "blob";

        // progresso
        xhr.onprogress = (event) => {
            const bytes = event.loaded;
            const kib = bytes / 1024;

            this.setState({ progressoDicomZip: Math.round(kib) }); // número inteiro
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                const blob = xhr.response;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `dicom_${pedido.StudyUid}.zip`;
                link.click();
                window.URL.revokeObjectURL(url);

                this.AdicionarHistoricoAcoes(31, pedido.Id, pedido.Tipo);
            }
            this.setState({ baixandoDicomZip: false, dialogDicomZip: false });
        };

        xhr.onerror = () => {
            console.error("Erro no download");
            this.setState({ baixandoDicomZip: false, dialogDicomZip: false });
        };

        xhr.send();
    }



    handleAbrirImagem(pedido) {
        if (pedido.StatusImagem === 2) {
            let ultimoLaudoFiltro = {
                PacienteId: pedido.Paciente.Id,
                PacienteNome: pedido.Paciente.Nome,
                PacienteNascimento: pedido.PacienteNascimento,
                PacienteSexo: pedido.PacienteSexo,
                ModalidadeId: pedido.Modalidade.Id,
                DataCadastro: pedido.DataCadastro
            }
            this.pedidoservice.obterUltimosLaudosComStudyUid(ultimoLaudoFiltro)
                .then(data => {
                    this.setState({
                        imagensVinculadas: data.UltimosLaudos
                    });
                    this.setState({ modalImagemOutroPedido: true })
                    this.setState({ pedidoComImagemVinculadaMedicoExecutante: pedido.MedicoExecutante })
                    this.setState({ pedidoComImagemVinculadaMedicoRevisor: pedido.MedicoRevisor })
                    this.setState({ pedidoComImagemVinculadaId: pedido.Id })
                })
            return
        }
        const auth = JSON.parse(`${sessionStorage.getItem("auth")}`);

        const isSolicitante = sessionStorage.getItem("perfil") === "Solicitante";

        if (this.mobilecheck()) {
            let _viewer = pedido.Unidade.VisualizadorPortal.replace('{STUDYUID}', pedido.StudyUid);
            const parametro = _viewer.indexOf('/viewer/') > 0 ? '?' : '&';
            _viewer = _viewer.replace('{STUDYID}', pedido.StudyId);

            _viewer += `${parametro}acessoportal=1&User=${`${ServiceApi._getHeaders().headers.user}`}&Token=${`${ServiceApi._getHeaders().headers.Token}`}&Cnonce=${`${ServiceApi._getHeaders().headers.Cnonce}`}&TokenPortal=${`${ServiceApi._getHeaders().headers.TokenPortal}`}&isPacientePortal=${`${ServiceApi._getHeaders().headers.isPacientePortal}`}&isConvenioPortal=${`${ServiceApi._getHeaders().headers.isConvenioPortal}`}&isSolicitantePortal=${`${isSolicitante}`}`;

            window.open(_viewer, "imageFrame");
        } else {
            this.setState({
                selectedPedido: pedido,
                servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
                panelVisible: true,
                panelImageJpegVisible: false
            });
            let _viewer = pedido.Unidade.VisualizadorPortal.replace('{STUDYUID}', pedido.StudyUid);
            const parametro = _viewer.indexOf('/viewer/') > 0 ? '?' : '&';
            _viewer = _viewer.replace('{STUDYID}', pedido.StudyId);

            _viewer += `${parametro}acessoportal=1&User=${`${ServiceApi._getHeaders().headers.user}`}&Token=${`${ServiceApi._getHeaders().headers.Token}`}&Cnonce=${`${ServiceApi._getHeaders().headers.Cnonce}`}&TokenPortal=${`${ServiceApi._getHeaders().headers.TokenPortal}`}&isPacientePortal=${`${ServiceApi._getHeaders().headers.isPacientePortal}`}&isConvenioPortal=${`${ServiceApi._getHeaders().headers.isConvenioPortal}`}&isSolicitantePortal=${`${isSolicitante}`}`;

            const embedRemove = document.getElementsByTagName('embed');
            if (embedRemove.length > 0) {
                for (let index = 0; index < embedRemove.length; index++)
                    embedRemove[index].remove();
            }
            const embed = document.createElement('embed');
            embed.src = _viewer;
            embed.width = '100%';
            embed.height = '100%';
            const container = document.getElementById("viewer-container");
            if (container) {
                container.innerHTML = ""; // limpa pra não duplicar
                container.appendChild(embed);
            }

            this.setState({ modalImagemOutroPedido: false })
        }
        this.AdicionarHistoricoAcoes(30, pedido.Id, pedido.Tipo);
        return null;
    }

    handleImprimirLaudo(pedido) {

        if (this.mobilecheck())
            return alert("Impressão de laudo somente por computador.");

        this.pedidoSelecionado = pedido;

        if (this.pedidoSelecionado.ContemAnexoDiagnostico && this.state.isExecutante)
            return this.setState({ modalConfirmaImpressao: true });

        //if(this.pedidoSelecionado.DataRevisado === null || this.pedidoSelecionado.ContemAnexoDiagnostico)
        //return this.confirmaImprimirLaudo(true);

        return this.confirmaImprimirLaudo(true);
    }

    confirmaImprimirLaudo(anexoDiagnostico) {
        if (this.pedidoSelecionado) {
            let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${this.pedidoSelecionado.IdExterno}&anexoDiagnostico=${anexoDiagnostico}`;
            var xhr = new XMLHttpRequest();

            xhr.open('GET', caminho, true);

            xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
            xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
            xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            xhr.responseType = 'arraybuffer';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    var blob = new Blob([this.response], { type: "application/pdf" });
                    var pdfUrl = URL.createObjectURL(blob);
                    print(pdfUrl);
                }
            };
            xhr.send();
            this.AdicionarHistoricoAcoes(38, this.pedidoSelecionado.Id, this.pedidoSelecionado.Tipo);
        }
        return null;
    }

    abrirLaudo = (pedido) => {
        if (!pedido || pedido.laudoJaCarregado) return;

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);

        if (!isAndroid) {
            const anexo = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
            const url = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${anexo}`;
            const headers = ServiceApi._getHeaders().headers;

            this.setState({ urlLaudoPdf: null, laudoCarregando: true });

            fetch(url, {
                method: 'GET',
                headers: {
                    user: headers.user,
                    Cnonce: headers.Cnonce,
                    Token: headers.Token,
                    TokenPortal: headers.TokenPortal,
                    isPacientePortal: headers.isPacientePortal,
                    isConvenioPortal: headers.isConvenioPortal,
                },
            })
                .then(r => r.blob())
                .then(blob => {
                    const pdfUrl = URL.createObjectURL(blob);
                    this.setState({ urlLaudoPdf: pdfUrl, laudoCarregando: false }, this.atualizarZoomPDF);
                    pedido.laudoJaCarregado = true;
                })
                .catch(() => {
                    this.setState({ urlLaudoPdf: null, laudoCarregando: false });
                });
        } else {

            let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
            let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;          
            var xhr = new XMLHttpRequest();
            cntPgr = 0;
            pgrBarCont = setInterval(viewPgrContinuous, 30);
            xhr.addEventListener("progress", updateProgress, false);
            xhr.addEventListener("load", transferComplete, false);
            xhr.addEventListener("error", transferFailed, false)

            xhr.open('Get', caminho, true);

            xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
            xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
            xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            xhr.responseType = 'arraybuffer';
            xhr.onload = function (e) {

                alert("Este navegador não suporta a exibição direta do arquivo. \n Será realizado o download no seu dispositivo, confira em seus arquivos.");

                if (this.status == 200) {
                    var file = new File([this.response], `Laudo_${pedido.IdExterno}.pdf`, { type: "application/pdf" });
                    var exportUrl = URL.createObjectURL(file);
                    var fileLink = document.createElement('a');
                    fileLink.href = exportUrl;
                    fileLink.download = `Laudo_${pedido.Id}.pdf`;
                    fileLink.click();                    
                }
            };
            xhr.send();
        }
    };

    handleAbrirLaudo(pedido) {
        if (this.mobilecheck()) {

            let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
            let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;
            //window.open(caminho, "LaudoFrame"); //Abrir em nova aba            
            var xhr = new XMLHttpRequest();
            cntPgr = 0;
            pgrBarCont = setInterval(viewPgrContinuous, 30);
            xhr.addEventListener("progress", updateProgress, false);
            xhr.addEventListener("load", transferComplete, false);
            xhr.addEventListener("error", transferFailed, false)

            xhr.open('Get', caminho, true);
            
            xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
            xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
            xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            xhr.responseType = 'arraybuffer';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    var file = new File([this.response], `Laudo_${pedido.IdExterno}.pdf`, { type: "application/pdf" });
                    var exportUrl = URL.createObjectURL(file);
                    var fileLink = document.createElement('a');
                    fileLink.href = exportUrl;
                    fileLink.download = `Laudo_${pedido.Id}.pdf`;
                    fileLink.click();
                }
            };
            xhr.send();

        } else {

            this.setState({
                selectedPedido: pedido,
                panelVisible: true,
                panelAnexoVisible: false,
            });

            let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;

            const caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;

            const embedRemove = document.getElementsByTagName('embed');

            if (embedRemove.length > 0) {
                for (let index = 0; index < embedRemove.length; index++)
                    embedRemove[index].remove();
            }

            const headers = new Headers();
            headers.append('user', `${ServiceApi._getHeaders().headers.user}`);
            headers.append('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            headers.append('Token', `${ServiceApi._getHeaders().headers.Token}`);
            headers.append('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            headers.append('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            headers.append('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            const requestOptions = {
                method: 'GET',
                headers: headers,
            };

            const embed = document.createElement('embed');

            fetch(caminho, requestOptions)
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    embed.src = URL.createObjectURL(blob);
                    document.getElementById(`divLaudo-${pedido.Id}`).append(embed);
                }).catch(error => {
                    console.error('Erro na requisição:', error);
                });

            embed.width = '100%';
            embed.height = '100%';

            this.setDialogContentSize();

            this.onScrollIntoView(`divLaudo-${pedido.Id}`);
        }
        this.AdicionarHistoricoAcoes(28, pedido.Id, pedido.Tipo);
        return null;
    }

    onScrollIntoView(el) {
        setTimeout(() => {
            document.getElementById(el).scrollIntoView();
            const _scrollTop = document.scrollingElement.scrollTop.toFixed() - 200;
            window.scroll(0, _scrollTop);
        }, 200);
    }

    setDialogContentSize = () => {
        try {
            const pDialogContent = document.getElementsByClassName('p-panel-content')[0];
            const embed = document.getElementsByTagName('embed')[0];
            pDialogContent.style.padding = '0';
            embed.style.height = `${pDialogContent.clientHeight}px`;
        } catch (ex) { }
    }

    async handleAbrirGaleriaDeImagens(pedido) {
        try {
            const possuiJob = await listarJob(pedido.AcNumber);
            // const possuiJob = false;

            if (possuiJob.length > 0) {
                sessionStorage.setItem('pedido', JSON.stringify(pedido));
                this.props.history.push({
                    pathname: '/Jobs',
                });
            } else {
                this.setState({
                    selectedPedido: pedido,
                    servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
                    panelImageJpegVisible: true
                });
                this.AdicionarHistoricoAcoes(29, pedido.Id, pedido.Tipo);
            }
        } catch (error) {
            console.error("Erro ao listar jobs:", error);
            alert("Não foi possível conectar ao servidor, tente novamente.");
            this.props.location.href = '#/portal';
        }
    }

    handleAbrirModalExamesExternos = async (opcao) => {
        if (opcao === 'Exames externos') {
            try {
                this.setState({
                    modalExamesExternosVisivel: true // abre a modal
                });
            } catch (error) {
                console.error('Erro ao buscar exames externos:', error);
                this.setState({ modalExamesExternosVisivel: true }); // ainda abre, mas sem dados
            }
        } else {
            this.setState({ modalExamesExternosVisivel: true });
        }
    };

    // Helper: mapeia a aba para a operação do histórico
    getOperacaoHistorico = (opcao) => {
        switch (opcao) {
            case 'Parecer': return 33;
            case 'Galeria': return 29;
            case 'Compartilhar': return 32;
            case 'Laudo': return 46;
            case 'Anexos': return 34;
            default: return 29;
        }
    };

    handleAbrirModalGenerica = (pedido, opcao) => {
        pedido.laudoJaCarregado = false;

        if (opcao === "Viewer" && !pedido.StudyUid && pedido.possuiJob)
            opcao = "Galeria";

        const isExterno = pedido.Tipo === "externo";
        const operacao = this.getOperacaoHistorico(opcao);

        // limpa lista de anexos anterior
        let _listaAnexos = [];
        if (pedido?.Anexos?.Anexos) {
            _listaAnexos = [...pedido.Anexos.Anexos];
        }

        if (opcao === 'LaudoAndroid') {
            this.setState({
                modalOpcoesVisivel: false,
            });
        } else {
            this.setState({
                modalOpcoesVisivel: true,
            });
        }

        // state inicial comum a todos os tipos
        this.setState({
            listaAnexos: _listaAnexos,
            selectedPedido: pedido,
            pedidoModalOpcoes: pedido,
            modalOpcaoSelecionada: opcao,
            listaParecer: []
        }, () => {
            // === Histórico ===
            if (operacao) this.AdicionarHistoricoAcoes(operacao, pedido.Id, pedido.Tipo);

            // === Parecer ===
            if (opcao === 'Parecer') {
                const medicoService = new MedicoService();
                medicoService.GetParecerMedico(pedido.Id)
                    .then(data => {
                        const _listaParecer = data.Comentarios.map(el => ({
                            DataCadastro: moment(el.DataCadastro).format("DD/MM/YYYY"),
                            Prioridade: this.retLegendaPrioridade(el.Prioridade),
                            Texto: el.Texto
                        }));
                        this.setState({ listaParecer: _listaParecer });
                    })
                    .catch(error => console.log('Erro ao buscar parecer médico:', error));
            }

            // === Viewer ===
            if (opcao === 'Viewer') {
                this.abrirViewer(pedido);
            }

            // === Laudo ===
            if (opcao === 'Laudo') {
                this.abrirLaudo(pedido);
            }

            // === Laudo Android ===
            if (opcao === 'LaudoAndroid') {
                this.abrirLaudo(pedido);
            }

        });
    };


    async handleAbrirModalVisualizador(pedido, tipo) {
        try {
            const possuiJob = await listarJob(pedido.AcNumber);

            if (possuiJob.length > 0) {
                sessionStorage.setItem('pedido', JSON.stringify(pedido));
                this.props.history.push({ pathname: '/Jobs' });
            } else {
                this.setState({
                    selectedPedido: pedido,
                    servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
                    tipoVisualizador: tipo, // <- pode ser 'imagem', 'laudo', 'dicom', etc.
                    panelVisualizadorVisible: true
                });
                this.AdicionarHistoricoAcoes(29, pedido.Id, pedido.Tipo);
            }
        } catch (error) {
            console.error("Erro ao listar jobs:", error);
            alert("Não foi possível conectar ao servidor, tente novamente.");
            this.props.location.href = '#/portal';
        }
    }

    handleCompartilharLinkPortal() {
        const pedido = this.state.pedidoModalOpcoes;

        if (!pedido || !pedido.Unidade) {
            console.error("Pedido ou Unidade está indefinido:", pedido);
            return;
        }

        const tipoCompartilhamento = this.state.formaEnvio === 'whatsapp' ? 0 : 1;
        let urlAcesso = `${window.location.origin}${window.location.pathname}`;
        urlAcesso = urlAcesso.replace(/^https?:\/\//, '');  // remove protocolo da URL

        const cel = this.state.celCompartilhar;
        const email = this.state.emailCompartilhar || '';
        const prazoRaw = this.state.validadeSelecionada;

        const prazo = parseInt(prazoRaw, 10) || 8; // valor padrão caso o parse falhe

        const cnonce = Math.random().toString().slice(2); // string aleatória sem ponto
        const unidadeId = pedido?.Unidade?.Id || pedido?.UnidadeId || 0;
        const pacienteId = pedido?.IdPaciente || pedido?.Paciente?.Id || 0;

        if (!pacienteId) {
            alert("Não foi possível encontrar o pacienteId.");
            return;
        }

        if (tipoCompartilhamento === 1 && (!email || !email.includes('@'))) {
            alert("Preencha um e-mail válido.");
            return;
        }

        if (tipoCompartilhamento === 0 && (!cel || cel.length < 8)) {
            alert("Preencha um número de celular válido.");
            return;
        }

        // Caminho da URL (assumindo que ServiceApi já tem baseURL configurada corretamente)
        const url = `/api/Portal/PostCompartilharLinkPortal/?` +
            `prontuario=${encodeURIComponent(pedido.Prontuario)}` +
            `&pacienteId=${pacienteId}` +
            `&url=${encodeURIComponent(urlAcesso)}` +
            `&email=${encodeURIComponent(email)}` +
            `&prazo=${prazo}` +
            `&cnonce=${encodeURIComponent(cnonce)}` +
            `&tipoCompartilhamento=${tipoCompartilhamento}` +
            `&unidadeId=${unidadeId}` +
            `&pedidoId=${pedido.Id}`;

        this.AdicionarHistoricoAcoes(32, pedido.Id, pedido.Tipo);

        console.log(' Compartilhamento', {
            prontuario: pedido.Prontuario,
            pacienteId,
            urlCompleta: url
        });

        return ServiceApi.post(url)
            .then(res => {
                const mensagem = typeof res === 'string' ? res : res?.data || '';

                if (tipoCompartilhamento === 0) {
                    let texto = mensagem.replace('http:', 'https:');
                    let numero = cel.replace(/[-()\s]/g, '');

                    if (numero) {
                        numero = `+55${numero}`;
                        const linkWhatsapp = document.createElement("a");
                        linkWhatsapp.href = `https://${this.mobilecheck() ? 'api' : 'web'}.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(texto)}`;
                        linkWhatsapp.target = this.mobilecheck() ? '' : '_blank';
                        document.body.appendChild(linkWhatsapp);
                        linkWhatsapp.click();
                        linkWhatsapp.remove();
                    } else {
                        alert("Preencha o número do celular que deseja compartilhar o link do portal.");
                    }
                } else {
                    alert(mensagem);
                }

                this.setState({
                    modalOpcoesVisivel: false,
                    validadeSelecionada: null,
                    emailCompartilhar: "",
                    celCompartilhar: ""
                });
            })
            .catch(err => {
                console.error("Erro ao compartilhar:", err);
                alert("Erro ao compartilhar. Verifique os dados ou tente novamente mais tarde.");
            });
    }


    toggleFiltro = () => {
        if (this.state.isAcessoCompartilhado) {
            return;
        }
        this.setState((prevState) => ({
            mostrarFiltro: !prevState.mostrarFiltro
        }));
    };

    handleFilterKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleBuscarClick();
        }
    };

    handlePeriodoChange = (e) => {
        const value = e.value;
        const hoje = new Date();
        let novaDataInicial = this.state.dataInicial;
        let novaDataFinal = this.state.dataFinal;

        if (value === 'ultimos30') {
            novaDataFinal = hoje;
            novaDataInicial = new Date();
            novaDataInicial.setDate(novaDataFinal.getDate() - 30);
        } else if (value === 'ultimos90') {
            novaDataFinal = hoje;
            novaDataInicial = new Date();
            novaDataInicial.setDate(novaDataFinal.getDate() - 90);
        }

        if (value === 'personalizado') {
            const ultimaInicial = localStorage.getItem("ultimaDataInicialPersonalizada");
            const ultimaFinal = localStorage.getItem("ultimaDataFinalPersonalizada");

            if (ultimaInicial && ultimaFinal) {
                novaDataInicial = new Date(ultimaInicial);
                novaDataFinal = new Date(ultimaFinal);
            }
        }

        this.setState({
            periodoSelecionado: value,
            dataInicial: novaDataInicial,
            dataFinal: novaDataFinal
        });
    };

    handleModalidadeChange = (e) => {
        const value = e.value;

        this.setState({
            modalidadeSelecionada: value,
        });
    };

    handleDataInicialChange = (e) => {
        const novaDataInicial = e.value;
        const dataFinalAtual = this.state.dataFinal;
        const dataInvalida = new Date(novaDataInicial) > new Date(dataFinalAtual);

        localStorage.setItem("ultimaDataInicialPersonalizada", novaDataInicial);
        localStorage.setItem("ultimaDataFinalPersonalizada", this.state.dataFinal);

        this.setState({
            dataInicial: novaDataInicial,
            periodoSelecionado: 'personalizado',
            dataInicialInvalida: dataInvalida,
            dataFinalInvalida: dataInvalida
        });
    };

    handleDataFinalChange = (e) => {
        const novaDataFinal = e.value;
        const dataInicialAtual = this.state.dataInicial;
        const dataInvalida = new Date(dataInicialAtual) > new Date(novaDataFinal);

        localStorage.setItem("ultimaDataFinalPersonalizada", novaDataFinal);
        localStorage.setItem("ultimaDataInicialPersonalizada", this.state.dataInicial);

        this.setState({
            dataFinal: novaDataFinal,
            periodoSelecionado: 'personalizado',
            dataInicialInvalida: dataInvalida,
            dataFinalInvalida: dataInvalida
        });
    };

    handlePesquisarExamesExternos = (e) => {
        if (this.state.isAcessoCompartilhado) {
            this.setState({ pesquisarExamesExternos: false });
            return;
        }

        const value = e.value;

        this.setState({
            pesquisarExamesExternos: value
        })
    }

    handleBuscarClick = () => {
        const { nomeExame, modalidadeSelecionada, dataInicial, dataFinal, procedimentoSelecionadoId } = this.state;

        const filtro = {
            paciente: '',
            acNumber: '',
            prontuario: '',
            modalidades: [],
            selectedProcedimentoId: null,
            dataInicial,
            dataFinal
        };

        if (this.RetPerfil() === "Médico Executante" || this.RetPerfil() === "Médico Solicitante") {
            const texto = nomeExame?.trim();

            if (!texto) {

            } else if (
                /^\p{L}+$/u.test(texto) ||
                texto.includes(" ")
            ) {
                filtro.paciente = texto;
            } else {
                filtro.acNumber = texto;
            }
        } else {
            filtro.selectedProcedimentoId = procedimentoSelecionadoId;

            if (modalidadeSelecionada?.Modalidade !== undefined) {
                filtro.modalidades = modalidadeSelecionada
                    ? [modalidadeSelecionada.Modalidade]
                    : [];
            }
        }

        // Ativa o loading
        this.setState({ isLoading: true }, () => {
            this.onExecuteFiltro(filtro);
        });
    };

    handleIncluirExamesExternos = async () => {
        const {
            descricaoExame,
            dataExameExterno,
            localExameExterno,
            arquivosSelecionados,
            medicoSolicitanteExameExterno,
            crmMedicoSolicitanteExameExterno,
            zipDicom,
            UsuarioId,
        } = this.state;

        const erroDescricao = !descricaoExame?.trim();
        const erroData = !dataExameExterno;
        const erroLocal = !localExameExterno?.trim();
        const erroArquivos = arquivosSelecionados.length === 0 && !zipDicom;
        const pedidoPacienteID = UsuarioId;

        if (erroDescricao || erroData || erroLocal || erroArquivos || !pedidoPacienteID) {
            this.setState({
                erroDescricao,
                erroData,
                erroLocal,
                erroCamposObrigatorios: erroDescricao || erroData || erroLocal,
                erroArquivos,
            });
            return;
        }

        const formData = new FormData();
        formData.append('pacienteId', String(pedidoPacienteID));
        formData.append('dataExame', new Date(dataExameExterno).toLocaleDateString('pt-BR'));
        formData.append('descricaoExame', descricaoExame);
        formData.append('nomeInstituicao', localExameExterno);
        formData.append('nomeMedicoSolicitante', medicoSolicitanteExameExterno);
        formData.append('crmMedicoSolicitante', crmMedicoSolicitanteExameExterno);

        formData.append('usuario', '0');
        formData.append('acao', 'portal');

        arquivosSelecionados.forEach(file => {
            if (file) formData.append('file', file);
        });

        if (zipDicom) {
            formData.append('dicom', zipDicom);
        }

        try {
            this.setState({
                resultadoInclusaoVisivel: true,
                resultadoInclusaoMensagem: 'Incluindo exames externos...',
                resultadoInclusaoTipo: 'carregando'
            });

            const headers = new Headers();
            const authHeaders = ServiceApi._getHeaders().headers;

            headers.append('user', authHeaders.user);
            headers.append('Cnonce', authHeaders.Cnonce);
            headers.append('Token', authHeaders.Token);
            headers.append('TokenPortal', authHeaders.TokenPortal);
            headers.append('isPacientePortal', authHeaders.isPacientePortal);
            headers.append('isConvenioPortal', authHeaders.isConvenioPortal);

            delete headers['Content-Type'];
            if (!headers.TokenPortal) delete headers.TokenPortal;

            const response = await fetch(`${this.state.caminhoServico}Api/PedidoExterno/PostPedidoExterno`, {
                method: 'POST',
                headers,
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Erro no envio (status):', response.status);
                console.error('Detalhes do erro:', errorText);
                throw new Error(errorText || 'Erro no envio');
            }

            this.setState({
                resultadoInclusaoMensagem: 'Exames incluídos com sucesso!',
                resultadoInclusaoTipo: 'sucesso',
                arquivosSelecionados: [],
                descricaoExame: '',
                dataExameExterno: '',
                localExameExterno: '',
                //arquivosSelecionados: '',
                //medicoSolicitanteExameExterno: '',
                //crmMedicoSolicitanteExameExterno: '',
                zipDicom: null,
                //pedidoModalOpcoes: '',
                caminhopastaDicomExameExterno: '',

                erroArquivos: false,
                erroCamposObrigatorios: false,
                erroDescricao: false,
                erroLocal: false,
                erroData: false,
                modalExamesExternosVisivel: false

            });

        } catch (error) {
            console.error('Erro ao incluir exames:', error);

            this.setState({
                resultadoInclusaoMensagem: 'Erro ao incluir exames. Tente novamente.',
                resultadoInclusaoTipo: 'erro'
            });
        }
    };

    handleSelecionarPastaDicom = async (event) => {
        const files = Array.from(event.target.files);
        const zip = new JSZip();

        this.setState({ zipandoDicom: true }); //Exibe o spinner

        for (const file of files) {
            const relativePath = file.webkitRelativePath || file.name;
            zip.file(relativePath, file);
        }

        try {
            const conteudoZip = await zip.generateAsync({ type: 'blob' });
            const zipFile = new File([conteudoZip], 'dicom.zip', { type: 'application/zip' });

            this.setState({
                zipDicom: zipFile,
                caminhopastaDicomExameExterno: files[0]?.webkitRelativePath?.split('/')[0] || 'Pasta selecionada',
                zipandoDicom: false //Esconde o spinner
            });

            console.log('ZIP DICOM gerado com sucesso');
        } catch (error) {
            console.error('Erro ao zipar pasta DICOM:', error);
            alert('Falha ao compactar a pasta. Verifique os arquivos e tente novamente.');
            this.setState({ zipandoDicom: false });
        }
    };

    visualizarAnexoStl(pedido) {
        const auth = JSON.parse(sessionStorage.getItem("auth"));

        const user = auth?.Login;
        const cnonce = auth?.Cnonce;
        let token = md5(user + cnonce + auth?.Token);
        let isPacientePortal = false;
        let tokenPortal = '';

        if (auth.IdMedico === 0) {
            token = auth?.Md5;
            isPacientePortal = true;
            tokenPortal = auth?.TokenPortal == null ? "" : auth?.TokenPortal;
        }

        if (!user || !token || !cnonce) {
            console.error("Dados de autenticação ausentes no sessionStorage:", { user, token, cnonce });
            return;
        }

        const payload = {
            user: user,
            token: token,
            cnonce: cnonce,
            isPacientePortal: isPacientePortal,
            tokenPortal: tokenPortal
        };

        const base64Payload = btoa(JSON.stringify(payload));

        const protocolo = window.location.protocol; 
        const host = window.location.hostname;     
        const baseUrl = `${protocolo}//${host}`;

        const viewerUrl = `${baseUrl}/Viewer3D/?id=${pedido.Id}&data=${base64Payload}`;


        window.open(viewerUrl);
        this.AdicionarHistoricoAcoes(34, pedido.Id, pedido.Tipo);
    }




    visualizarAnexo(rowData) {
        const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS) {
            // Abre direto — Safari mostrará o PDF/arquivo e o usuário pode "Salvar em Arquivos"
            window.open(downloadUrl, '_blank');
            return;
        }

        var xhr = new XMLHttpRequest();
        xhr.open('GET', downloadUrl, true);
        xhr.responseType = 'blob';

        // Adiciona headers de autenticação como nos outros m.étodos
        const headers = ServiceApi._getHeaders().headers;
        xhr.setRequestHeader('user', headers.user);
        xhr.setRequestHeader('Cnonce', headers.Cnonce);
        xhr.setRequestHeader('Token', headers.Token);
        xhr.setRequestHeader('TokenPortal', headers.TokenPortal);
        xhr.setRequestHeader('isPacientePortal', headers.isPacientePortal);
        xhr.setRequestHeader('isConvenioPortal', headers.isConvenioPortal);

        xhr.onload = function () {
            if (xhr.status === 200) {
                const blob = xhr.response;
                const fileURL = URL.createObjectURL(blob);

                // Abre a visualização do anexo
                window.open(fileURL, "AnexoFrame");
            } else {
                console.error("Erro ao visualizar anexo:", xhr.status);
            }
        };

        xhr.onerror = function () {
            console.error("Erro de rede ao tentar visualizar anexo.");
        };

        xhr.send();

        // Histórico da operação
        let operacao = rowData.TipoAnexo === 1 ? 36 : 34;
        this.AdicionarHistoricoAcoes(operacao, this.state.selectedPedido.Id, this.state.selectedPedido.Tipo);
    }

    downloadAnexo(rowData) {
        const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS) {
            alert("O download será aberto em uma nova aba. Para salvar, toque em 'Compartilhar' e escolha 'Salvar em Arquivos'.");
            // Abre direto — Safari mostrará o PDF/arquivo e o usuário pode "Salvar em Arquivos"
            window.open(downloadUrl, '_blank');
            return;
        }

        var xhr = new XMLHttpRequest();
        xhr.open('GET', downloadUrl, true);
        xhr.responseType = 'blob';

        // Setando os headers de autenticação manualmente
        const headers = ServiceApi._getHeaders().headers;
        xhr.setRequestHeader('user', headers.user);
        xhr.setRequestHeader('Cnonce', headers.Cnonce);
        xhr.setRequestHeader('Token', headers.Token);
        xhr.setRequestHeader('TokenPortal', headers.TokenPortal);
        xhr.setRequestHeader('isPacientePortal', headers.isPacientePortal);
        xhr.setRequestHeader('isConvenioPortal', headers.isConvenioPortal);

        xhr.onload = function () {
            if (xhr.status === 200) {
                var blob = xhr.response;
                var fileName = rowData.Nome;
                var tempEl = document.createElement("a");
                document.body.appendChild(tempEl);
                tempEl.style = "display: none";
                let url = window.URL.createObjectURL(blob);
                tempEl.href = url;
                tempEl.download = fileName;
                tempEl.click();
                window.URL.revokeObjectURL(url);
            } else {
                console.error("Erro no download do anexo:", xhr.status, xhr.responseText);
            }
        };

        xhr.onerror = function () {
            console.error("Erro de rede ou CORS ao tentar baixar o anexo.");
        };

        xhr.send();

        // Adiciona histórico
        let operacao = rowData.TipoAnexo === 1 ? 37 : 35;
        this.AdicionarHistoricoAcoes(operacao, this.state.selectedPedido.Id, this.state.selectedPedido.Tipo);
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    exibirLaudoNaDiv(pedido) {
        if (!pedido) return;

        const anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
        const caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${anexoDiagnostico}`;

        const headers = new Headers();
        const authHeaders = ServiceApi._getHeaders().headers;

        headers.append('user', authHeaders.user);
        headers.append('Cnonce', authHeaders.Cnonce);
        headers.append('Token', authHeaders.Token);
        headers.append('TokenPortal', authHeaders.TokenPortal);
        headers.append('isPacientePortal', authHeaders.isPacientePortal);
        headers.append('isConvenioPortal', authHeaders.isConvenioPortal);

        const requestOptions = {
            method: 'GET',
            headers: headers,
        };

        fetch(caminho, requestOptions)
            .then(response => response.blob())
            .then(blob => {
                const embed = document.createElement('embed');
                embed.src = URL.createObjectURL(blob);
                embed.type = 'application/pdf';
                embed.width = '100%';
                embed.height = '100%';
                const divLaudo = document.getElementById(`divLaudo-${pedido.Id}`);
                if (divLaudo) {
                    divLaudo.innerHTML = '';
                    divLaudo.appendChild(embed);
                }
            })
            .catch(error => {
                console.error('Erro ao exibir o laudo:', error);
            });
    }

    mostrarBotaoLaudoNaModal(pedido) {
        const btnLaudoDisabledSemServico = this.DesabilitarBtnLaudoSemServico(pedido);
        const btnLaudoDisabled = this.state.isMedico & btnLaudoDisabledSemServico
            ? btnLaudoDisabledSemServico
            : this.DesabilitarBtnLaudo(pedido);

        return !btnLaudoDisabled;
    }

    mostrarBotao(pedido) {

        return pedido?.tipo !== 'externo';
    }

    handleArquivoSelecionado = (e) => {
        const arquivos = e.files || [];

        this.setState({
            arquivosSelecionados: arquivos,
            arquivosEnviadosViaUpload: arquivos.length > 0
        });
    };


    visualizarArquivo = (arquivo) => {
        const url = URL.createObjectURL(arquivo);
        window.open(url, "_blank");
    };

    removerArquivo = (index) => {
        const novaLista = [...this.state.arquivosSelecionados];
        novaLista.splice(index, 1);
        this.setState({ arquivosSelecionados: novaLista });
    };

    //#endregion

    //RENDERS SECUNDÁRIOS
    //#region RENDERS SECUNDÁRIOS

    renderAcoesArquivoExterno = (file) => {
        const pedidoId = this.state.pedidoModalOpcoes?.Id;
        if (!pedidoId) return null;

        const visualizar = async () => {
            try {
                const response = await this.pedidoservice.getArquivoExterno(pedidoId, file.Name);

                const fileName = file.Name.toLowerCase();
                let tipoForcado = "application/octet-stream";
                if (fileName.endsWith(".pdf")) tipoForcado = "application/pdf";
                else if (fileName.endsWith(".png")) tipoForcado = "image/png";
                else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg")) tipoForcado = "image/jpeg";
                else if (fileName.endsWith(".bmp")) tipoForcado = "image/bmp";

                const blob = new Blob([response.data], { type: tipoForcado });
                const url = URL.createObjectURL(blob);

                // PDF: precisa de uma forma segura para abrir
                if (tipoForcado === "application/pdf") {
                    // alguns navegadores bloqueiam window.open com PDF
                    const novaAba = window.open();
                    novaAba.document.write(`
                <html>
                    <body style="margin:0">
                        <embed src="${url}" type="application/pdf" width="100%" height="100%" />
                    </body>
                </html>
            `);
                } else {
                    window.open(url, "_blank");
                }

                setTimeout(() => URL.revokeObjectURL(url), 10000);
            } catch (err) {
                console.error("Erro ao visualizar:", err);
            }
        };


        const baixar = async () => {
            try {
                const response = await this.pedidoservice.getArquivoExterno(pedidoId, file.Name);

                // Detecta o tipo (pelo nome, já que Content-Type pode ser inconsistente)
                const fileName = file.Name.toLowerCase();
                let tipoForcado = "application/octet-stream";
                if (fileName.endsWith(".pdf")) tipoForcado = "application/pdf";
                if (fileName.endsWith(".png")) tipoForcado = "image/png";
                if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg")) tipoForcado = "image/jpeg";
                if (fileName.endsWith(".bmp")) tipoForcado = "image/bmp";

                const blob = new Blob([response.data], { type: tipoForcado });
                const url = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = file.Name || "arquivo"; // usa o nome real
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => URL.revokeObjectURL(url), 10000);
            } catch (err) {
                console.error("Erro ao baixar arquivo externo:", err);
            }
        };


        return (
            <div style={{ display: 'flex', gap: '0.5em' }}>
                <Button
                    icon="pi pi-eye"
                    className="p-button-text p-button-sm"
                    onClick={visualizar}
                    tooltip="Visualizar"
                    tooltipOptions={{ position: 'top' }}
                />
                <Button
                    icon="pi pi-download"
                    className="p-button-text p-button-sm"
                    onClick={baixar}
                    tooltip="Baixar"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };

    renderListItem(pedido) {

        let dataEstudo = "";
        let btnLaudoDisabled = false;
        let btnImageDisable = false;
        let btnGaleriaDisable = false;
        let btnAnexoDisabled = false;
        let msgLaudo = "";
        let btnLaudoDisabledSemServico = false;
        let btnImagemDisabledSemServico = false;
        let titleBtnLaudoDisabledSemServico = "";
        let titleBtnImageDisabledSemServico = "";
        let temStl = pedido.temStl;

        try {

            dataEstudo = new Date(pedido.DataEstudo);
            dataEstudo = moment(dataEstudo).format("DD/MM/YYYY");
            btnAnexoDisabled = this.DesabilitarBtnAnexo(pedido);
            btnLaudoDisabledSemServico = this.DesabilitarBtnLaudoSemServico(pedido);
            btnLaudoDisabled = this.state.isMedico & btnLaudoDisabledSemServico ? btnLaudoDisabledSemServico : this.DesabilitarBtnLaudo(pedido);
            btnImagemDisabledSemServico = this.DesabilitarBtnImagemSemServico(pedido);
            btnImageDisable = this.state.btnImageDisable;
            msgLaudo = this.msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImagemDisabledSemServico);
            titleBtnLaudoDisabledSemServico = this.state.isMedico & btnLaudoDisabledSemServico ? 'Pedido não possui serviço vinculado' : '';
            titleBtnImageDisabledSemServico = this.state.isMedico & btnImagemDisabledSemServico ? 'Pedido não possui serviço vinculado' : '';
            

            if (pedido.StudyUid != null && pedido.StudyUid != "" || pedido.possuiJob != false) {
                btnImageDisable = false;
            } else {
                btnImageDisable = true;
            }

            if (pedido.possuiJob != false || pedido.StudyUid != null && pedido.StudyUid != "") {
                btnGaleriaDisable = false;
            } else {
                btnGaleriaDisable = true;
            }

        } catch (ex) { console.log(ex); }

        const NOMEBOTAO = JSON.parse(sessionStorage.getItem('config'));



        //Configurações:
        const {
            isMedico,
            isExecutante,
            isConvenio,
            acaoPrincipalBotaoImagensMedico,
            acaoPrincipalBotaoImagensPaciente,
            acaoPrincipalThumbnailImagensMedico,
            acaoPrincipalThumbnailImagensPaciente
        } = this.state;

        const isPerfilMedico = isMedico || isExecutante;

        // Ação principal de acordo com o perfil
        const acaoPrincipal = isPerfilMedico
            ? acaoPrincipalBotaoImagensMedico
            : acaoPrincipalBotaoImagensPaciente;

        // Ação principal de acordo com o perfil
        const acaoPrincipalPreview = isPerfilMedico
            ? acaoPrincipalThumbnailImagensMedico
            : acaoPrincipalThumbnailImagensPaciente;

        //Label do botão principal de imagem
        const labelAcaoPrincipal =
            acaoPrincipal === "Viewer"
                ? (this.state.labelBotaoViewer || "Abrir Viewer")
                : (this.state.labelBotaoGaleria || "Galeria de imagens");

        //Ação secundária botão de imagens
        const acaoSecundaria = acaoPrincipal === "Viewer" ? "Galeria" : "Viewer";


        //Ícone Principal
        const iconPrincipal =
            acaoPrincipal === "Viewer"
                ? <img className="btnPrincipalImagens" src={viewerIcon_principal} alt="Viewer" style={{ width: "30px", height: "30px", marginRight: "8px" }} />
                : <img className="btnPrincipalImagens" src={galeryIcon_principal} alt="Galeria" style={{ width: "30px", height: "30px", marginRight: "8px" }} />;

        //Ícone Secundário
        const iconSecundario =
            acaoSecundaria === "Viewer"
                ? <img src={viewerIcon_secundario} alt="Viewer" style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                : <img src={galeryIcon_secundario} alt="Galeria" style={{ width: "20px", height: "20px", marginRight: "8px" }} />;

        // Define se o botão deve aparecer (pelo menos uma das ações ativas)
        const mostrarBotaoImagens = isPerfilMedico
            ? (this.state.botaoViewerAtivoMedico || this.state.botaoGaleriaAtivoMedico)
            : (this.state.botaoViewerAtivoPaciente || this.state.botaoGaleriaAtivoPaciente);

        // Define se o botão será SplitButton (várias opções)
        const hasOptions = (() => {
            if (isPerfilMedico) {
                const {
                    botaoGaleriaAtivoMedico,
                    botaoViewerAtivoMedico,
                    acaoBaixarImagens_visualizador_Medico,
                    acaoBaixarImagens_dicomZip_Medico
                } = this.state;

                const variasOpcoesDeImagem = botaoGaleriaAtivoMedico && botaoViewerAtivoMedico;
                const opcoesDeDownload = acaoBaixarImagens_visualizador_Medico || acaoBaixarImagens_dicomZip_Medico;

                return variasOpcoesDeImagem || opcoesDeDownload;
            } else {
                const {
                    botaoGaleriaAtivoPaciente,
                    botaoViewerAtivoPaciente,
                    acaoBaixarImagens_visualizador_Paciente,
                    acaoBaixarImagens_dicomZip_Paciente
                } = this.state;

                const variasOpcoesDeImagem = botaoGaleriaAtivoPaciente && botaoViewerAtivoPaciente;
                const opcoesDeDownload = acaoBaixarImagens_visualizador_Paciente || acaoBaixarImagens_dicomZip_Paciente;

                return variasOpcoesDeImagem || opcoesDeDownload;
            }
        })();


        // Checa se alguma opção do model estaria visível
        const hasLaudoExtras = isPerfilMedico
            ? (this.state.botaoImprimirLaudoAtivoMedico || this.state.botaoCompartilharAtivoMedico)
            : (this.state.botaoImprimirLaudoAtivoPaciente || this.state.botaoCompartilharAtivoPaciente);

        return (
            <div >
                <div className="StudyArea">
                    <div className="StudyArea-Left" style={{ display: "flex" }}>

                        <div>
                            <div style={{ display: "flex" }}>
                                <div className="StudyArea-info">
                                    <div style={{ padding: "10px" }}>
                                        <div className="card-details">
                                            <div
                                                style={{ display: (this.state.isMedico || this.RetPerfil() === "Convênio") ? "block" : "none" }}
                                                className="PacienteDados"
                                            >

                                                <div className="PacienteDados-Nome-Prontuario-status-desktop">
                                                    <div className="PacienteDados-Nome">
                                                        <b>{pedido.Paciente.Nome}</b>
                                                    </div>

                                                    {(this.state.infoProntuarioAtivoMedico) && (

                                                        <div style={{ display: 'flex' }}>
                                                            <div className="PacienteDados-icone">
                                                                <b> | </b>
                                                                <img src={iconeProntuario} alt="Prontuario" style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                                            </div>

                                                            <div className="PacienteDados-Prontuario">
                                                                <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(this.state.statusAtivoMedico) && (
                                                        <div>
                                                            <div className="statusArea-yellow"
                                                                style={{
                                                                    display: (btnLaudoDisabled && btnImageDisable) ? 'block' : 'none'
                                                                }}>

                                                                <div style={{
                                                                    display: 'flex', alignItems: 'center'
                                                                }}>
                                                                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                    <b> {this.state.labelStatusProcessamentoMedico} </b>
                                                                </div>
                                                            </div>

                                                            <div className="statusArea-yellow"
                                                                style={{
                                                                    display: (btnLaudoDisabled && !btnImageDisable) ? 'block' : 'none'
                                                                }}>
                                                                <div style={{
                                                                    display: 'flex', alignItems: 'center'
                                                                }}>
                                                                    <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                    <b> {this.state.labelStatusAguardandoMedico} </b>
                                                                </div>
                                                            </div>

                                                            <div className="statusArea-green"
                                                                style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                                                                <div style={{
                                                                    display: 'flex', alignItems: 'center'
                                                                }}>
                                                                    <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                    <b> {this.state.labelStatusLiberadoMedico} </b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="PacienteDados-celular">
                                                    <div className="PacienteDados-Nome-Prontuario"
                                                        style={{ display: (this.state.isMedico || this.RetPerfil() === "Convênio") ? "block" : "none" }}>
                                                        <div className="PacienteDados-Nome">
                                                            <b>{pedido.Paciente.Nome}</b>
                                                        </div>

                                                        {(this.state.infoProntuarioAtivoMedico) && (

                                                            <div style={{ display: 'flex' }}>
                                                                <div className="PacienteDados-icone">
                                                                    <b> | </b>
                                                                    <img src={iconeProntuario} alt="Prontuario" style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                                                </div>

                                                                <div className="PacienteDados-Prontuario">
                                                                    <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="PacienteDados-Exame-Status">
                                                        <div className={'ExameTituloMedico'} style={{ display: (this.state.isMedico || this.RetPerfil() === "Convênio") ? "block" : "none" }}>
                                                            <b>
                                                                {pedido.Procedimento.Modalidade.Abreviacao} - {" "}
                                                                {pedido.Procedimento.Nome}
                                                            </b>
                                                        </div>


                                                        {(this.state.statusAtivoMedico) && (
                                                            <div
                                                                style={{ display: (this.state.isMedico || this.RetPerfil() === "Convênio") ? "block" : "none" }}
                                                            >
                                                                <div className="statusArea-yellow"
                                                                    style={{
                                                                        display: (btnLaudoDisabled && btnImageDisable) ? 'block' : 'none'
                                                                    }}>

                                                                    <div style={{
                                                                        display: 'flex', alignItems: 'center'
                                                                    }}>
                                                                        <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                        <b> {this.state.labelStatusProcessamentoMedico} </b>
                                                                    </div>
                                                                </div>

                                                                <div className="statusArea-yellow"
                                                                    style={{
                                                                        display: (btnLaudoDisabled && !btnImageDisable) ? 'block' : 'none'
                                                                    }}>
                                                                    <div style={{
                                                                        display: 'flex', alignItems: 'center'
                                                                    }}>
                                                                        <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                        <b> {this.state.labelStatusAguardandoMedico} </b>
                                                                    </div>
                                                                </div>

                                                                <div className="statusArea-green"
                                                                    style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                                                                    <div style={{
                                                                        display: 'flex', alignItems: 'center'
                                                                    }}>
                                                                        <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                        <b> {this.state.labelStatusLiberadoMedico} </b>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>               
                                            </div>
                                        </div>

                                        <div className="card-details"

                                            style={{ display: (this.state.isMedico || this.RetPerfil() === "Convênio") ? "block" : "none" }}
                                        >
                                            <div className="card-details-zone">
                                                <div className="card-details-left">

                                                    <div className="PacienteDados-Nome-Prontuario-status-tablet">
                                                        <div className="PacienteDados-Nome">
                                                            <b>{pedido.Paciente.Nome}</b>
                                                        </div>

                                                        {(this.state.infoProntuarioAtivoMedico) && (
                                                            <div className="PacienteDados-icone-prontuario"  style={{ display: 'flex' }}>
                                                                <div className="PacienteDados-icone">
                                                                    <b> | </b>
                                                                </div>

                                                                <div className="PacienteDados-Prontuario">
                                                                    <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {(this.state.statusAtivoMedico) && (
                                                            <div className="statusArea-medico">
                                                                <div className="statusArea-yellow"
                                                                    style={{
                                                                        display: (btnLaudoDisabled && btnImageDisable) ? 'block' : 'none'
                                                                    }}>

                                                                    <div style={{
                                                                        display: 'flex', alignItems: 'center'
                                                                    }}>
                                                                        <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                        <b> {this.state.labelStatusProcessamentoMedico} </b>
                                                                    </div>
                                                                </div>

                                                                <div className="statusArea-yellow"
                                                                    style={{
                                                                        display: (btnLaudoDisabled && !btnImageDisable) ? 'block' : 'none'
                                                                    }}>
                                                                    <div style={{
                                                                        display: 'flex', alignItems: 'center'
                                                                    }}>
                                                                        <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                        <b> {this.state.labelStatusAguardandoMedico} </b>
                                                                    </div>
                                                                </div>

                                                                <div className="statusArea-green"
                                                                    style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                                                                    <div style={{
                                                                        display: 'flex', alignItems: 'center'
                                                                    }}>
                                                                        <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                        <b> {this.state.labelStatusLiberadoMedico} </b>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="PacienteDados-Exame-Data-Acnumber-Desktop">

                                                        <div className={'ExameTituloMedico-desktop'}>
                                                            <b>
                                                                {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                                                {pedido.Procedimento.Nome}
                                                            </b>
                                                        </div>

                                                        {(this.state.infoDataAtivoMedico) && (
                                                            <div className="DataExameMedico">
                                                                <img src={calendar} style={{ width: "20px", height: "20px" }} />
                                                                <div>
                                                                    {this.state.labelInfoData || "Data"} <b>{dataEstudo}</b>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {(this.state.infoAcNumberAtivoMedico) &&
                                                            pedido.AcNumber &&
                                                            pedido.AcNumber.trim() !== "" && (
                                                                <div className="AcNumber">
                                                                    <img src={keyImg} style={{ marginRight: "5px", maxWidth: "18px" }} />
                                                                    {this.state.labelInfoAcNumber || "Ac. Number"}  <b>{pedido.AcNumber}</b>
                                                                </div>
                                                        )}
                                                    </div>

                                                    <div className="PacienteDados-Data-Acnumber">
                                                        {(this.state.infoDataAtivoMedico) && (
                                                            <div className="DataExameMedico">
                                                                <img src={calendar} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                                                {this.state.labelInfoData || "Data"} <b>{" " + dataEstudo}</b>

                                                            </div>
                                                        )}                                                 
                                                        {(this.state.infoAcNumberAtivoMedico) &&
                                                            pedido.AcNumber &&
                                                            pedido.AcNumber.trim() !== "" && (
                                                                <div className="AcNumber">
                                                                    <img src={keyImg} style={{ marginRight: "5px", maxWidth: "18px" }} />
                                                                    {this.state.labelInfoAcNumber || "Ac. Number"}  <b>{pedido.AcNumber}</b>
                                                                </div>
                                                        )} 
                                                    </div>

                                                    <div className="PacienteDados-Info">
  
                                                        <br></br>
                                                        {(this.state.infoUnidadeAtivoMedico) && (
                                                            <div className="Unidade">
                                                                <img src={hospital} style={{ marginRight: "5px" }} />
                                                                {this.state.labelInfoUnidade || "Unidade"}  <b>{pedido.Unidade.Nome}</b>
                                                            </div>
                                                        )}

                                                        {this.state.infoMedSolicitanteAtivoMedico &&
                                                            pedido.MedicoSolicitante?.Nome &&
                                                            pedido.MedicoSolicitante.Nome.trim() !== "" && (
                                                                <div className="MedicoSolicitante">
                                                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                                                    {this.state.labelInfoMedSolicitante || "Médico Solicitante"} <b>{pedido.MedicoSolicitante.Nome}</b>
                                                                </div>
                                                            )}


                                                        {(this.state.infoMedExecutanteAtivoMedico) &&
                                                            pedido.MedicoExecutante?.Nome &&
                                                            pedido.MedicoExecutante.Nome.trim() !== "" && (
                                                                <div className="MedicoExecutante">
                                                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                                                    {this.state.labelInfoMedExecutante || "Médico Executante"}  <b>{pedido.MedicoExecutante.Nome}</b>
                                                                </div>
                                                            )}

                                                        {(this.state.infoMedRevisorAtivoMedico) &&
                                                            pedido.MedicoRevisor?.Nome &&
                                                            pedido.MedicoRevisor.Nome.trim() !== "" && (
                                                                <div className="MedicoRevisor">
                                                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                                                    {this.state.labelInfoMedRevisor || "Médico Revisor"}  <b>{pedido.MedicoRevisor.Nome}</b>
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                        <div style={{ display: (!this.state.isMedico && this.RetPerfil() !== "Convênio") ? "block" : "none" }}
                                            className={'ExameTitulo'}
                                        >
                                            <div style={{ display: 'flex' }}>
                                                <div className={'PacienteProcedimentoDados'}>
                                                    <div style={{display: 'flex'}}>
                                                        <b>
                                                            {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                                            {pedido.Procedimento.Nome}
                                                        </b>

                                                        {(this.state.infoProntuarioAtivoPaciente) && (
                                                            <div className="PacienteDados-icone-prontuario" style={{ display: 'flex' }}>
                                                                <div className="PacienteDados-icone">
                                                                    <b> | </b>
                                                                    <img src={iconeProntuario} alt="Prontuario" style={{ width: "30px", height: "30px", marginRight: "8px", marginBottom: "-5px" }} />
                                                                </div>

                                                                <div className="PacienteDados-Prontuario">
                                                                    <b className="PacienteDados-Prontuario-text">{pedido.Prontuario}</b>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>   

                                                {(this.state.statusAtivoPaciente) && (
                                                    <div className={'PacienteProcedimentoStatus'}>
                                                        <div className="statusArea-yellow"
                                                            style={{
                                                                display: (btnLaudoDisabled && btnImageDisable) ? 'block' : 'none'
                                                            }}>

                                                            <div style={{
                                                                display: 'flex', alignItems: 'center'
                                                            }}>
                                                                <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                <b> {this.state.labelStatusProcessamentoPaciente} </b>
                                                            </div>
                                                        </div>

                                                        <div className="statusArea-yellow"
                                                            style={{
                                                                display: (btnLaudoDisabled && !btnImageDisable) ? 'block' : 'none'
                                                            }}>
                                                            <div style={{
                                                                display: 'flex', alignItems: 'center'
                                                            }}>
                                                                <img src={iconeAmpulheta} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                <b> {this.state.labelStatusAguardandoPaciente} </b>
                                                            </div>
                                                        </div>

                                                        <div className="statusArea-green"
                                                            style={{ display: !btnLaudoDisabled ? "block" : "none" }}>
                                                            <div style={{
                                                                display: 'flex', alignItems: 'center'
                                                            }}>
                                                                <img src={iconeCorreto} style={{ width: "20px", height: "20px", marginRight: "8px" }} />
                                                                <b> {this.state.labelStatusLiberadoPaciente} </b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {(this.state.infoDataAtivoPaciente) && (
                                                    <div className="DataExame-mobile">
                                                        <img src={calendar} style={{ marginRight: "5px" }} /> {this.state.labelInfoData || "Data: "} <b>{dataEstudo}</b>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div style={{ display: pedido.Unidade.Veterinaria ? 'block' : 'none' }}>
                                            <div className="Campos-veterinario">
                                                <div className="Tutor">
                                                    Tutor <b>{pedido.Tutor}</b>
                                                </div>

                                                <div className="Raca">
                                                    Raça <b>{pedido.Raca}</b>
                                                </div>

                                                <div className="Especie">
                                                    Espécie <b>{pedido.Especie}</b>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: (!this.state.isMedico && this.RetPerfil() !== "Convênio") ? "block" : "none" }}
                                            className="StudyArea-info-5">

                                            <div className="StudyArea-info-6">

                                                {(this.state.infoDataAtivoPaciente) && (
                                                    <div className="DataExame">
                                                        <img src={calendar} style={{ marginRight: "5px" }} /> {this.state.labelInfoData || "Data: "} <b>{dataEstudo}</b>
                                                    </div>
                                                )}

                                                {(this.state.infoUnidadeAtivoPaciente) && (
                                                    <div className="Unidade">
                                                        <img src={hospital} style={{ marginRight: "5px" }} />
                                                        {this.state.labelInfoUnidade || "Unidade: "} <b>{pedido.Unidade.Nome}</b>
                                                    </div>
                                                )}

                                                {(this.state.infoAcNumberAtivoPaciente) && pedido.AcNumber && pedido.AcNumber.trim() !== "" && (
                                                    <div className="AcNumber">                                                     
                                                        <img src={keyImg} style={{ width: "18px", height: "18px", marginRight: "5px" }} />
                                                        {this.state.labelInfoAcNumber || "Ac.Number"}  <b>{pedido.AcNumber}</b>                                                        
                                                    </div>
                                                )}
                                            </div>
                                            <div><br></br></div>

                                            <div className="PacienteDados-Info">
                                                {(this.state.infoMedSolicitanteAtivoPaciente) &&
                                                    pedido.MedicoSolicitante?.Nome &&
                                                    pedido.MedicoSolicitante.Nome.trim() !== "" && (
                                                        <div className="MedicoSolicitante">
                                                            <img src={doctor} style={{ marginRight: "5px" }} />
                                                            {this.state.labelInfoMedSolicitante || "Médico Solicitante"}  <b>{pedido.MedicoSolicitante.Nome}</b>
                                                        </div>
                                                    )}

                                                {(this.state.infoMedExecutanteAtivoPaciente) &&
                                                    pedido.MedicoExecutante?.Nome &&
                                                    pedido.MedicoExecutante.Nome.trim() !== "" && (
                                                        <div className="MedicoExecutante">
                                                            <img src={doctor} style={{ marginRight: "5px" }} />
                                                            {this.state.labelInfoMedExecutante || "Médico Executante"}  <b>{pedido.MedicoExecutante.Nome}</b>
                                                        </div>
                                                    )}

                                                {(this.state.infoMedRevisorAtivoPaciente) &&
                                                    pedido.MedicoRevisor?.Nome &&
                                                    pedido.MedicoRevisor.Nome.trim() !== "" && (
                                                        <div className="MedicoRevisor">
                                                            <img src={doctor} style={{ marginRight: "5px" }} />
                                                            {this.state.labelInfoMedRevisor || "Médico Revisor"}  <b>{pedido.MedicoRevisor.Nome}</b>
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="StudyArea-Buttons">
                                <div className="BtnImagens-area"
                                    style={{ display: btnImageDisable ? "none" : "block" }}>
                                    {mostrarBotaoImagens && (
                                        <div className="BtnImagens-area" style={{ display: btnImageDisable ? "none" : "block" }}>
                                            {hasOptions && (pedido.StudyUid) ? (
                                                <SplitButton
                                                    className="BtnImagens"
                                                    icon={iconPrincipal}
                                                    label={labelAcaoPrincipal}
                                                    iconpos="right"
                                                    appendTo="self"
                                                    onClick={() => this.handleAbrirModalGenerica(pedido, acaoPrincipal)}
                                                    disabled={btnImageDisable}
                                                    tooltipOptions={{ position: "bottom" }}
                                                    model={[
                                                        {
                                                            label: acaoSecundaria === "Galeria"
                                                                ? (this.state.labelBotaoGaleria || "Galeria de imagens")
                                                                : (this.state.labelBotaoViewer || "Abrir Viewer"),
                                                            icon: iconSecundario,
                                                            disabled: btnGaleriaDisable,
                                                            visible: (acaoSecundaria === "Viewer" && !pedido.StudyUid) ? false : isPerfilMedico
                                                                ? (this.state.botaoGaleriaAtivoMedico && this.state.botaoViewerAtivoMedico)
                                                                : (this.state.botaoGaleriaAtivoPaciente && this.state.botaoViewerAtivoPaciente),
                                                            command: () => this.handleAbrirModalGenerica(pedido, acaoSecundaria)
                                                        },
                                                        {
                                                            label: this.state.lblbtnDownloadVisualizador || "Baixar visualizador",
                                                            icon: <img src={downloadImg} alt="Baixar Imagens" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                            visible: pedido.StudyUid ? isPerfilMedico
                                                                ? this.state.acaoBaixarImagens_visualizador_Medico
                                                                : this.state.acaoBaixarImagens_visualizador_Paciente
                                                                : false,
                                                            command: () => this.handleBaixarImagem(pedido)
                                                        },
                                                        {
                                                            label: this.state.lblbtnDownloadDicomZip || "Baixar DICOM.zip",
                                                            icon: <img src={downloadDicomZip} alt="Baixar Imagens" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                            visible: pedido.StudyUid ? isPerfilMedico
                                                                ? this.state.acaoBaixarImagens_dicomZip_Medico
                                                                : this.state.acaoBaixarImagens_dicomZip_Paciente
                                                                : false
                                                                ,
                                                            command: () => this.handleBaixarDicomZip(pedido)
                                                        },
                                                    ]}
                                                    title={titleBtnImageDisabledSemServico}
                                                />
                                            ) : (
                                                <Button
                                                    className="BtnImagens"
                                                    icon={iconPrincipal}
                                                    label={labelAcaoPrincipal}
                                                    iconPos="right"
                                                    onClick={() => this.handleAbrirModalGenerica(pedido, acaoPrincipal)}
                                                    disabled={btnImageDisable}
                                                    tooltipOptions={{ position: "bottom" }}
                                                />
                                            )}
                                        </div>
                                    )}


                                </div>

                                <div>

                                    <div style={{ display: btnLaudoDisabled ? "none" : "block" }}>

                                        {(isPerfilMedico
                                            ? this.state.botaoLaudoAtivoMedico
                                            : this.state.botaoLaudoAtivoPaciente) ? (
                                            hasLaudoExtras ? (
                                                <SplitButton
                                                    className="BtnLaudo"
                                                    icon="custom-icon"
                                                    label={this.state.labelBotaoLaudo || "Laudo"}
                                                    iconpos="right"
                                                    appendTo="self"
                                                        onClick={() => {


                                                            const isAndroid = /Android/i.test(navigator.userAgent);

                                                            if (isAndroid) {
                                                                this.handleAbrirModalGenerica(pedido, 'LaudoAndroid');
                                                            } else {
                                                                this.handleAbrirModalGenerica(pedido, 'Laudo');
                                                            }
                                                        }}
                                                    disabled={btnLaudoDisabled}
                                                    tooltipOptions={{ position: "bottom" }}
                                                    title={titleBtnLaudoDisabledSemServico}
                                                    model={[
                                                        {
                                                            label: this.state.labelBotaoImprimirLaudo || "Imprimir Laudo",
                                                            icon: <img src={printIcon} alt="Imprimir Laudo" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                            disabled: btnLaudoDisabled,
                                                            visible: isPerfilMedico
                                                                ? this.state.botaoImprimirLaudoAtivoMedico
                                                                : this.state.botaoImprimirLaudoAtivoPaciente,
                                                            command: () => this.handleImprimirLaudo(pedido)
                                                        },
                                                        ...(pedido.CompartilharPortal && this.state.isAcessoCompartilhado === false
                                                            ? [{
                                                                label: this.state.labelBotaoCompartilhar || "Compartilhar",
                                                                icon: <img src={share} alt="Compartilhar" style={{ width: "20px", height: "20px", marginRight: "8px" }} />,
                                                                disabled: btnLaudoDisabled,
                                                                visible: isPerfilMedico
                                                                    ? this.state.botaoCompartilharAtivoMedico
                                                                    : this.state.botaoCompartilharAtivoPaciente,
                                                                command: () => this.handleAbrirModalGenerica(pedido, 'Compartilhar')
                                                            }]
                                                            : [])
                                                    ]}
                                                />
                                            ) : (
                                                <Button
                                                    className="BtnLaudo"
                                                    icon="custom-icon"
                                                    label={this.state.labelBotaoLaudo || "Laudo"}
                                                            iconpos="right"

                                                            onClick={() => {


                                                                const isAndroid = /Android/i.test(navigator.userAgent);

                                                                if (isAndroid) {
                                                                    this.handleAbrirModalGenerica(pedido, 'LaudoAndroid');
                                                                } else {
                                                                    this.handleAbrirModalGenerica(pedido, 'Laudo');
                                                                }
                                                            }}
                                                    disabled={btnLaudoDisabled}
                                                    tooltipOptions={{ position: "bottom" }}
                                                    title={titleBtnLaudoDisabledSemServico}
                                                />
                                            )
                                        ) : null}

                                    </div>
                                </div>

                                <div>
                                    {(isPerfilMedico
                                        ? this.state.botaoAnexosAtivoMedico
                                        : this.state.botaoAnexosAtivoPaciente) && (
                                            <Button
                                                visible={!btnAnexoDisabled}
                                                className="btnAnexos"
                                                type="text"
                                                placeholder="Bottom"
                                                tooltipOptions={{ position: "bottom" }}
                                                icon="custom-icon"
                                                tooltip="Anexos"
                                                iconpos="right"
                                                label={this.state.labelBotaoAnexos || "Anexos"}
                                                onClick={() => this.handleAbrirModalGenerica(pedido, 'Anexos')}
                                            />
                                        )}
                                </div>

                                <div style={{ display: ServiceLogin.getNaoPodeVisualizarComentarios() || btnImageDisable ? "none" : "block" }}>

                                    {isPerfilMedico && this.state.botaoParecerAtivoMedico && (
                                        <Button
                                            type="text"
                                            placeholder="Bottom"
                                            tooltipOptions={{ position: "bottom" }}
                                            tooltip="Parecer Médico"
                                            icon="custom-icon"
                                            iconpos="right"
                                            label={this.state.labelBotaoParecer || "Parecer médico"}
                                            className="btnParecerMedico"
                                            onClick={() => this.handleAbrirModalGenerica(pedido, 'Parecer')}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="StudyArea-Preview">
                            <div className="StudyPreview-tablet">
                                {pedido.imagemPreviewUrl ? (
                                    <div className="StudyPreview-Image">
                                        <img
                                            src={pedido.imagemPreviewUrl}
                                            alt="Prévia do exame"
                                            onClick={() => this.handleAbrirModalGenerica(pedido, acaoPrincipalPreview)}
                                            onLoad={(e) => e.target.style.opacity = 1}
                                            style={{
                                                width: "150px",
                                                height: "160px",
                                                borderRadius: "15px",
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                opacity: 0, // começa invisível
                                                transition: "opacity 0.3s ease-in-out",
                                            }}
                                        />

                                        <div className="spinner-imagePrevew">
                                            <div className="spinner-preview" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="StudyPreview-ImgNotFound">
                                        <div className="StudyPreview-ImgNotFound-Img"> </div>
                                        <div className="StudyPreview-ImgNotFound-Txt">
                                            <p> Imagens ainda não </p>
                                            <p> estão disponíveis </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>

                    <div className="StudyArea-Right">
                        <div className="StudyPreview">
                            {pedido.imagemPreviewUrl ? (
                                <div className="StudyPreview-Image">
                                    <img
                                        src={pedido.imagemPreviewUrl}
                                        alt="Prévia do exame"
                                        onClick={() => this.handleAbrirModalGenerica(pedido, acaoPrincipalPreview)}
                                        onLoad={(e) => e.target.style.opacity = 1}
                                        style={{
                                            width: "223px",
                                            height: "232px",
                                            borderRadius: "15px",
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            opacity: 0, // começa invisível
                                            transition: "opacity 0.3s ease-in-out",
                                        }}
                                    />

                                    <div className="spinner-imagePrevew">
                                        <div className="spinner-preview" />
                                    </div>
                                </div>
                            ) : (
                                <div className="StudyPreview-ImgNotFound">
                                    <div className="StudyPreview-ImgNotFound-Img"> </div>
                                    <div className="StudyPreview-ImgNotFound-Txt">
                                        <p> Imagens ainda não </p>
                                        <p> estão disponíveis </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Panel
                    id={`panelLaudo-${pedido.Id}`}
                    className={this.state.panelVisible ? 'p-col-8' : ''}
                    style={{
                        visibility: this.mobilecheck() || this.state.panelVisible === false || this.state.selectedPedido.Id !== pedido.Id ? 'hidden' : 'visible'
                    }}

                    header={<div>
                        <div>
                            {pedido.Paciente.Nome}
                        </div>
                        <div>
                            <Button
                                icon="pi pi-window-maximize"
                                onClick={e => this.viewFullScreen(`panelLaudo-${pedido.Id}`)}
                                style={{
                                    position: "absolute",
                                    float: "right",
                                    right: this.state.isFullScreen ? "50px" : '82px',
                                    marginTop: "-25px"
                                }}
                            />
                        </div>

                        <div>
                            <Button
                                icon="pi pi-times"
                                onClick={() => this.closeModalFullScreen(`panelLaudo-${pedido.Id}`)}
                                style={{
                                    position: "absolute",
                                    float: "right",
                                    right: this.state.isFullScreen ? "7px" : "40px",
                                    marginTop: "-25px"
                                }}
                            />
                        </div>

                    </div>}
                >
                    <div id={`divLaudo-${pedido.Id}`} style={{ height: this.state.panelVisible ? '65vh' : '1px' }}></div>
                </Panel>
            </div>
        );
    }

    renderListItemExterno(pedido) {

        return (
            <div className="StudyArea--pedidoExterno">
                <div className="StudyArea-Left">
                    <div className="PacienteDados">
                        <div className="PacienteDados-Exame">
                        </div>

                        <div className="PacienteDados-Exame">
                        {this.RetPerfil() !== 'Paciente' && (
                            <>
                            <b>{pedido.Paciente.Nome}</b>
                            <b> | </b>
                            </>
                        )}
                        <b>{pedido.Procedimento.Nome}</b>
                        </div>

                        <div className="StudyArea--pedidoExterno--dados">

                            {(this.state.infoDataAtivoMedico) && (
                                <div className="DataExame">
                                    <img src={calendar} style={{ marginRight: "5px" }} /> Data: <b>{moment(pedido.DataEstudo).format("DD/MM/YYYY")}</b>
                                </div>
                            )}

                            {(this.state.infoUnidadeAtivoPaciente) && (
                                <div className="Unidade">
                                    <img src={hospital} style={{ marginRight: "5px" }} />
                                    Clínica/Hospital: <b>{pedido.Unidade.Nome}</b>
                                </div>
                            )}

                            {(this.state.infoMedSolicitanteAtivoPaciente) && (                                
                                <div className="MedicoSolicitante">
                                    <img src={doctor} style={{ marginRight: "5px" }} />
                                    {this.state.labelInfoMedSolicitante || "Médico Solicitante"} <b>{pedido.MedicoSolicitante.Nome}</b>
                                </div>
                            )}
                        </div>

                        <div className="StudyArea--pedidoExterno--buttons">

                            <div>
                                {(pedido.imagemPreviewUrl) && (
                                    <Button
                                        className="BtnImagens"
                                        type="text"
                                        placeholder="Bottom"
                                        tooltipOptions={{ position: "bottom" }}
                                        icon="custom-icon"
                                        tooltip="Imagens"
                                        iconpos="right"
                                        label="Imagens"
                                        onClick={() => this.handleAbrirModalGenerica(pedido, 'Imagens')}
                                    />
                                )}
                            </div>

                            <div>
                                {(pedido?.Files?.length > 0) && (
                                    <Button
                                        className="btnAnexos"
                                        type="text"
                                        placeholder="Bottom"
                                        tooltipOptions={{ position: "bottom" }}
                                        icon="custom-icon"
                                        tooltip="Arquivos"
                                        iconpos="right"
                                        label="Arquivos"
                                        onClick={() => this.handleAbrirModalGenerica(pedido, 'Arquivos')}
                                    />
                                )}
                            </div>
                        </div>

                    </div>
                </div>

                {pedido.imagemPreviewUrl && (
                    <div className="StudyArea-Right">
                        <div className="StudyPreview">
                            <div className="StudyPreview-Image">
                                <img
                                    src={pedido.imagemPreviewUrl}
                                    alt="Prévia do exame"
                                    onClick={() => this.handleAbrirModalGenerica(pedido, 'Imagens')}
                                    onLoad={(e) => e.target.style.opacity = 1}
                                    style={{
                                        width: "223px",
                                        height: "232px",
                                        borderRadius: "15px",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0, // começa invisível
                                        transition: "opacity 0.3s ease-in-out",
                                    }}
                                />

                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {pedido.imagemPreviewUrl && (
                    <div className="StudyArea-Preview">
                        <div className="StudyPreview-tablet">
                            <div className="StudyPreview-Image">
                                <img
                                    src={pedido.imagemPreviewUrl}
                                    alt="Prévia do exame"
                                    onClick={() => this.handleAbrirModalGenerica(pedido, 'Imagens')}
                                    onLoad={(e) => e.target.style.opacity = 1}
                                    style={{
                                        width: "160px",
                                        height: "168px",
                                        borderRadius: "15px",
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        opacity: 0, // começa invisível
                                        transition: "opacity 0.3s ease-in-out",
                                    }}
                                />

                                <div className="spinner-imagePrevew">
                                    <div className="spinner-preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderGridItem(pedido) {
        let dataEstudo = "";
        let msgLaudo = "";
        let btnLaudoDisabled = false;
        let btnImageDisable = false;
        let btnLaudoDisabledSemServico = false;
        let btnImagemDisabledSemServico = false;
        let titleBtnLaudoDisabledSemServico = "";
        let titleBtnImageDisabledSemServico = "";
        try {
            dataEstudo = new Date(pedido.DataEstudo);
            dataEstudo = moment(dataEstudo).format("DD/MM/YYYY");
            btnLaudoDisabledSemServico = this.DesabilitarBtnLaudoSemServico(pedido);
            btnLaudoDisabled = this.state.isMedico & btnLaudoDisabledSemServico ? btnLaudoDisabledSemServico : this.DesabilitarBtnLaudo(pedido);
            btnImagemDisabledSemServico = this.DesabilitarBtnImagemSemServico(pedido);
            btnImageDisable = this.state.btnImageDisable;
            msgLaudo = this.msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImagemDisabledSemServico);
            titleBtnLaudoDisabledSemServico = this.state.isMedico & btnLaudoDisabledSemServico ? 'Pedido não possui serviço vinculado' : '';
            titleBtnImageDisabledSemServico = this.state.isMedico & btnImagemDisabledSemServico ? 'Pedido não possui serviço vinculado' : '';
        } catch (ex) { console.log(ex); }

        const NOMEBOTAO = JSON.parse(sessionStorage.getItem('config'));

        return (
            <div style={{ padding: ".5em" }}>
                <Panel
                    header={
                        pedido.Procedimento.Modalidade.Abreviacao +
                        " - " +
                        pedido.Procedimento.Nome
                    }
                    style={{ textAlign: "center", width: "380px" }}
                >
                    <div style={{ padding: "10px" }}>
                        <div className="car-details">
                            <div
                                style={{ display: this.state.isMedico ? "block" : "none" }}
                                className="p-col-12"
                            >
                                <b>{pedido.Paciente.Nome}</b>
                            </div>
                        </div>
                        <div style={{ display: pedido.Unidade.Veterinaria ? 'block' : 'none' }}>
                            <div className="p-col-12">
                                Tutor: <b>{pedido.Tutor}</b>
                            </div>
                            <div className="p-col-12">
                                Raça: <b>{pedido.Raca}</b>
                            </div>
                            <div className="p-col-12">
                                Espécie: <b>{pedido.Especie}</b>
                            </div>
                        </div>
                        <div className="p-col-12">
                            Data: <b>{dataEstudo}</b>
                        </div>
                        <div className="p-col-12">
                            Prontuário: <b>{pedido.Prontuario}</b>
                        </div>
                        <div className="p-col-12">
                            Ac. Number: <b>{pedido.AcNumber}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Solicitante: <b>{pedido.MedicoSolicitante.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Executante: <b>{pedido.MedicoExecutante.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Revisor: <b>{pedido.MedicoRevisor.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Unidade: <b>{pedido.Unidade.Nome}</b>
                        </div>
                    </div>

                    <hr className="ui-widget-content" style={{ borderTop: 0 }} />

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: this.mobilecheck() ? "auto 40px 40px 40px 40px 40px 40px" : "auto 40px 40px 40px 40px 40px 40px 40px 40px",
                            columnGap: "5px"
                        }}
                    >

                        <Button
                            className="p-button btnGreen"
                            disabled={btnLaudoDisabled}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Visualizar Laudo" icon="pi pi-file"
                            style={{ width: "40px", height: "40px", fontSize: "20px" }}
                            onClick={() =>
                                this.handleAbrirLaudo(pedido)
                            }
                            title={titleBtnLaudoDisabledSemServico}
                        />

                        <Button
                            className="p-button iconDicom"
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Visualizar Exame" label=""
                            style={{ width: "40px", height: "40px", fontSize: "20px", display: 'block' }}
                            onClick={() => this.handleAbrirImagem(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <Button
                            className="p-button"
                            disabled={btnLaudoDisabled}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Imprimir Laudo"
                            icon="pi pi-print"
                            style={{ width: "40px", height: "40px", fontSize: "20px", display: this.mobilecheck() ? 'none' : 'block' }}

                            onClick={() => this.handleImprimirLaudo(pedido)}
                            title={titleBtnLaudoDisabledSemServico}
                        />

                        <Button
                            className="p-button"
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip={NOMEBOTAO ? NOMEBOTAO.NomeBotaoImprimirPortal : "Imprimir Imagem"} icon="pi pi-images"
                            style={{ width: "40px", height: "40px", fontSize: "20px" }}
                            onClick={() => this.handleAbrirGaleriaDeImagens(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <Button
                            className="p-button"
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Baixar Imagens" icon="pi pi-download"
                            style={{ width: "40px", height: "40px", fontSize: "20px", display: this.mobilecheck() ? "none" : "block" }}
                            onClick={() => this.handleBaixarImagem(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <div style={{ display: this.state.isExecutante ? "block" : "none" }}>

                            <Button
                                className="p-button"
                                disabled={btnLaudoDisabled}
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Anexos" icon="pi pi-paperclip"
                                onClick={() => this.visualizarListaAnexos(pedido)}
                                title={titleBtnLaudoDisabledSemServico}
                            />

                        </div>

                        <div style={{ display: pedido.CompartilharPortal && this.state.isAcessoCompartilhado === false ? "block" : "none" }}>

                            <Button
                                className="p-button"
                                disabled={btnLaudoDisabled}
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Compartilhar" icon="pi pi-share-alt"
                                onClick={() => this.openModalCompartilhar(pedido)}
                                title={titleBtnLaudoDisabledSemServico}
                            />

                        </div>

                        <div style={{ display: ServiceLogin.getNaoPodeVisualizarComentarios() ? "none" : "block" }}>
                            {((this.RetPerfil() === "Médico Executante") || (this.RetPerfil() === "Médico Solicitante")) && (
                                <Button
                                    className="p-button"
                                    type="text"
                                    placeholder="Bottom"
                                    tooltipOptions={{ position: "bottom" }}
                                    tooltip="Parecer Médico" icon="pi pi-comment"
                                    onClick={() => this.openDialogParecer(pedido)}
                                />
                            )}
                        </div>

                    </div>

                </Panel>
            </div>
        );
    }

    itemTemplate(pedido, layout) {

        if (!pedido) return null;

        if (pedido.Tipo === "externo") {
            return this.renderListItemExterno(pedido);
        } else {
            return this.renderListItem(pedido);
        }
    }

    renderPedidoDialogContent() {
        if (this.state.selectedPedido) {
            return (
                <div
                    className="p-grid"
                    style={{ fontSize: "16px", textAlign: "center", padding: "20px" }}
                >
                    <div className="p-col-12" style={{ textAlign: "center" }}>
                        {/* <img src={'showcase/resources/demo/images/car/${this.state.selectedCar.brand}.png'} alt={this.state.selectedCar.brand} /> */}
                    </div>
                    <div className="p-col-4">Paciente: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.Paciente?.Nome || ''}
                    </div>

                    <div className="p-col-4">Procedimento: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.Procedimento?.Nome || ''}
                    </div>

                    <div className="p-col-4">Medico Executante: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.MedicoExecutante?.Nome || ''}
                    </div>

                    <div className="p-col-4">Medico Revisor: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.MedicoRevisor?.Nome || ''}
                    </div>

                    <div className="p-col-4">Modalidade: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.Modalidade?.Nome || ''}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderHeaderFilter() {
        if (this.state.isAcessoCompartilhado) {
            return null;
        }

        const classeFiltro = `filter-bar ${this.state.mostrarFiltro ? 'aberto' : ''}`;

        const periodoOptions = [
            { label: 'Personalizado', value: 'personalizado' },
            { label: 'Últimos 30 dias', value: 'ultimos30' },
            { label: 'Últimos 90 dias', value: 'ultimos90' }
        ];

        return (
            <div className={classeFiltro}>

                <div className="filter-bar__left" onKeyDown={this.handleFilterKeyDown}>

                    {this.RetPerfil() !== "Médico Executante" && (
                        <div className="filter-bar__search">
                            <p className="filter-bar__search-label">Nome do exame</p>
                            <InputText
                                className="filter-bar__search-input"
                                value={this.state.nomeExame}
                                onChange={(e) => this.setState({ nomeExame: e.target.value })}
                            />
                        </div>
                    )}

                    {this.RetPerfil() === "Médico Executante" && (
                        <div className="filter-bar__search">
                            <p className="filter-bar__search-label">Paciente, AcNumber</p>
                            <InputText
                                className="filter-bar__search-input"
                                value={this.state.nomeExame}
                                onChange={(e) => this.setState({ nomeExame: e.target.value })}
                            />
                        </div>
                    )}

                    <div className="filter-bar__range-desktop">
                        <p className="filter-bar__range-label">Período</p>
                        <Dropdown
                            className="filter-bar__range-dropdown"
                            value={this.state.periodoSelecionado}
                            options={periodoOptions}
                            optionLabel="label"
                            optionValue="value"
                            onChange={this.handlePeriodoChange}
                        />
                    </div>


                </div>

                <div className="filter-bar__right" onKeyDown={this.handleFilterKeyDown}>
                    <div className="filter-bar__calendar-container">
                        <div className="filter-bar__periodo-range-tablet">
                            <p className="filter-bar__range-label">Período</p>
                            <Dropdown
                                className="filter-bar__range-dropdown"
                                value={this.state.periodoSelecionado}
                                options={periodoOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.handlePeriodoChange}
                            />
                        </div>

                        <div className="filter-bar__calendar">
                            <p className="filter-bar__calendar-label">Data inicial</p>
                            <Calendar
                                className={`filter-bar__calendar-input ${this.state.dataInicialInvalida ? 'filter-bar__calendar--invalid' : ''}`}
                                value={this.state.dataInicial}
                                dateFormat="dd/mm/yy"
                                onChange={this.handleDataInicialChange}
                            />
                        </div>

                        <div className="filter-bar__calendar">
                            <p className="filter-bar__calendar-label">Data final</p>
                            <Calendar
                                className={`filter-bar__calendar-input ${this.state.dataFinalInvalida ? 'filter-bar__calendar--invalid' : ''}`}
                                value={this.state.dataFinal}
                                dateFormat="dd/mm/yy"
                                onChange={this.handleDataFinalChange}
                            />
                        </div>
                    </div>

                    <div className="filter-bar__actions">

                        <div className="filter-bar__externos">
                            <p className="filter-bar__externos-label">Exames incluídos</p>

                            <InputSwitch
                                className={'filter-bar__externos-switch'}
                                checked={this.state.pesquisarExamesExternos}
                                onChange={this.handlePesquisarExamesExternos}
                            />
                        </div>

                        <div className="filter-bar__clear">
                            <Button
                                className="filter-bar__button--clear"
                                label={
                                    <span className="filter-bar__button--clear-label">
                                        <span className={`filter-bar__icon--rotating ${this.state.girando ? 'rotating' : ''}`} />
                                        Limpar
                                    </span>
                                }
                                onClick={() => {
                                    this.setState({
                                        dataInicialInvalida: false,
                                        dataFinalInvalida: false,
                                        nomeExame: '',
                                        modalidadeSelecionada: 'todas',
                                        periodoSelecionado: 'ultimos30',
                                        dataInicial: (() => {
                                            const date = new Date();
                                            date.setDate(date.getDate() - 30);
                                            return date;
                                        })(),
                                        dataFinal: new Date(),
                                        girando: true
                                    }, () => {
                                        // chama o buscar logo após resetar tudo
                                        this.handleBuscarClick();
                                    });

                                    setTimeout(() => this.setState({ girando: false }), 600);
                                }}                                
                            />
                        </div>

                        <div className="filter-bar__search-button-container">
                            <Button label="Buscar" onClick={this.handleBuscarClick} />
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    renderHeaderTopInfo() {
        const isAcessoCompartilhado = this.state.isAcessoCompartilhado;

        const {
            isMedico,
            isExecutante,
            isConvenio
        } = this.state;

        const isPerfilMedico = isMedico || isExecutante;

        return (
            <div className="results-header">

                <div className="results-header__title">

                    <span id="perfil"> </span>

                    <p>Exames</p>
                </div>

                <div className="results-header__actions">

                    {/*<div style={{ display: this.state.isMedico ? "none" : "block" }}>*/}

                    {this.RetPerfil() !== "Convênio" &&
                        !isAcessoCompartilhado &&
                        (isPerfilMedico ? this.state.botaoIncluirExamesAtivoMedico : this.state.botaoIncluirExamesAtivoPaciente) && 
                            (
                                <Button
                                    label={
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span className="icon-anexos" />
                                            Incluir exames
                                        </span>
                                    }
                                    className="results-header__button--external-exam"
                                    onClick={() => this.handleAbrirModalExamesExternos('Exames externos')}
                                />
                            )
                    }
                        
                    {/*</div>*/}

                    {!isAcessoCompartilhado && (
                        <div className="results-header__sort">
                            {this.FiltroDropdown()}
                        </div>
                    )}

                    {!isAcessoCompartilhado && (
                        <div className="results-header__toggle-filters">
                            <Button
                                aria-label="Filter"
                                onClick={this.toggleFiltro}
                                className={`p-button ${this.state.mostrarFiltro ? 'ativo' : ''}`}
                            />
                        </div>
                    )}

                </div>
            </div>
        )
    }

    renderHeaderLista() {

        //if (this.state.isMedico || ServiceLogin.isConvenio()) {

        //    return (
        //        <div className="filtroForm">
        //            <ComponentsPedidoFiltroForm
        //                mobilecheck={this.mobilecheck}
        //                onSortChange={this.onSortChange}
        //                sortKey={this.state.sortKey}
        //                onChangeDataViewLayoutOptions={value => this.onChangeDataViewLayoutOptions(value)}
        //                layout={this.state.layout}
        //                filtro={this.pedidoFiltro}
        //                onExecute={this.onExecuteFiltro.bind(this)}
        //                style={{ width: "100%" }}
        //            />
        //        </div>
        //    );
        //}
    }

    renderHeaderAnexoDiagnostico() {
        return (
            <div>
                <div>
                    <span>Anexo Diagnóstico</span>
                </div>
                <Button
                    icon="pi pi-times"
                    onClick={e => this.setState({ panelAnexoVisible: false })}
                    style={{
                        position: "absolute",
                        float: "right",
                        right: "22px",
                        marginTop: "-25px"
                    }}
                />
            </div>
        );
    }

    renderPainelAnexoDiagnostico() {

        if (this.state.panelAnexoVisible) {

            const caminho = `${this.state.caminhoServico}api/Anexo/GetAnexoPortal/${this.state.selectedPedido.Id}`;
            const embed = `<embed src="${caminho}" width="100%" height="100%" />`;
            return (
                <div className={this.state.panelAnexoVisible ? "p-col-7" : ""}>
                    <Panel
                        header={this.renderHeaderAnexoDiagnostico()}
                        style={
                            this.state.panelAnexoVisible
                                ? { visibility: "visible" }
                                : { visibility: "hidden" }
                        }
                    >
                        <div>
                            <ComponentEmbed
                                embed={embed}
                                id={this.state.selectedPedido.IdExterno}
                            />
                        </div>
                    </Panel>
                </div>
            );
        } else return null;
    }

    renderFooter(name) {
        return (
            <div>
                <Button label="Sim" icon="pi pi-check" onClick={() => { this.confirmaImprimirLaudo(true); this.onHide(name); }} autoFocus />
                <Button label="Não" icon="pi pi-times" onClick={() => { this.confirmaImprimirLaudo(false); this.onHide(name); }} className="p-button-text" />
            </div>
        );
    }

    renderFooterCancelar(name) {
        return (
            <div>
                <Button label="Cancelar" icon="pi pi-times" onClick={() => { this.onHide(name); }} className="p-button-text" />
            </div>
        );
    }

    dataEstudoImagemVinculada(rowData) {
        const date = new Date(rowData.DataEstudo);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        const formattedDate = date.toLocaleString([], options);

        return (
            <>
                <span className="p-column-title">Data</span>
                {formattedDate}
            </>
        )
    }

    idLaudoImagemVinculada(rowData) {
        return (
            <>
                <span className="p-column-title">ID</span>
                {rowData.Id}
            </>
        )
    }

    procedimentoImagemVinculada(rowData) {
        return (
            <>
                <span className="p-column-title">Procedimento</span>
                {rowData.ProcedimentoNome}
            </>
        )
    }

    modalidadeImagemVinculada(rowData) {
        return (
            <>
                <span className="p-column-title">Modalidade</span>
                {rowData.ModalidadeNome}
            </>
        )
    }

    botaoVisualizarImagemVinculada = (rowData) => {
        const abreImagemDoPedidoSelecionado = () => {
            let _viewer = rowData.VisualizadorPortal.replace('{STUDYUID}', rowData.StudyUid);
            _viewer = _viewer.replace('{STUDYID}', rowData.StudyId);

            const embedRemove = document.getElementsByTagName('embed');

            if (embedRemove.length > 0) {
                for (let index = 0; index < embedRemove.length; index++)
                    embedRemove[index].remove();
            }

            let pedido = rowData;
            pedido.Modalidade = { Nome: rowData.ModalidadeNome };
            pedido.Procedimento = { Nome: rowData.ProcedimentoNome };
            pedido.MedicoExecutante = this.state.pedidoComImagemVinculadaMedicoExecutante;
            pedido.MedicoRevisor = this.state.pedidoComImagemVinculadaMedicoRevisor;
            pedido.Id = this.state.pedidoComImagemVinculadaId;
            this.handleAbrirImagem(pedido);
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button label={"Visualizar"} icon="pi pi-eye" onClick={abreImagemDoPedidoSelecionado}></Button>
            </div>
        );
    };

    renderHeaderAnexoDiagnostico() {
        return (<div> <i className="pi pi-paperclip"></i> Anexos </div>)
    }

    renderFooterAnexo(name) {
        return (
            <div>
                <Button label="Fechar" icon="pi pi-times" onClick={() => this.onHide(name)} className="p-button-text" />
            </div>
        );
    }

    nomeArquivoAnexoMob(rowData) {
        return <div style={{ display: "flex", alignItems: "center" }}>
            <img src={require('./../images/pdf.png')} style={{ width: "24px", height: "24px", marginRight: "5px" }} />
            <span style={{ marginTop: "7px" }}>{rowData.Nome.slice(0, 15) + (rowData.Nome.length > 15 ? "..." : "")}</span>
            <div className={`anexo status-${rowData.TipoAnexo}`}
                style={{ padding: '5px', textAlign: 'center', marginLeft: '5px', fontSize: '10px' }}
            >{rowData.TipoAnexo === 0 ? 'Normal' : 'Diagnóstico'}</div>
        </div>
    }

    nomeArquivoAnexo(rowData) {
        return <div style={{ display: "flex", alignItems: "center" }}>
            <img src={require('./../images/Icons/icone-pdf-azul.svg')} style={{ width: "24px", height: "24px", marginRight: "5px" }} />
            <span style={{ marginTop: "7px" }}>{rowData.Nome}</span>
        </div>
    }

    statusTipoAnexo(rowData) {
        let _tipoAnexo = "";
        switch (rowData.TipoAnexo) {
            case 0:
                _tipoAnexo = "Normal";
                break;
            case 1:
                _tipoAnexo = "Diagnóstico";
                break;
            case 2:
                _tipoAnexo = "Anamnese";
                break;
            case 3:
                _tipoAnexo = "Ped. Médico";
                break;
            case 4:
                _tipoAnexo = "Modelo 3D";
                break;
        }
        return <div style={{ textAlign: "center" }}>
            <div className={`anexo status-${rowData.TipoAnexo}`}>{_tipoAnexo}</div>
        </div>;
    }

    statusPrioridade(rowData) {
        let prioridadeTexto = "";

        switch (rowData.Prioridade) {
            case 'Alta':
                prioridadeTexto = "Alta";
                break;
            case 'Média':
                prioridadeTexto = "Média";
                break;
            case 'Baixa':
                prioridadeTexto = "Baixa";
                break;
            default:
                prioridadeTexto = "Sem Prioridade";
                break;
        }

        return (
            <div style={{ textAlign: "center" }}>
                <div className={`parecerStatus status-${rowData.Prioridade?.toLowerCase()}`}>
                    {prioridadeTexto}
                </div>
            </div>
        );
    }

    async visualizarAnexo(rowData) {
        try {
            const url = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;

            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (isIOS) {
                // Abre direto — Safari mostrará o PDF/arquivo e o usuário pode "Salvar em Arquivos"
                this.downloadAnexo(rowData);
                return;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: ServiceApi._getHeaders().headers
            });

            if (!response.ok) {
                throw new Error("Erro ao buscar anexo");
            }

            const contentType = response.headers.get("Content-Type") || "application/octet-stream";

            const blob = await response.blob();
            const fileURL = URL.createObjectURL(blob);

            if (contentType.startsWith("application/pdf") || contentType.startsWith("image/")) {
                window.open(fileURL, "_blank");
            } else {
                const link = document.createElement("a");
                link.href = fileURL;
                link.download = rowData.Nome || "arquivo";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            let operacao = rowData.TipoAnexo === 1 ? 36 : 34;
            this.AdicionarHistoricoAcoes(operacao, this.state.selectedPedido.Id, this.state.selectedPedido.Tipo);
        } catch (error) {
            console.error("Erro ao visualizar anexo:", error);
        }
    }


    async downloadAnexo(anexo) {
        try {
            const url = `${this.state.caminhoServico}api/Anexo/GetAnexo/${anexo.Id}`;
            const response = await fetch(url, {
                method: "GET",
                headers: ServiceApi._getHeaders().headers
            });

            if (!response.ok) throw new Error("Erro ao baixar o anexo");

            const data = await response.blob();

            const contentType = response.headers.get("Content-Type") || "application/octet-stream";
            const file = new Blob([data], { type: contentType });

            const fileName = anexo.Nome.replace(anexo.TipoArquivo, "") + anexo.TipoArquivo;

            const fileURL = URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // libera memória depois de 10s
            setTimeout(() => URL.revokeObjectURL(fileURL), 10000);

        } catch (error) {
            alert("Erro ao baixar o anexo.");
            console.error(error);
        }
    };

    async iphoneDownloadWarning() {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS) {
            alert("O download será aberto em uma nova aba. Para salvar, toque em 'Compartilhar' e escolha 'Salvar em Arquivos'.");
        }
    }
    
    btnAnexoAcoes(pedido, rowData) {
        const isStl = rowData?.Nome?.toLowerCase().endsWith('.stl');

        if (isStl) {
            return (
                <div style={{ textAlign: "center", display: 'flex' }}>
                    <Button label=""
                        onClick={() => this.visualizarAnexoStl(pedido)}
                        className="buttonAnexoView" style={{ marginRight: "5px" }} />
                </div>
            );
        }

        return (
            <div style={{ textAlign: "center", display: 'flex' }}>
                <Button label=""
                    onClick={() => this.visualizarAnexo(rowData)}
                    className="buttonAnexoView" style={{ marginRight: "5px" }} />
                <Button
                    label=""
                    onClick={() => {
                        this.iphoneDownloadWarning();
                        this.downloadAnexo(rowData);
                    }}
                    className="buttonAnexoDownload"
                />
            </div>
        );
    }


    tamanhoArquivoKB(rowData) {
        // Se já tiver o tamanho salvo, usa ele
        if (rowData.tamanhoKB) {
            return <span style={{ marginLeft: "10px" }}>{rowData.tamanhoKB.toFixed(0)} KB</span>;
        }

        // Se ainda não tiver, tenta buscar e salvar o tamanho
        if (!rowData._fetchingSize) {
            rowData._fetchingSize = true; // evita chamadas duplicadas

            const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;
            var xhr = new XMLHttpRequest();
            xhr.open('GET', downloadUrl, true);
            xhr.responseType = 'blob';

            // 👇 Insere os headers de autenticação igual ao outro método
            const headers = ServiceApi._getHeaders().headers;
            xhr.setRequestHeader('user', headers.user);
            xhr.setRequestHeader('Cnonce', headers.Cnonce);
            xhr.setRequestHeader('Token', headers.Token);
            xhr.setRequestHeader('TokenPortal', headers.TokenPortal);
            xhr.setRequestHeader('isPacientePortal', headers.isPacientePortal);
            xhr.setRequestHeader('isConvenioPortal', headers.isConvenioPortal);

            xhr.onload = function () {
                if (xhr.status === 200) {
                    const blob = xhr.response;
                    const tamanhoKB = blob.size / 1024;

                    // Atualiza diretamente o objeto da linha com o tamanho
                    rowData.tamanhoKB = tamanhoKB;

                    // Força re-render da tabela
                    this.setState({ listaAnexos: [...this.state.listaAnexos] });
                } else {
                    console.error("Erro ao buscar tamanho do anexo:", xhr.status);
                }
            }.bind(this);

            xhr.onerror = function () {
                console.error("Erro de rede ao buscar tamanho do anexo.");
            };

            xhr.send();
        }

        return <span> </span>;
    }

    btnAnexoAcoesMob(rowData) {
        return <div style={{ textAlign: "center", display: 'grid', gridTemplateRows: 'auto auto', rowGap: '5px' }}>
            <Button label="" tooltip="Visualizar" onClick={() => this.visualizarAnexo(rowData)} icon="custom-icon" className="p-button p-button-secondary" style={{ marginRight: "5px" }} />
            <Button label="" tooltip="Download" onClick={() => this.downloadAnexo(rowData)} icon="custom-icon" className="p-button p-button-secondary" />
        </div>;
    }

    buildViewerUrl = (pedido) => {
        let _viewer = pedido.Unidade.VisualizadorPortal.replace('{STUDYUID}', pedido.StudyUid);
        const parametro = _viewer.indexOf('/viewer/') > 0 ? '?' : '&';
        _viewer = _viewer.replace('{STUDYID}', pedido.StudyId);

        const headers = ServiceApi._getHeaders().headers;
        const isSolicitante = sessionStorage.getItem("perfil") === "Solicitante";

        _viewer += `${parametro}acessoportal=1`
            + `&User=${headers.user}`
            + `&Token=${headers.Token}`
            + `&Cnonce=${headers.Cnonce}`
            + `&TokenPortal=${headers.TokenPortal}`
            + `&isPacientePortal=${headers.isPacientePortal}`
            + `&isConvenioPortal=${headers.isConvenioPortal}`
            + `&isSolicitantePortal=${isSolicitante}`;
        return _viewer;
    };

    renderZipandoDicom() {
        return (
            <Dialog
                className="processing-modal--zip"
                header="Compactando Arquivos DICOM"
                visible={this.state.zipandoDicom}
                modal
                closable={false}
            >
                <div>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2em', marginBottom: '20px' }} />
                    <p>Compactando e preparando os arquivos DICOM...</p>
                </div>
            </Dialog>
        );
    }

    renderResultadoInclusao() {
        const { resultadoInclusaoVisivel, resultadoInclusaoMensagem, resultadoInclusaoTipo } = this.state;

        return (
            <Dialog
                header="Inclusão de exames"
                visible={resultadoInclusaoVisivel}
                modal
                closable={false}
                className="action-feedback-modal--inclusion"
                footer={
                    <div>
                        {resultadoInclusaoTipo !== 'carregando' && (
                            <Button
                                label="OK"
                                className={resultadoInclusaoTipo === 'erro' ? 'p-button-danger' : 'p-button-success'}
                                onClick={() => {
                                    this.setState({ resultadoInclusaoVisivel: false }, () => {
                                        this.componentDidMount();
                                    });
                                }}
                            />
                        )}
                    </div>
                }
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {resultadoInclusaoTipo === 'carregando' ? (
                        <>
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                            <p style={{ marginTop: '10px' }}>{resultadoInclusaoMensagem}</p>
                        </>
                    ) : (
                        <p>{resultadoInclusaoMensagem}</p>
                    )}
                </div>
            </Dialog>
        );
    }

    headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton, element } = options;

        return (
            <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}

                <Button
                    type="button"
                    label="Tirar Foto"
                    icon="pi pi-camera"
                    className="p-button-secondary BotaoCamera"
                    onClick={() => this.cameraInputRef && this.cameraInputRef.click()}
                />

                <input
                    ref={(el) => (this.cameraInputRef = el)}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                        const files = e.target.files;
                        if (files && files.length > 0) {
                            const fileList = Array.from(files);

                            // Cria objeto de evento semelhante ao onSelect
                            this.handleArquivoSelecionado({ files: fileList });

                            // limpa o input pra nova foto
                            e.target.value = '';
                        }
                    }}
                />


                {element}
            </div>
        );
    };

    renderAcoesDaModal = (pedido) => {
        const { modalOpcaoSelecionada } = this.state;

        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const isAcessoCompartilhado = auth.TokenPortal ? true : false;

        const {
            isMedico,
            isExecutante,
            isConvenio
        } = this.state;

        const isPerfilMedico = isMedico || isExecutante;

        const acaoVisualizadorAtiva = isPerfilMedico
            ? this.state.acaoBaixarImagens_visualizador_Medico
            : this.state.acaoBaixarImagens_visualizador_Paciente;

        const acaoDicomZipAtiva = isPerfilMedico
            ? this.state.acaoBaixarImagens_dicomZip_Medico
            : this.state.acaoBaixarImagens_dicomZip_Paciente;

        // quantidade de ações disponíveis
        const totalAcoesAtivas = [acaoVisualizadorAtiva, acaoDicomZipAtiva].filter(Boolean).length;

        return (
            <>
                {/* Ações da Galeria */}
                <div
                    className="ModalNavegacao-Acoes-Galeria"
                    style={{ display: (modalOpcaoSelecionada === 'Galeria' && pedido.possuiJob == false) ? 'block' : 'none' }}
                >
                    <h2 className="Titulo-Navegacao-Acoes">
                        Baixe ou compartilhe as imagens
                    </h2>
                    <p className="Texto-Navegacao-Acoes">
                        Faça o download das imagens agora mesmo, em zip, ou com o visualizador.
                    </p>
                    <p className="Texto-Navegacao-Acoes">
                        Compartilhe este estudo com seu médicos.
                    </p>

                    <div className="ModalNavegacao-Acoes-Laudo-buttons">
                        {!isAcessoCompartilhado && (
                            <div>
                                {(
                                    isPerfilMedico
                                        ? this.state.botaoCompartilharAtivoMedico
                                        : this.state.botaoCompartilharAtivoPaciente
                                ) && (
                                    <Button
                                        className={`Button-modal-actions ${this.state.modalOpcaoSelecionada === 'Compartilhar' ? 'buttom-modal-selected' : ''}`}

                                        label={
                                            <span className="label-button-content">
                                                <span
                                                    className="icon-navegacao"
                                                    style={{ backgroundImage: `url(${icoCompartilharBranco})` }}
                                                />
                                                {this.state.labelBotaoCompartilhar || "Compartilhar"}
                                            </span>
                                        }
                                        onClick={() => this.setState({ modalOpcaoSelecionada: 'Compartilhar', mostrarModalAcoesMobile: false })}
                                    />
                                )}
                            </div>
                        )}

                        <div>
                            {totalAcoesAtivas === 2 && (
                                <SplitButton
                                    className="Button-modal-actions--downlod-images"
                                    label={
                                        <span className="label-button-content">
                                            <span
                                                className="icon-navegacao"
                                                style={{ backgroundImage: `url(${icoDowndloadBranco})` }}
                                            />
                                            {this.state.lblbtnDownloadVisualizador || "Baixar imagens"}
                                        </span>
                                    }
                                    onClick={() => this.handleBaixarImagem(pedido)}
                                    iconpos="right"
                                    appendTo="self"
                                    tooltipOptions={{ position: "bottom" }}
                                    model={[
                                        {
                                            visible: acaoDicomZipAtiva,
                                            label: this.state.lblbtnDownloadDicomZip || "Baixar DICOM.zip",
                                            icon: (
                                                <img
                                                    src={downloadDicomZip}
                                                    alt="Baixar Imagens"
                                                    style={{ width: "20px", height: "20px", marginRight: "8px" }}
                                                />
                                            ),
                                            command: () => this.handleBaixarDicomZip(pedido),
                                        },
                                    ]}
                                />
                            )}

                            {totalAcoesAtivas === 1 && (
                                <Button
                                    className="Button-modal-actions--downlod-images"
                                    label={
                                        <span className="label-button-content">
                                            <span
                                                className="icon-navegacao"
                                                style={{ backgroundImage: `url(${icoDowndloadBranco})` }}
                                            />
                                            {acaoVisualizadorAtiva
                                                ? this.state.lblbtnDownloadVisualizador || "Baixar imagens"
                                                : this.state.lblbtnDownloadDicomZip || "Baixar DICOM.zip"}
                                        </span>
                                    }
                                    onClick={() =>
                                        acaoVisualizadorAtiva
                                            ? this.handleBaixarImagem(pedido)
                                            : this.handleBaixarDicomZip(pedido)
                                    }
                                />
                            )}
                        </div>

                    </div>
                </div>

                {/* Ações da Galeria Externos*/}
                <div
                    className="ModalNavegacao-Acoes-Galeria-externo"
                    style={{ display: modalOpcaoSelecionada === 'Imagens' ? 'block' : 'none' }}
                >
                    <h2 className="Titulo-Navegacao-Acoes">
                        Observação
                    </h2>
                    <p className="Texto-Navegacao-Acoes">
                        As imagens apresentadas foram incluídas pelo próprio paciente,
                    </p>
                    <p className="Texto-Navegacao-Acoes">
                        sendo seu conteúdo de inteira responsabilidade do mesmo.
                    </p>
                </div>

                {/* Ações do Laudo */}
                <div
                    className="ModalNavegacao-Acoes-Laudo"
                    style={{
                        display: (modalOpcaoSelecionada === 'Laudo' || modalOpcaoSelecionada === 'Compartilhar' || modalOpcaoSelecionada === 'Exames externos') ? 'block' : 'none'
                    }}
                >
                   
                    {this.mostrarBotaoLaudoNaModal(this.state.pedidoModalOpcoes) && (
                        <div>
                            <h2 className="Titulo-Navegacao-Acoes">
                                Imprima, baixe ou compartilhe este laudo
                            </h2>
                            <p className="Texto-Navegacao-Acoes">
                                Imprima, compartilhe ou baixe o laudo no formato .pdf
                            </p>

                            <div className="ModalNavegacao-Acoes-Laudo-buttons">

                                <div>
                                    {(
                                        isPerfilMedico
                                            ? this.state.botaoImprimirLaudoAtivoMedico
                                            : this.state.botaoImprimirLaudoAtivoPaciente
                                    ) && (
                                        <Button
                                            className="Button-modal-actions"
                                            label={
                                                <span className="label-button-content">
                                                    <span
                                                        className="icon-navegacao"
                                                        style={{ backgroundImage: `url(${icoImpressoraBranco})` }}
                                                    />
                                                    {this.state.labelBotaoImprimirLaudo || "Imprimir laudo"}
                                                </span>
                                            }
                                            onClick={() => {
                                                const iframe = document.querySelector('.ModalVisualizador iframe');
                                                if (iframe && iframe.contentWindow) {
                                                    iframe.contentWindow.focus();
                                                    iframe.contentWindow.print();
                                                } else {
                                                    alert('O laudo ainda não foi carregado ou não está disponível para impressão.');
                                                }
                                            }}
                                        />
                                        )}
                                </div>

                                {!isAcessoCompartilhado && (
                                    <div>
                                        {(
                                            isPerfilMedico
                                                ? this.state.botaoCompartilharAtivoMedico
                                                : this.state.botaoCompartilharAtivoPaciente
                                        ) && (
                                            <Button
                                                className={`Button-modal-actions ${this.state.modalOpcaoSelecionada === 'Compartilhar' ? 'buttom-modal-selected' : ''}`}

                                                label={
                                                    <span className="label-button-content">
                                                        <span
                                                            className="icon-navegacao"
                                                            style={{ backgroundImage: `url(${icoCompartilharBranco})` }}
                                                        />
                                                        {this.state.labelBotaoCompartilhar || "Compartilhar"}
                                                    </span>
                                                }
                                                onClick={() => this.setState({ modalOpcaoSelecionada: 'Compartilhar', mostrarModalAcoesMobile: false })}
                                            />
                                            )}
                                    </div>

                                )}

                                <Button
                                    className="Button-modal-actions"
                                    label={
                                        <span className="label-button-content">
                                            <span
                                                className="icon-navegacao"
                                                style={{ backgroundImage: `url(${icoPdfBranco})` }}
                                            />
                                            {this.state.labelBotaoBaixarLaudoPdf || "Fazer download"}
                                        </span>
                                    }
                                    onClick={() => {
                                        const iframe = document.querySelector('.ModalVisualizador iframe');
                                        if (iframe && iframe.src) {
                                            const link = document.createElement('a');
                                            link.href = iframe.src;
                                            link.download = 'Laudo.pdf';  // Define o nome padrão do arquivo baixado
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        } else {
                                            alert('O laudo ainda não foi carregado ou não está disponível para download.');
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {!this.mostrarBotaoLaudoNaModal(this.state.pedidoModalOpcoes) && (
                        <div style={{marginTop: '20%'} }>
                            <h2 className="Titulo-Navegacao-Acoes">
                                Compartilhe este estudo
                            </h2>
                            <p className="Texto-Navegacao-Acoes">
                                Compartilhe o acesso a este estudo com seus médicos
                            </p>

                            <div className="ModalNavegacao-Acoes-Laudo-buttons">
                                {!isAcessoCompartilhado && (
                                    <Button
                                        className={`Button-modal-actions ${this.state.modalOpcaoSelecionada === 'Compartilhar' ? 'buttom-modal-selected' : ''}`}

                                        label={
                                            <span className="label-button-content">
                                                <span
                                                    className="icon-navegacao"
                                                    style={{ backgroundImage: `url(${icoCompartilharBranco})` }}
                                                />
                                                {this.state.labelBotaoCompartilhar || "Compartilhar"}
                                            </span>
                                        }
                                        onClick={() => this.setState({ modalOpcaoSelecionada: 'Compartilhar', mostrarModalAcoesMobile: false })}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* Ações Anexo e Parecer */}
                <div
                    className="ModalNavegacao-Acoes-Parecer"
                    style={{
                        display: (modalOpcaoSelecionada === 'Parecer' || modalOpcaoSelecionada === 'Anexos') ? 'block' : 'none'
                    }}
                >
                    <div style={{ display: "flex" }}>

                        <div>
                            <h2 className="Titulo-Navegacao-Acoes">
                                Baixe as imagens .dicom e o visualizador em pasta .zip
                            </h2>
                            <p className="Texto-Navegacao-Acoes">
                                Para ter acesso às imagens em
                                formato ".dicom" no seu computador,
                                é necessário ter o software instalado
                            </p>

                            <Button
                                className="Button-modal-actions"
                                label={
                                    <span className="label-button-content">
                                        <span
                                            className="icon-navegacao"
                                            style={{ backgroundImage: `url(${icoBaixarZip})` }}
                                        />
                                        Baixar pasta
                                    </span>
                                }
                                onClick={() => {
                                    const iframe = document.querySelector('.ModalVisualizador iframe');
                                    if (iframe && iframe.contentWindow) {
                                        iframe.contentWindow.focus();
                                        iframe.contentWindow.print();
                                    } else {
                                        alert('O laudo ainda não foi carregado ou não está disponível para impressão.');
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* Ações Arquivos */}
                <div
                    className="ModalNavegacao-Acoes-Arquivos"
                    style={{
                        display: (modalOpcaoSelecionada === 'Arquivos') ? 'block' : 'none'
                    }}
                >
                    <div style={{ display: "flex" }}>

                        <div>
                            <h2 className="Titulo-Navegacao-Acoes">
                                Observação
                            </h2>
                            <p className="Texto-Navegacao-Acoes">
                                Este exame foi importado pelo
                                paciente, que assume integralmente
                                a responsabilidade por seu conteúdo.
                            </p>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    abrirViewer = (pedido) => {
        if (!pedido) return;

        if (this.mobilecheck && this.mobilecheck()) {
            // comportamento mobile: nova aba
            window.open(this.buildViewerUrl(pedido), "imageFrame");
        } else {
            // desktop: mostra no iframe da modal
            const url = this.buildViewerUrl(pedido);
            this.setState({ viewerSrc: url });
        }
    };

    renderConteudoModalGenerica() {

        const pedido = this.state.pedidoModalOpcoes;
        const opcao = this.state.modalOpcaoSelecionada;

        const prioridadeSelectItems = [
            { label: 'Sem prioridade', value: 0 },
            { label: 'Baixa', value: 1 },
            { label: 'Média', value: 2 },
            { label: 'Alta', value: 3 }
        ];

        return (
            <>

                {/* Viewer */}
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        display: opcao === 'Viewer' ? 'block' : 'none',
                        overflow: 'hidden'
                    }}
                >
                    {this.state.viewerSrc ? (
                        <iframe
                            src={this.state.viewerSrc}
                            title="viewer"
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allowFullScreen
                        />
                    ) : (
                        <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>
                            Carregando viewer...
                        </div>
                    )}
                </div>



                {/* Galeria */}
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        display: opcao === 'Galeria' || opcao === 'Imagens' ? 'block' : 'none'
                    }}
                >
                    <GaleriaImagens
                        selectedPedido={this.state.pedidoModalOpcoes}
                        servicoImagem={this.state.pedidoModalOpcoes?.Unidade?.ServicoImagemPortal}
                        panelImageJpegVisible={true}
                        panelImageJpegMaximize={(e) => this.panelImageJpegMaximize()}
                        handleFecharImagemJpg={() => this.setState({ modalOpcoesVisivel: false })}
                        onHideGaleria={() => this.setState({ modalOpcoesVisivel: false })}
                        mobilecheck={() => this.mobilecheck()}
                        adicionarHistoricoAcoes={(acao, pedidoId) => this.AdicionarHistoricoAcoes(acao, pedidoId, this.state.pedidoModalOpcoes?.Tipo)}
                    />
                </div>

                {/* Laudo */}
                <div className="modal-Laudo"

                    style={{
                        display: opcao === 'Laudo' ? 'block' : 'none'
                    }}
                >
                    <div className="modal-Laudo-estrutura-estrutura">
                        {this.state.laudoCarregando ? (
                            <div
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#161618',
                                    borderRadius: '10px'
                                }}
                            >
                                <ProgressSpinner style={{ width: '100px', height: '100px' }} strokeWidth="4" />
                            </div>
                        ) : (
                            <iframe
                                className="modal-Laudo-estrutura-corpo"
                                src={this.state.urlLaudoPdf} // já vem com #zoom=...
                                title="Laudo PDF"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 'none'
                                }}
                            />
                        )}
                    </div>
                </div>

                {/* Compartilhar */}
                {opcao === 'Compartilhar' && (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                        }}
                    >

                        <div className="formulario-compartilhar">

                            <div style={{ display: 'flex' }}>
                                <div>
                                    <label>Forma de envio</label>
                                    {/* Tabs de seleção: WhatsApp / E-mail */}
                                    <div className="tabs-envio">
                                        <button
                                            className={`tab-envio ${this.state.formaEnvio === 'whatsapp' ? 'ativo' : ''}`}
                                            onClick={() => this.setState({ formaEnvio: 'whatsapp' })}
                                        >
                                            WhatsApp
                                        </button>
                                        <button
                                            className={`tab-envio ${this.state.formaEnvio === 'email' ? 'ativo' : ''}`}
                                            onClick={() => this.setState({ formaEnvio: 'email' })}
                                        >
                                            E-mail
                                        </button>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', width: '100%', color: 'black' }}>
                                    <div style={{ marginLeft: 'auto' }}>
                                        <div style={{ display: 'block' }}>
                                            <div>
                                                <label>Válido por</label>
                                            </div>

                                            <div>
                                                <Dropdown
                                                    className="dropdownValidade"
                                                    panelClassName="painel-validade"
                                                    value={this.state.validadeSelecionada}
                                                    onChange={(e) => this.setState({ validadeSelecionada: e.value })}
                                                    options={this.state.validades}
                                                    optionLabel="name"
                                                    placeholder={this.state.validadeSelecionada}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Campo de entrada conforme forma de envio */}
                            <div className="campo-envio">
                                {this.state.formaEnvio === 'whatsapp' ? (
                                    <div className="input-com-icone">
                                        <span className="icone-whatsapp" />

                                        <InputMask
                                            className="campo-envio-input"
                                            value={this.state.celCompartilhar}
                                            onChange={(e) => this.setState({ celCompartilhar: e.target.value })}
                                            mask="(99) 99999-9999"
                                            placeholder="(99) 99999-9999"
                                        />
                                    </div>
                                ) : (
                                    <div className="input-com-icone">
                                        <span className="icone-email" />
                                        <input
                                            className="campo-envio-input"
                                            type="email"
                                            placeholder="seuemail@exemplo.com"
                                            value={this.state.emailCompartilhar}
                                            onChange={(e) => this.setState({ emailCompartilhar: e.target.value })}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="botoesModalCompartilhar">
                                <Button
                                    className="botaoCancelar"
                                    label="Cancelar"
                                    onClick={() => this.setState({ modalOpcoesVisivel: false })}
                                />
                                <Button
                                    className="botaoCompartilhar"
                                    label="Compartilhar"
                                    onClick={() => this.handleCompartilharLinkPortal()}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Anexos */}
                <div style={{
                    display: opcao === 'Anexos' ? 'block' : 'none',
                }}>
                    <div style={{ width: '100%' }}
                        footer={this.renderFooterAnexo('modalAnexo')} onHide={() => this.onHide('modalAnexo')}>

                        <div className="card">
                            <DataTable
                                className="tabela-anexos"
                                value={
                                    this.state.isExecutante
                                        ? this.state.listaAnexos
                                        : this.state.listaAnexos?.filter(a => a?.Nome?.toLowerCase().endsWith('.stl'))
                                }
                                tableStyle={{ minWidth: '100%' }}
                            >
                                <Column field="Nome" header="Nome do arquivo" body={this.nomeArquivoAnexo}></Column>
                                <Column field="Tamanho" header="Tamanho" body={(e) => this.tamanhoArquivoKB(e)} headerStyle={{ width: '9em' }} ></Column>
                                <Column field="TipoAnexo" header="Formato" body={this.statusTipoAnexo} headerStyle={{ width: '9em' }} ></Column>
                                <Column field="" header="Ações" headerStyle={{ width: '9em' }} body={(e) => this.btnAnexoAcoes(this.state.pedidoModalOpcoes, e)}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>

                {/* Exames externos */}
                <div style={{
                    display: opcao === 'Arquivos' ? 'block' : 'none',
                }}>
                    <div style={{ width: '100%' }}>

                        <div className="card">
                            <DataTable
                                className="tabela-anexos"
                                value={this.state.pedidoModalOpcoes?.Files || []}
                                tableStyle={{ minWidth: '100%' }}
                            >
                                <Column
                                    field="Name"
                                    header="Nome do arquivo"
                                />
                                <Column
                                    header="Ações"
                                    body={this.renderAcoesArquivoExterno}
                                    style={{ width: '10em' }}
                                />
                            </DataTable>


                        </div>
                    </div>
                </div>

                {/* Galeria Externos - COMENTADO POR DOUGLAS */ }
                {/* <div
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'relative',
                        display: opcao === 'Imagens' ? 'block' : 'none'
                    }}
                >
                    <GaleriaExternos
                        selectedPedido={this.state.pedidoModalOpcoes}
                        servicoImagem={'http://localhost/dicom/studies'}
                        panelImageJpegVisible={true}
                        panelImageJpegMaximize={(e) => this.panelImageJpegMaximize()}
                        handleFecharImagemJpg={() => this.setState({ modalOpcoesVisivel: false })}
                        onHideGaleria={() => this.setState({ modalOpcoesVisivel: false })}
                        mobilecheck={() => this.mobilecheck()}
                        adicionarHistoricoAcoes={(acao, pedidoId) => this.AdicionarHistoricoAcoes(acao, pedidoId)}
                    />
                </div> */}

                {/* Parecer Medico */}
                <div style={{
                    display: opcao === 'Parecer' ? 'block' : 'none',
                }}>

                    <div
                        className="ParecerMedico">

                        <div className="ParecerMedicoLista">
                            <DataTable value={this.state.listaParecer}
                                className="p-datatable-gridlines"
                                emptyMessage="Nenhum parecer disponível no momento."
                            >
                                <Column field="DataCadastro" header="Data"></Column>
                                <Column field="Texto" header="Descrição"></Column>
                                <Column header="Prioridade" body={this.statusPrioridade} />
                            </DataTable>
                        </div>

                        <div
                            className="ParecerMedicoForm"
                        >
                            <div className="ParecerMedicoFormInput">
                                <label className="ParecerMedicoInputTextLabel">Parecer Médico:</label>
                                <InputTextarea
                                    className="ParecerMedicoInputText"
                                    placeholder="Descreva o parecer médico aqui..."
                                    value={this.state.parecerTexto}
                                    onChange={(e) => this.setState({ parecerTexto: e.target.value })}
                                    autoResize={true}
                                />
                            </div>

                            <div className="ParecerMedicoFormPrioridade">
                                <div>
                                    <label className="ParecerMedicoPrioridadeLabel">Prioridade: </label>
                                    <Dropdown
                                        className="ParecerMedicoPrioridade"
                                        value={this.state.parecerPrioridade}
                                        options={prioridadeSelectItems}
                                        onChange={(e) => { this.setState({ parecerPrioridade: e.value }) }}
                                    />
                                </div>
                                <div className="ParecerMedicoFormButtons">
                                    <Button
                                        label="Cancelar"
                                        className="ParecerMedicoFormCancelarButtom"
                                        onClick={() => this.setState({ modalOpcoesVisivel: false })}
                                    />
                                    <Button
                                        label="Salvar"
                                        className="ParecerMedicoFormSalvarButtom"
                                        onClick={async () => {
                                            try {
                                                // Aguarda o salvamento terminar
                                                await this.handleSalvarParecer();

                                                // Só depois tenta buscar os novos pareceres
                                                const pedido = this.state.pedidoModalOpcoes;
                                                if (pedido?.Id) {
                                                    const medicoService = new MedicoService();
                                                    const data = await medicoService.GetParecerMedico(pedido.Id);

                                                    const _listaParecer = data.Comentarios.map(el => ({
                                                        DataCadastro: moment(el.DataCadastro).format("DD/MM/YYYY"),
                                                        Prioridade: this.retLegendaPrioridade(el.Prioridade),
                                                        Texto: el.Texto
                                                    }));

                                                    this.setState({ listaParecer: _listaParecer });
                                                }
                                            } catch (error) {
                                                console.log('Erro ao salvar ou atualizar parecer médico:', error);
                                            }
                                        }}
                                        style={{ marginRight: "10px" }}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                {/* Default */}
                <div style={{ display: !opcao ? 'block' : 'none' }}>
                    <p>Selecione uma opção na lateral.</p>
                </div>
            </>
        );
    }



    //#endregion

    //#region RENDER PRINCIPAL
    render() {

        const headerLista = this.renderHeaderLista();

        const pedidoAtual = this.state.pedidoModalOpcoes;

        this.state.existeAnexo = this.DesabilitarBtnAnexo(pedidoAtual);

        const {
            isMedico,
            isExecutante,
            isConvenio
        } = this.state;

        const isPerfilMedico = isMedico || isExecutante;

        const prioridadeSelectItems = [
            { label: 'Sem prioridade', value: 0 },
            { label: 'Baixa', value: 1 },
            { label: 'Média', value: 2 },
            { label: 'Alta', value: 3 }
        ];


        // Ajusta composição do paginador:

        const { first, rows, totalPedidos, isMobile } = this.state;

        const desktopTemplate = "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink";
        const mobileTemplate = "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink";


        return (

            <div>

                <ModalMensagem
                    visible={this.state.modalErroVisivel}
                    onHide={() => this.setState({ modalErroVisivel: false })}
                    tipo="erro"
                    mensagem={this.state.mensagemErro}
                    imagem={imgErro}
                />

                {this.renderHeaderFilter()}

                {this.renderHeaderTopInfo()}

                {this.renderZipandoDicom()}

                {this.renderResultadoInclusao()}

                <div className="main-body">

                    <div className="layout-main">

                        <Dialog className="modal-confirmar-impressao" header="Confirmar Impressão" position="top" visible={this.state.modalConfirmaImpressao} footer={this.renderFooter('modalConfirmaImpressao')} onHide={() => this.onHide('modalConfirmaImpressao')}>
                            <p className="modal-confirmar-impressao--text">Esse exame possui Anexo Diagnóstico. Deseja imprimir junto com o laudo?</p>
                        </Dialog>

                        <Dialog header="Aviso"
                            position="top" visible={this.state.modalImagemOutroPedido} style={{ width: this.mobilecheck() ? '90vw' : '70vw' }} footer={this.renderFooterCancelar('modalImagemOutroPedido')} onHide={() => this.onHide('modalImagemOutroPedido')}>
                            <p style={{ fontSize: '16px', marginTop: '.5rem', fontWeight: 'bold' }}>O pedido selecionado não possui imagem vinculada. Porém, suas imagens podem estar vinculadas em um pedido do mesmo paciente e da mesma modalidade.</p>
                            <div className="datatable-responsive-demo">
                                <div className="card">
                                    <DataTable value={this.state.imagensVinculadas} className="p-datatable-gridlines p-datatable-responsive-demo">
                                        <Column field="Visualizar" header=" " body={this.botaoVisualizarImagemVinculada.bind(this)} />
                                        <Column field="Laudo" header="Laudo" body={this.idLaudoImagemVinculada} />
                                        <Column field="Data do Estudo" header="Data do Estudo" body={this.dataEstudoImagemVinculada} />
                                        <Column field="Procedimento" header="Procedimento" body={this.procedimentoImagemVinculada} />
                                        <Column field="Modalidade" header="Modalidade" body={this.modalidadeImagemVinculada} />
                                    </DataTable>
                                </div>
                            </div>
                        </Dialog>

                        <Dialog header={this.renderHeaderAnexoDiagnostico()} visible={this.state.modalAnexo}
                            style={{ width: this.mobilecheck() ? '100%' : '50vw' }}
                            footer={this.renderFooterAnexo('modalAnexo')} onHide={() => this.onHide('modalAnexo')}>

                            <div className="card" style={{ display: this.mobilecheck() ? 'none' : 'block' }} >
                                <DataTable value={this.state.listaAnexos} className="p-datatable-gridlines">
                                    <Column field="Nome" header="Nome" body={this.nomeArquivoAnexo}></Column>
                                    <Column field="TipoAnexo" header="Tipo" body={this.statusTipoAnexo} headerStyle={{ width: '9em' }} ></Column>
                                    <Column field="" header="Ações" headerStyle={{ width: '9em' }} body={(e) => this.btnAnexoAcoes(e)}></Column>
                                </DataTable>
                            </div>

                            <div style={{ display: this.mobilecheck() ? 'block' : 'none' }} >
                                <DataTable value={this.state.listaAnexos} className="p-datatable-gridlines">
                                    <Column field="Nome" header="Nome" body={this.nomeArquivoAnexoMob}></Column>
                                    <Column style={{ width: '70px' }} field="" header="Ações" body={(e) => this.btnAnexoAcoesMob(e)}></Column>
                                </DataTable>
                            </div>

                        </Dialog>

                        <Dialog
                            header="Download em andamento"
                            visible={this.state.dialogDicomZip}
                            modal
                            style={{ width: "350px" }}
                            closable={false}
                            className="download-dicom-zip--modal"
                        >
                            <div style={{ textAlign: "center", padding: "20px" }}>
                                <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                                <p style={{ marginTop: "15px" }}>
                                    {this.state.progressoDicomZip === 0
                                        ? "Preparando arquivo..."
                                        : `Baixando arquivo... ${this.state.progressoDicomZip}kb`}
                                </p>
                            </div>
                        </Dialog>


                        <Dialog
                            header="Inclusão de exames"
                            visible={this.state.modalExamesExternosVisivel}
                            className="external-exams-modal"
                            modal
                            onHide={() => this.setState({ modalExamesExternosVisivel: false })}
                        >
                            <div className="external-exams-modal__wrapper">

                                <div className="external-exams-modal__content">
                                    <div className="external-exams-modal__form-group">

                                        <div className="external-exams-modal__field">
                                            <span className="external-exams-modal__label">Descrição do Exame:</span>
                                            <AutoComplete
                                                className={`external-exams-modal__autocomplete ${this.state.erroDescricao ? 'campo-obrigatorio' : ''}`}
                                                panelClassName="external-exams-modal__autocomplete-panel"
                                                value={this.state.descricaoExame}
                                                suggestions={this.state.procedimentosSugeridos}
                                                completeMethod={this.buscarProcedimentos}
                                                minLength={2}
                                                field="Nome"
                                                placeholder="Digite para buscar..."
                                                // Se disponível na sua versão, isso já ajuda muito:
                                                // forceSelection
                                                onChange={(e) => {
                                                    const novoValor = e.value || '';
                                                    this.setState(prev => ({
                                                        descricaoExame: novoValor,
                                                        // EDITAR o texto invalida a seleção anterior
                                                        procedimentoSelecionado:
                                                            typeof novoValor === 'string' ? null : prev.procedimentoSelecionado
                                                    }));
                                                }}
                                                onSelect={(e) => {
                                                    // e.value é o objeto selecionado da lista
                                                    this.setState({
                                                        procedimentoSelecionado: e.value,
                                                        descricaoExame: e.value?.Nome || ''
                                                    });
                                                }}
                                                onBlur={() => {
                                                    const { descricaoExame, procedimentoSelecionado } = this.state;
                                                    const valido = !!procedimentoSelecionado && descricaoExame === procedimentoSelecionado.Nome;
                                                    if (!valido) {
                                                        this.setState({ procedimentoSelecionado: null, erroDescricao: true });
                                                        // Opcional: limpar o texto para deixar explícito que não é válido
                                                        this.setState({ descricaoExame: '' });
                                                    } else {
                                                        this.setState({ erroDescricao: false });
                                                    }
                                                }}
                                            />

                                        </div>

                                        <div className="external-exams-modal__field">
                                            <span className="external-exams-modal__label">
                                                Clínica/hospital do exame:
                                            </span>

                                            <InputText
                                                className={`external-exams-modal__input ${this.state.erroLocal ? 'campo-obrigatorio' : ''}`}
                                                value={this.state.localExameExterno}
                                                onChange={(e) => this.setState({ localExameExterno: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="external-exams-modal__form-group">

                                        <div className="external-exams-modal__field">
                                            <span className="external-exams-modal__label">
                                                Data da realização do exame:
                                            </span>

                                            <Calendar
                                                className={`external-exams-modal__calendar ${this.state.erroData ? 'campo-obrigatorio' : ''}`}
                                                value={this.state.dataExameExterno}
                                                dateFormat="dd/mm/yy"
                                                maxDate={new Date()} // ⬅️ impede datas futuras
                                                onChange={(e) => this.setState({ dataExameExterno: e.value })}
                                            />
                                        </div>

                                        <div className="external-exams-modal__field">
                                            <span className="external-exams-modal__label">
                                                Médico solicitante:
                                            </span>
                                            <InputText
                                                className="external-exams-modal__input"
                                                value={this.state.medicoSolicitanteExameExterno}
                                                onChange={(e) => this.setState({ medicoSolicitanteExameExterno: e.target.value })}
                                            />
                                        </div>

                                        <div className="external-exams-modal__field">
                                            <span className="external-exams-modal__label">
                                                CRM do médico solicitante:
                                            </span>
                                            <InputText
                                                className="external-exams-modal__input"
                                                value={this.state.crmMedicoSolicitanteExameExterno}
                                                onChange={(e) => this.setState({ crmMedicoSolicitanteExameExterno: e.target.value })}
                                            />
                                        </div>

                                    </div>

                                    {this.state.erroCamposObrigatorios && (
                                        <div style={{ color: 'red', marginTop: '10px', fontWeight: 'bold', marginBottom: '30px' }}>
                                            * Os campos destacados acima são obrigatórios.
                                        </div>
                                    )}

                                    <div className="external-exams-modal__upload">
                                        <span className="external-exams-modal__label">
                                            Anexar arquivos (PDF/Imagens)
                                        </span>



                                        <div className="external-exams-modal__upload-buttons">

                                            {/* Botões de seleção */}
                                            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                                                {/* Botão Selecionar Arquivos */}
                                                <Button
                                                    label="Selecionar Arquivos"
                                                    icon="pi pi-folder-open"
                                                    className="external-exams-modal__button--select-file"
                                                    onClick={() => this.inputArquivosRef && this.inputArquivosRef.click()}
                                                />
                                                <input
                                                    type="file"
                                                    ref={(el) => (this.inputArquivosRef = el)}
                                                    style={{ display: 'none' }}
                                                    accept=".pdf,.png,.jpg,.jpeg"
                                                    multiple
                                                    onChange={(e) => {
                                                        const files = Array.from(e.target.files);
                                                        this.adicionarArquivos(files);
                                                        e.target.value = ''; // limpa para permitir reseleção do mesmo arquivo
                                                    }}
                                                />

                                                {window.innerWidth < 1024 ? (
                                                    // Mobile: botão que abre a câmera nativa
                                                    <>
                                                        <Button
                                                            label="Tirar Foto"
                                                            icon="pi pi-camera"
                                                            className="external-exams-modal__button--camera"
                                                            onClick={() => this.inputCameraRef && this.inputCameraRef.click()}
                                                        />
                                                        <input
                                                            type="file"
                                                            ref={(el) => (this.inputCameraRef = el)}
                                                            style={{ display: "none" }}
                                                            accept="image/*"
                                                            capture="environment"
                                                            onChange={(e) => {
                                                                const files = Array.from(e.target.files);
                                                                this.adicionarArquivos(files);
                                                                e.target.value = "";
                                                            }}
                                                        />
                                                    </>
                                                ) : (
                                                    //Desktop: abre modal com CameraCapture
                                                    <>
                                                        <Button
                                                            label="Tirar Foto"
                                                            icon="pi pi-camera"
                                                            className="external-exams-modal__button--camera"
                                                            onClick={() => this.setState({ mostrarCamera: true })}
                                                        />
                                                        {this.state.mostrarCamera && (
                                                            <CameraCapture
                                                                onCapture={(files) => this.adicionarArquivos(files)}
                                                                onClose={() => this.setState({ mostrarCamera: false })}
                                                                preferredFacing="environment"
                                                                captureWidth={1280}
                                                                captureHeight={720}
                                                            />
                                                        )}
                                                    </>
                                                )}


                                            </div>

                                            {/* Lista de arquivos em grid */}
                                            {/* Lista de arquivos em lista vertical com scroll */}
                                            <div className="external-exams-modal__upload-grid">
                                                {this.state.arquivosSelecionados.length > 0 ? (
                                                    <ul className="arquivos-lista">
                                                        {this.state.arquivosSelecionados.map((arquivo, index) => (
                                                            <li key={`${arquivo.name}-${arquivo.size}-${index}`} className="arquivo-item">
                                                                <i className="pi pi-file arquivo-icone" aria-hidden />
                                                                <div className="arquivo-info">
                                                                    <div className="arquivo-nome" title={arquivo.name}>{arquivo.name}</div>
                                                                    <div className="arquivo-meta">
                                                                        {Math.ceil(arquivo.size / 1024)} KB
                                                                    </div>
                                                                </div>
                                                                <div className="arquivo-acoes">
                                                                    {/* Botão visualizar */}
                                                                    <Button
                                                                        icon="pi pi-eye"
                                                                        className="external-exams-modal__button-visualizer"
                                                                        style={{ color: 'black', backgroundColor: 'transparent', boder: 'none' }}
                                                                        tooltip="Visualizar"
                                                                        onClick={() => this.visualizarArquivo(arquivo)}
                                                                    />

                                                                    {/* Botão remover */}
                                                                    <Button
                                                                        icon="pi pi-times"
                                                                        className="p-button-rounded p-button-danger p-button-sm"
                                                                        tooltip="Remover"
                                                                        onClick={() => this.removerArquivo(index)}
                                                                    />
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <div className="grid-vazia">Nenhum arquivo selecionado ainda.</div>
                                                )}
                                            </div>


                                        </div>
                                    </div>

                                    
                                    {(this.state.habilitarEnvioDicomExamesExternos) && (
                                        <div className="external-exams-modal__dicom-section">
                                            <span className="external-exams-modal__label">
                                                Pasta com Imagens DICOM
                                            </span>
                                            <div className="external-exams-modal__dicom-path-input">
                                                <div className="external-exams-modal__dicom-input-row">
                                                    <InputText
                                                        className="external-exams-modal__input"
                                                        value={this.state.caminhopastaDicomExameExterno}
                                                        onChange={(e) => this.setState({ caminhopastaDicomExameExterno: e.target.value })}
                                                        readOnly
                                                    />

                                                    <input
                                                        type="file"
                                                        ref={this.inputPastaRef}
                                                        style={{ display: 'none' }}
                                                        onChange={this.handleSelecionarPastaDicom}
                                                        webkitdirectory="true"
                                                        directory="true"
                                                        multiple
                                                    />
                                                </div>

                                                <div style={{ display: 'flex' }}>

                                                    {this.state.zipDicom && (
                                                        <Button
                                                            icon="pi pi-times"
                                                            className="p-button-text p-button-danger"
                                                            tooltip="Remover pasta selecionada"
                                                            onClick={() => {
                                                                this.setState({
                                                                    zipDicom: null,
                                                                    caminhopastaDicomExameExterno: ''
                                                                });

                                                                // Reseta o input file para permitir nova seleção da mesma pasta
                                                                if (this.inputPastaRef.current) {
                                                                    this.inputPastaRef.current.value = null;
                                                                }
                                                            }}
                                                        />
                                                    )}

                                                    {!this.state.zipDicom && (
                                                        <Button
                                                            className="btnSelecionarDicomExterno"
                                                            label="Selecionar"
                                                            onClick={this.handleClickSelecionarPastaDicom}
                                                        />
                                                    )}
                                                </div>
                                            </div>

     
                                        </div>
                                    )}

                                    <div>
                                        {this.state.erroArquivos && (
                                            <div className="Exames-externos-aviso" style={{ color: 'red', marginTop: '10px', fontWeight: 'bold' }}>
                                                Você deve incluir ao menos um arquivo (PDF/Imagem ou pasta DICOM).
                                            </div>
                                        )}
                                    </div>

                                    <div className="external-exams-modal__actions">

                                        <Dialog
                                            header="Termo de consentimento"
                                            className= "termo-consetimento-exame-externo"
                                            visible={this.state.mostrarModalConsentimento}
                                            style={{ width: '40vw' }}
                                            modal
                                            onHide={() => this.setState({ mostrarModalConsentimento: false })}
                                        >
                                            <p className="exame-externo-termo-texto">
                                                A inclusão deste exame e seu conteúdo são de sua inteira responsabilidade.
                                            </p>
                                            <p className="exame-externo-termo-texto">
                                                Não nos responsabilizamos por informações incorretas, incompletas
                                                ou arquivos enviados de forma equivocada.
                                            </p>

                                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
                                                <Button
                                                    label="Cancelar"
                                                    className="p-button-text"
                                                    onClick={() => this.setState({ mostrarModalConsentimento: false })}
                                                />
                                                <Button
                                                    label="Aceito"
                                                    className="p-button-success"
                                                    onClick={() => {
                                                        this.setState({ mostrarModalConsentimento: false }, () => {
                                                            this.handleIncluirExamesExternos();
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Dialog>

                                        <Button
                                            className="external-exams-modal__button--submit"
                                            label="Incluir"
                                            onClick={() => this.setState({ mostrarModalConsentimento: true })}
                                        />

                                        <Button
                                            label="Cancelar"
                                            className="external-exams-modal__button--cancel"
                                            onClick={() => {
                                                this.setState({ modalExamesExternosVisivel: false });
                                                this.setState({
                                                    descricaoExame: "",
                                                    dataExameExterno: "",
                                                    localExameExterno: "",
                                                    arquivosSelecionados: "",
                                                    medicoSolicitanteExameExterno: "",
                                                    crmMedicoSolicitanteExameExterno: "",
                                                    zipDicom: "",
                                                    pedidoModalOpcoes: "",
                                                    erroArquivos: false,
                                                    erroCamposObrigatorios: false,
                                                    erroDescricao: false,
                                                    erroLocal: false,
                                                    erroData: false,
                                                    caminhopastaDicomExameExterno: ''

                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <div>
                            <div className="p-col-12 p-lg-12">

                                <div
                                    className="content-section introduction"
                                    style={{ display: this.state.isMedico ? "none" : "block" }}
                                >

                                </div>

                                {headerLista}

                                <div id="gridListaPedidos" className="content-section implementation">
                                    <div className="p-grid">
                                        <div
                                            className={
                                                this.state.panelImageJpegVisible || this.state.panelAnexoVisible
                                                    ? "p-col-5"
                                                    : "p-col-12"
                                            }
                                            style={autoHeigthLista}
                                        >
                                            <div>
                                                {(this.state.pedidosCombinados?.length ?? 0) > 0 ? (
                                                    <DataView
                                                        value={this.state.pedidosCombinados}
                                                        layout={this.state.layout}
                                                        itemTemplate={(pedido) => this.itemTemplate(pedido, this.state.layout)}
                                                        paginator={false}
                                                        rows={this.state.rows}
                                                        emptyMessage={null}
                                                    />
                                                ) : (
                                                    <div className="no-results">
                                                        <img className="no-tesults--image" src={require('../images/sem-resultados.svg')} alt="Sem resultados" style={{ width: 120, marginBottom: 20 }} />
                                                        <h3>Ops...</h3>
                                                        <p>Nenhum exame foi encontrado com o filtro selecionado.</p>
                                                        <p>Verifique o filtro, e tente novamente.</p>
                                                    </div>
                                                )}
                                            </div>

                                            <div
                                                style={{
                                                    height: this.state.mostrarFiltro ? "12%" : "5%",
                                                    opacity: this.state.mostrarFiltro ? 1 : 0.5,
                                                    transition: "height 0.4s ease, opacity 0.4s ease"
                                                }}
                                            ></div>

                                        </div>
                                        {this.renderPainelAnexoDiagnostico(0)}
                                    </div>
                                    <Dialog
                                        header="Detalhes do Pedido"
                                        visible={this.state.visible}
                                        modal={true}
                                        onHide={() => this.setState({ visible: false })}
                                    >
                                        {this.renderPedidoDialogContent()}
                                    </Dialog>
                                </div>
                            </div>
                        </div>

                        <div className="Footer-bar">

                            <div className="footer-bar--left">
                                <div className="Paginador">
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalPedidos}
                                        onPageChange={this.onPageChange}
                                        template={isMobile ? mobileTemplate : desktopTemplate}
                                        currentPageReportTemplate="{currentPage} de {totalPages}"
                                        responsiveLayout="stack"
                                    />
                                </div>
                            </div>
                            <div className="footer-bar--right">
                                <div className="Version-info">© 2025 Tzion MyResult 2026.001.01.04</div>
                            </div>
                        </div>

                        <Sidebar
                            header="Galeria de Imagens"
                            blockScroll={true}
                            fullScreen={true}
                            visible={this.state.panelImageJpegVisible}
                            modal={false}
                            //onHide={() => this.setState({panelImageJpegVisible: false})} 
                            style={{ zIndex: "999", border: "none", backgroundColor: "#000", padding: "0" }}
                            showCloseIcon={false}
                        >

                            <GaleriaImagens
                                selectedPedido={this.state.selectedPedido}
                                servicoImagem={this.state.servicoImagemPortal}
                                panelImageJpegMaximize={(e) => this.panelImageJpegMaximize()}
                                handleFecharImagemJpg={(e) => this.handleFecharImagemJpg()}
                                onHideGaleria={() => this.onHideGaleria()}
                                mobilecheck={() => this.mobilecheck()}
                                panelImageJpegVisible={this.state.panelImageJpegVisible}
                                adicionarHistoricoAcoes={(acao, pedidoId) => this.AdicionarHistoricoAcoes(acao, pedidoId, this.state.pedidoModalOpcoes?.Tipo)}
                            />

                        </Sidebar>


                        <Sidebar
                            header="Compartilhar Link do Portal"
                            blockScroll={true}
                            position="bottom"
                            visible={this.state.visibleDialog}
                            modal={false}
                            onHide={() => this.setState({ visibleDialog: false })}
                            style={{ zIndex: "999", border: "none", height: "200px" }}
                        >

                            <div className="tituloSlideForm">
                                <i className="pi pi-share-alt"></i> <strong>Compartilhar Link do Portal</strong>
                            </div>

                            <br></br>

                            <div style={{
                                display: "grid",
                                gridTemplateRows: "auto auto auto",
                                rowGap: "10px",
                                width: "100%",
                                position: "fixed",
                                left: "0",
                                bottom: "0",
                                padding: "20px 10px 10px 10px",
                                backgroundColor: "rgb(52, 51, 67)",
                                boxShadow: "0 0 10px 2px #ccc",
                            }}>


                                <div>

                                    <div className=" ">

                                        {
                                            this.tipoCompartilhamento.map((tipo) => {
                                                return (
                                                    <div key={tipo.key} className="p-field-radiobutton" style={{ float: 'left', marginRight: '20px' }}>
                                                        <RadioButton inputId={tipo.key} name="tipo" value={tipo} onChange={(e) => this.setState({ selectedCompartilhamento: e.value })} checked={this.state.selectedCompartilhamento.key === tipo.key} />
                                                        <label htmlFor={tipo.key}>{tipo.name}</label>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>

                                    <br />
                                    <br />
                                    <InputMask type="tel" style={{ width: '100%', display: this.state.selectedCompartilhamento.key === 0 ? 'block' : 'none' }} id="celular" mask="(99)99999-9999" value={this.state.celCompartilhar} placeholder="(99)99999-9999" onChange={(e) => this.setState({ celCompartilhar: e.value })}></InputMask>
                                    <InputText style={{ width: '100%', display: this.state.selectedCompartilhamento.key === 1 ? 'block' : 'none' }} name="email" placeholder="Informe o email" value={this.state.emailCompartilhar} onChange={(e) => { this.setState({ emailCompartilhar: e.target.value }) }} />
                                </div>

                                <div>
                                    <label>Prazo de validade do link:</label>
                                    <br />
                                    <Dropdown
                                        style={{ borderColor: '#e3ebf6' }}
                                        options={listPrazo}
                                        placeholder="Selecionar prazo"
                                        value={this.state.prazoValue}
                                        onChange={(e) => { this.setState({ prazoValue: e.value }) }}
                                    />
                                </div>

                                <div
                                    style={{
                                        textAlign: "right",
                                        borderTop: "solid 1px #ccc",
                                        marginTop: "10px",
                                        paddingTop: "10px"
                                    }}>
                                    <Button label="Compartilhar" className="p-button-info" onClick={e => { { this.handleCompartilharLinkPortal(); } }} style={{ marginRight: "10px" }} />
                                    <Button label="Cancelar" className="p-button-text" onClick={e => this.setState({ visibleDialog: false })} />
                                </div>

                            </div>
                        </Sidebar>

                        <Sidebar visible={this.state.visibleDialogComentario}
                            fullScreen={true}
                            blockScroll={true}
                            modal={false}
                            showCloseIcon={true}
                            style={{ zIndex: "999", border: "none" }}
                            onHide={() => this.setState({ visibleDialogComentario: false })}>

                            <div className="tituloSlideForm">
                                <i className="pi pi-comment"></i> <strong>Parecer Médico</strong>
                            </div>

                            <br></br>

                            <div className="card" style={{ padding: "0px", height: "70vw", borderBottom: "solid 1px #ccc" }}>
                                <DataTable value={this.state.listaParecer} header="Histórico" className="p-datatable-gridlines">
                                    <Column field="DataCadastro" header="Data"></Column>
                                    <Column field="Texto" header="Descrição"></Column>
                                    <Column field="Prioridade" header="Prioridade" style={{ textAlign: "center" }}></Column>
                                </DataTable>
                            </div>

                            <div style={{
                                display: "grid",
                                gridTemplateRows: "auto auto auto",
                                rowGap: "10px",
                                width: "100%",
                                position: "fixed",
                                left: "0",
                                bottom: "0",
                                padding: "20px 10px 10px 10px",
                                backgroundColor: "rgb(52, 51, 67)",
                                boxShadow: "0 0 10px 2px #ccc",
                            }}>

                                <div>
                                    <label className="textWhite">Parecer: </label>
                                    <InputTextarea
                                        placeholder="Descreva o parecer médico aqui..."
                                        value={this.state.parecerTexto}
                                        onChange={(e) => this.setState({ parecerTexto: e.target.value })}
                                        autoResize={true}
                                        style={{ width: "100%", height: "100px" }}
                                    />
                                </div>

                                <div>
                                    <label className="textWhite">Prioridade: </label>
                                    <Dropdown
                                        value={this.state.parecerPrioridade}
                                        options={prioridadeSelectItems}
                                        onChange={(e) => { this.setState({ parecerPrioridade: e.value }) }}
                                    />
                                </div>

                                <div
                                    style={{
                                        textAlign: "right",
                                        borderTop: "solid 1px #ccc",
                                        marginTop: "10px",
                                        paddingTop: "10px"
                                    }}>
                                    <Button label="Salvar" onClick={e => { { this.handleSalvarParecer(); } }} style={{ marginRight: "10px" }} />
                                    <Button label="Cancelar" className="p-button-text" onClick={e => this.setState({ visibleDialogComentario: false })} />
                                </div>

                            </div>

                        </Sidebar>

                        <ComponentsAppSplash visible={this.state.isLoading} />
                    </div>

                    <div style={{ width: "20px" }}></div>

                </div>

                <Dialog
                    className={`ModalGenerica ${this.getClasseVisualizador()}`}
                    header={
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', position: 'relative' }}>
                            <div className="botao-acoes results-header__toggle-filters">
                                <Button
                                    className={`p-button ${this.state.mostrarModalAcoesMobile ? 'ativo' : ''}`}
                                    onClick={() =>
                                        this.setState({ mostrarModalAcoesMobile: !this.state.mostrarModalAcoesMobile })
                                    }
                                />
                            </div>

                            {/* Dropdown flutuante abaixo do botão */}
                            {this.state.mostrarModalAcoesMobile && (
                                <div className="DialogMobileAcoesDropdown">

                                    <div className="ModalButtons">
                                        <div>
                                            {(
                                                isPerfilMedico
                                                    ? this.state.botaoGaleriaAtivoMedico
                                                    : this.state.botaoGaleriaAtivoPaciente
                                            ) && (
                                                    <Button
                                                        label={
                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <span className="icon-galeria" />
                                                                {this.state.labelBotaoGaleria || "Galeria de Imagens"}
                                                            </span>
                                                        }
                                                        className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Galeria' ? 'buttom-modal-selected' : ''}`}
                                                        onClick={() => this.setState({
                                                            modalOpcaoSelecionada: 'Galeria',
                                                            mostrarModalAcoesMobile: false
                                                        })}
                                                    />
                                                )}
                                        </div>


                                        {this.mostrarBotaoLaudoNaModal(this.state.pedidoModalOpcoes) && (
                                            <div>
                                                {(
                                                    isPerfilMedico
                                                        ? this.state.botaoLaudoAtivoMedico
                                                        : this.state.botaoLaudoAtivoPaciente
                                                ) && (
                                                        <Button
                                                            label={
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span className="icon-laudo" />
                                                                    {this.state.labelBotaoLaudo || "Laudo"}
                                                                </span>
                                                            }
                                                            className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Laudo' ? 'buttom-modal-selected' : ''}`}
                                                        onClick={() => {

                                                            const isAndroid = /Android/i.test(navigator.userAgent);

                                                            if (isAndroid) {
                                                                this.setState({ modalOpcoesVisivel: false });

                                                                this.abrirLaudo(this.state.pedidoModalOpcoes);
                                                            } else {
                                                                this.setState({ modalOpcaoSelecionada: 'Laudo', mostrarModalAcoesMobile: false });

                                                            }     
                                                           
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        )}

                                        <div>
                                            {(
                                                isPerfilMedico
                                                    ? this.state.botaoAnexosAtivoMedico
                                                    : this.state.botaoAnexosAtivoPaciente
                                            ) && (
                                                    <Button
                                                        label={
                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <span className="icon-anexos" />
                                                                {this.state.labelBotaoAnexos || "Anexos"}
                                                            </span>
                                                        }
                                                        visible={!this.state.existeAnexo}
                                                        className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Anexos' ? 'buttom-modal-selected' : ''}`}
                                                        onClick={() => this.setState({ modalOpcaoSelecionada: 'Anexos', mostrarModalAcoesMobile: false })}
                                                    />
                                                )}
                                        </div>

                                        <div className="ModalButtons-executante" style={{ display: this.state.isExecutante ? "block" : "none" }}>

                                            {this.RetPerfil() === "Médico Executante" && (
                                                <div>
                                                    {this.state.botaoParecerAtivoMedico && (

                                                        <Button
                                                            label={
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span className="icon-parecer" />
                                                                    Parecer Médico
                                                                </span>
                                                            }
                                                            className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Parecer' ? 'buttom-modal-selected' : ''}`}
                                                            onClick={() => this.setState({ modalOpcaoSelecionada: 'Parecer', mostrarModalAcoesMobile: false })}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {this.renderAcoesDaModal(this.state.pedidoModalOpcoes)}
                                </div>
                            )}

                            <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {this.state.modalOpcaoSelecionada}
                            </span>
                        </div>
                    }
                    visible={this.state.modalOpcoesVisivel}
                    modal
                    draggable={false}
                    onHide={() => {
                        document.body.style.overflow = 'auto';
                        document.body.classList.remove('p-overflow-hidden', 'overflow-hidden');
                        document.documentElement.style.overflow = 'auto';
                        document.documentElement.classList.remove('p-overflow-hidden', 'overflow-hidden');

                        this.setState({ modalOpcoesVisivel: false, mostrarModalAcoesMobile: false,  });
                    }}
                >
                    {this.state.pedidoModalOpcoes && (
                        <div className="ModalPedido">

                            {this.state.modalOpcaoSelecionada !== "Viewer" && (
                                <div className={`ModalNavegacao ${this.getClasseVisualizador()}`}>

                                    {this.mostrarBotao(this.state.pedidoModalOpcoes) &&
                                        this.state.modalOpcaoSelecionada !== "Imagens" && this.state.modalOpcaoSelecionada !== "Arquivos" &&(
                                        <div className="ModalButtons">

                                            {(
                                                (this.state.pedidoModalOpcoes.StudyUid || this.state.pedidoModalOpcoes.possuiJob) ? 
                                                isPerfilMedico
                                                    ? this.state.botaoGaleriaAtivoMedico
                                                    : this.state.botaoGaleriaAtivoPaciente
                                                : false
                                            ) && (
                                                <Button
                                                    label={
                                                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <span className="icon-galeria" />
                                                            Galeria de Imagens
                                                        </span>
                                                    }
                                                    className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Galeria' ? 'buttom-modal-selected' : ''}`}
                                                    onClick={() => {
                                                        this.setState({ modalOpcaoSelecionada: 'Galeria' });
                                                        this.AdicionarHistoricoAcoes(29, this.state.pedidoModalOpcoes.Id, this.state.pedidoModalOpcoes.Tipo);
                                                    }}
                                                />
                                            )}


                                            {this.mostrarBotaoLaudoNaModal(this.state.pedidoModalOpcoes) && (
                                                <div>
                                                    {(
                                                        isPerfilMedico
                                                            ? this.state.botaoLaudoAtivoMedico
                                                            : this.state.botaoLaudoAtivoPaciente
                                                    ) && (
                                                        <Button
                                                            label={
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span className="icon-laudo" />
                                                                    Laudo
                                                                </span>
                                                            }
                                                            className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Laudo' ? 'buttom-modal-selected' : ''}`}
                                                            onClick={() => {       
                                                                
                                                                this.setState({ modalOpcaoSelecionada: 'Laudo', mostrarModalAcoesMobile: false });

                                                                this.abrirLaudo(this.state.pedidoModalOpcoes);
                                                                
                                                                this.AdicionarHistoricoAcoes(46, this.state.pedidoModalOpcoes.Id, this.state.pedidoModalOpcoes.Tipo);
                                                            }}
                                                        />
                                                    )}
                                                </div>

                                            )}

                                            <div>
                                                {(
                                                    isPerfilMedico
                                                        ? this.state.botaoAnexosAtivoMedico
                                                        : this.state.botaoAnexosAtivoPaciente
                                                ) && (
                                                        <Button
                                                            label={
                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span className="icon-anexos" />
                                                                    Anexos
                                                                </span>
                                                            }
                                                            visible={!this.state.existeAnexo}
                                                            className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Anexos' ? 'buttom-modal-selected' : ''}`}
                                                            onClick={() => {
                                                                this.setState({ modalOpcaoSelecionada: 'Anexos' });
                                                                this.AdicionarHistoricoAcoes(34, this.state.pedidoModalOpcoes.Id, this.state.pedidoModalOpcoes.Tipo);
                                                            }}
                                                        />
                                                    )}
                                            </div>

                                            <div style={{ display: this.state.isExecutante ? "block" : "none" }}>

                                                {this.RetPerfil() === "Médico Executante" && (
                                                    <div>
                                                        {isPerfilMedico && this.state.botaoParecerAtivoMedico && (
                                                            <Button
                                                                label={
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                        <span className="icon-parecer" />
                                                                        Parecer Médico
                                                                    </span>
                                                                }
                                                                className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Parecer' ? 'buttom-modal-selected' : ''}`}
                                                                onClick={() => {
                                                                    this.setState({ modalOpcaoSelecionada: 'Parecer' }, () => {
                                                                        const pedido = this.state.pedidoModalOpcoes;
                                                                        if (pedido?.Id) {
                                                                            const medicoService = new MedicoService();
                                                                            medicoService.GetParecerMedico(pedido.Id)
                                                                                .then(data => {
                                                                                    const _listaParecer = data.Comentarios.map(el => ({
                                                                                        DataCadastro: moment(el.DataCadastro).format("DD/MM/YYYY"),
                                                                                        Prioridade: this.retLegendaPrioridade(el.Prioridade),
                                                                                        Texto: el.Texto
                                                                                    }));
                                                                                    this.setState({ listaParecer: _listaParecer });
                                                                                    this.AdicionarHistoricoAcoes(33, this.state.pedidoModalOpcoes.Id, this.state.pedidoModalOpcoes.Tipo);
                                                                                })
                                                                                .catch(error => {
                                                                                    console.log('Erro ao buscar parecer médico:', error);
                                                                                });
                                                                        }
                                                                    });
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                    )}

                                    {(this.state.modalOpcaoSelecionada === 'Arquivos' || this.state.modalOpcaoSelecionada === 'Imagens') && (
                                        <div className="ModalButtons">


                                            {(this.state.pedidoModalOpcoes?.Files?.length > 0) && (
                                                <Button
                                                    label={
                                                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span className="icon-anexos" />
                                                            Arquivos
                                                        </span>
                                                    }
                                                    className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Arquivos' ? 'buttom-modal-selected' : ''}`}
                                                    onClick={() => this.setState({ modalOpcaoSelecionada: 'Arquivos' })}
                                                />
                                            )}

                                            {(this.state.pedidoModalOpcoes.imagemPreviewUrl) && (
                                                <Button
                                                    label={
                                                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span className="icon-galeria" />
                                                            Imagens
                                                        </span>
                                                    }
                                                    className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Imagens' ? 'buttom-modal-selected' : ''}`}
                                                    onClick={() => this.setState({ modalOpcaoSelecionada: 'Imagens' })}
                                                />
                                            )}
                                        </div>
                                    )}


                                    {(() => {
                                        const { modalOpcaoSelecionada } = this.state;
                                        const classes = ['ModalActions'];

                                        if (modalOpcaoSelecionada === 'Laudo' || modalOpcaoSelecionada === 'Compartilhar') {
                                            classes.push('ModalActionsLaudo');
                                        }

                                        if (modalOpcaoSelecionada === 'Exames externos') {
                                            classes.push('ModalActionsExamesExternos');
                                        }

                                        if (modalOpcaoSelecionada === 'Compartilhar') {
                                            classes.push('compartilhar');
                                        }

                                        if (modalOpcaoSelecionada === 'Arquivos') {
                                            classes.push('arquivos');
                                        }

                                        return (
                                            <div className={classes.join(' ')}>
                                                <div>
                                                    {this.renderAcoesDaModal(this.state.pedidoModalOpcoes)}
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                            )}

                            {/* Área de conteúdo dinâmico */}
                            <div
                                className={`ModalVisualizador ${this.getClasseVisualizador()}`}
                                style={
                                    this.state.modalOpcaoSelecionada === "Viewer"
                                        ? { width: "98%", height: "85vh" }
                                        : {}
                                }
                            >
                                {this.renderConteudoModalGenerica()}
                            </div>

                        </div>
                    )}
                </Dialog>
            </div>
        );
    }
    //#endregion

}



export default ScreensHomeForm;